import {submitEscapeEntry,retryEscapeEntry,restoreEscapeEntry,hellEntryCard,submitHellEntry,retryHellEntry,restoreHellEntry,leaveHell} from '../escape-field.js';
import {basinCampAt,hellCampAt,hellFieldAt} from '../../world/escape-field.js';
import { enableWorldNotify, disableWorldNotify, refreshWorldNotify, setWorldNotifyKind } from '../world-notify.js';
import { consumeLifeStoneFromBag } from '../lifestone-use.js';
import { formatVisibleNumbers } from '../number-format.js';
import { pixelGlyphText } from '../../render/pixel-glyphs.js';
import { markScrollCues } from '../scrollcue.js';
import { toast } from '../toast.js';
/**
 * 우측 패널 오케스트레이터.
 *
 * 이 파일은 **어느 조각을 언제 그릴지**만 정한다. 화면 내용은 옆 모듈에 있다:
 *   inv.js  가방        shop.js  상인들      forge.js 대장간
 *   vault.js 창고       rank.js  랭킹        help.js  도움말      skills.js 스킬
 *   account.js 계정
 * 한 덩어리로 두면 상점 문구 하나 고치는 데 300줄을 스크롤하게 된다.
 */
import { S, $, supportGiftReady } from '../../core/state.js';
import { canAct, where } from '../../world/places.js';
import { nativeFieldGeometry } from '../../world/native-field.js';
import { send, nativeActionAllowed, on, prewarmFieldEntryAt } from '../../core/net.js';
import { armPendingWrite, checkPendingWrite, clearPendingWrite, pendingWrite, resolvePendingWrite, revisePendingWrite, savePendingWrite } from '../../core/pending-write.js';
import { NPCS, serviceNpcAt, settlementAt } from '../../world/map.js';
import { josa } from '../../world/josa.js';
// R166(C22) — 사람이 쓰는 확인은 도트 확인 창이 묻는다(관리 화면 adm* 은 운영 도구라 브라우저 창 그대로)
import { askConfirm, askText } from '../dialog.js';
import { openChatWith } from '../chat.js';
import * as inv from './inv.js';
import * as shop from './shop.js';
import * as forge from './forge.js';
import * as alchemy from './alchemy.js';
import * as vault from './vault.js';
import * as rank from './rank.js';
import * as dps from './dps.js';
import * as help from './help.js';
import * as skills from './skills.js';
import * as acc from './acc.js';
import * as race from './race.js';
import * as lottery from './lottery.js';
import * as blackjack from './blackjack.js';
import * as slot from './slot.js';
import * as tomb from './tomb.js';
import * as hall from './hall.js';
import * as trade from './trade.js';
import * as temple from './temple.js';
import * as teleport from './teleport.js';
import * as gamble from './gamble.js';
import * as goblin from './goblin.js';
import * as pets from './pets.js';
import * as dex from './dex.js';
import * as account from './account.js';
import * as board from './board.js';
import * as tower from './tower.js';
import * as guild from './guild.js';
import * as appearance from './appearance.js';
import * as realty from './realty.js';
import * as resident from './resident.js';
import * as person from './person.js';
import { partySection } from './party.js';
import { isResident, num, preservePanelPress } from './common.js';
import * as exchange from './exchange.js';
import * as chat from '../chat.js';
import * as nativeVillage from './native-village.js';
import * as legendarySmith from './legendary-smith.js';
import * as settings from './settings.js';
// Q276 — 메뉴 한 화면·행사·동료·세계 수명·소식(사용자 결정 2026-10-13 B안)
import * as menu from './menu.js';
import * as events from './events.js';
import * as companions from './companions.js';
import * as worldlife from './worldlife.js';
import * as newsPanel from './news-panel.js';
import { setForce } from '../../core/input.js';
import { setFxOff } from '../../core/fx-pref.js';
import { setGoalLineOff } from '../../core/goal-pref.js';
import { setHudFxOff } from '../../core/hud-fx-pref.js';
import { setFirstHint } from '../first-hint.js';
import { setFrameMeterOn } from '../../core/frame-pref.js';
import { adminApi, loadAdmin } from '../admin-door.js';
import { showTip, hideTip } from '../tip.js';
import { markNewsRead } from '../news.js';
import { syncMainBar } from '../main-bar.js';
import { enableNotify, disableNotify } from '../notify.js';
// ⚠ 자유 식별자로 두면 눌렀을 때 터진다 — 오늘 두 번 겪은 부류다
import { log, syncGoalLine, CRIME_TOWN_ONLY } from '../hud.js';
import { promptInstall } from '../install.js';
import { adsStatus, setGoogleAdSound, showInterstitial, showRewarded } from '../ads.js';
import { logoutGoogleDevice, mountGoogleAuthPanel, mountNaverAuthPanel } from '../auth.js';
import { setAmbientVolume, setMusicSwell, setMusicVolume, setSfxVolume, toggleSound } from '../../core/sound.js';
import { setTextSize } from '../readability.js';
import { setQualityPreference } from '../../render/quality.js';
import { guildMoneyAmount, guildMoneyChoose, guildMoneyAdd, guildMoneyMax, guildMoneySubmit, guildMoneyConfirm, guildMoneyCancel, guildMoneyRetry, guildEstateBuy } from '../guild-money.js';
import { guildShopChoose, guildShopConfirm, guildShopCancel, guildShopRetry, guildShopFilter, guildShopQuantity, guildItemMove } from '../guild-shop.js';
import { stopById } from '../../world/teleport.js';
import { travelRequest } from '../crossing-cue.js';   // C9(14.476) · Q281(14.568) — 텔레포터를 누른 순간 이동 표시 · 요청 번호로 답과 짝

/**
 * R209(레드팀 D2-7) — 콘솔 모듈(`adminview.js`)은 정적으로 가져오지 않는다 — 가져오면 모든 플레이어가 첫 화면에서
 * 운영자 전용 코드 약 510KB 를 받는다. 아래 `act.adm*` 는 전부 콘솔 화면 안의 버튼이 부르므로 불릴 때는 이미 실려 있어
 * 그대로(동기로) 부르고, 혹시 먼저 불리면 싣고 나서 부른다. 이름은 전과 같다 — 부르는 자리는 안 바뀐다.
 */
const adminCall = (name) => (...args) => {
  const m = adminApi();
  return m ? m[name](...args) : loadAdmin().then((mod) => mod[name](...args));
};
const redrawAdmin = adminCall('drawAdmin'), filterAdminRows = adminCall('filterAdminRows'), admPost = adminCall('admPost'),
  currentAirdropSubmission = adminCall('currentAirdropSubmission'),
  adminEstateAction = adminCall('adminEstateAction'), nativeMarketAction = adminCall('nativeMarketAction'),
  filterAdminControls = adminCall('filterAdminControls'), restoreAdminControl = adminCall('restoreAdminControl'),
  undoAdminControl = adminCall('undoAdminControl'), saveRealtyControl = adminCall('saveRealtyControl'),
  saveBlackjackControl = adminCall('saveBlackjackControl'), selectAdminTab = adminCall('selectAdminTab'),
  selectAdminCategory = adminCall('selectAdminCategory'), refreshAdminCategory = adminCall('refreshAdminCategory'),
  rereadAdmin = adminCall('rereadAdmin');

function adminAmountText(raw, min = 1) {
  const text = String(raw ?? '').trim(), n = Number(text);
  if (!/^\d+$/.test(text) || !Number.isSafeInteger(n) || n < min) {
    alert(`수량은 ${min}~${Number.MAX_SAFE_INTEGER.toLocaleString()}의 정확한 정수로 입력해 달라.`);
    return null;
  }
  return text;
}

/** `opts.strings` — 문자열 설정값(고르는 칸의 열쇠 — F5 세계 랭커 날개)도 그대로 싣는다(빈 문자열 = 「없음」도 값이다). 끄면 옛 동작 그대로
 * `opts.only`·`opts.skip`(정규식) — 한 설정을 두 절이 나눠 그릴 때 그 절의 칸만 보낸다(F38 — `fieldPoll` 의 격리 사냥터 자동 재기동 칸) */
function saveAdminConfig(cmd, prefix, scales = {}, opts = {}) {
  const cfg = S.adm[cmd]?.cfg; if (!cfg) return;
  const patch = {};
  for (const [key,value] of Object.entries(cfg)) {
    if ((opts.only && !opts.only.test(key)) || (opts.skip && opts.skip.test(key))) continue;
    const input = $('#' + prefix + key); if (!input) continue;
    if (typeof value === 'boolean') patch[key] = input.value === '1';
    else if (opts.strings && typeof value === 'string') patch[key] = input.value;
    else if (input.value.trim() && Number.isFinite(Number(input.value))) patch[key] = Number(input.value) / (scales[key] || 1);
  }
  return admPost({cmd, set:true, patch});
}

/**
 * R206(레드팀 D2-23) — 원주민 교환은 **보낼 수 있을 때만** 「확인하고 있다」로 바꾼다. 사냥터 소켓은 `nativeTrade` 를 받지 않아
 * 전에는 대기 상태로 바꾼 뒤 보내기가 조용히 버려졌고, 응답이 영영 없어 창의 버튼이 전부 사라졌다(마을로 돌아갈 때까지).
 * 보낸 뒤에도 10초 안에 답이 없으면(끊김 등) 대기를 풀고 다시 누를 수 있게 한다 — 서버 답이 오면 그 답이 이긴다.
 */
function nativeTradeOpen() {
  if (nativeActionAllowed('nativeTrade')) return true;
  toast('사냥터에서는 원주민과 교환할 수 없다 — 마을에서 가까이 만나 달라.', 'trade');
  render(true);
  return false;
}
let nativeTradeTimer = 0;
function nativeTradeWatch() {
  clearTimeout(nativeTradeTimer);
  const asked = S.nativeTrade;
  nativeTradeTimer = setTimeout(() => {
    if (S.nativeTrade !== asked || asked?.status !== 'loading') return;
    S.nativeTrade = { npcId: asked.npcId, status: 'idle', message: '응답이 오지 않았다. 잠시 뒤 다시 살펴봐 달라.' };
    if (S.panel === 'resident') render(true);
  }, 10000);
}

function finishLotteryPurchase(message, bad = false) {
  const q = S.lotteryPurchase;
  if (!q) return;
  S.lotteryPurchase = null;
  S.lotteryBusy = false;
  log(message || `🎟 복권 ${q.bought.toLocaleString()}게임 구매 완료${q.bought < q.total ? ` · 요청 ${q.total.toLocaleString()}게임` : ''}.`, bad ? 'bad' : undefined);
  send({ t: 'lotteryGet' });
  render(true);
}

function sendLotteryChunk() {
  const q = S.lotteryPurchase;
  if (!q || q.cancelled || q.remaining <= 0 || pendingWrite('lottery')) return;
  const chunkId = crypto.randomUUID();
  const command = {
    t: 'lotteryBuy', purchaseId: q.id, chunkId, requestId: chunkId,
    worldN: q.worldN, drawNo: q.drawNo, mode: q.mode, picks: q.picks,
    quantity: Math.min(q.batch, q.remaining), bulk: q.total > q.batch,
  };
  if (!savePendingWrite('lottery', command, { purchase: { ...q } })) {
    finishLotteryPurchase('복권 구매 요청을 보관하지 못했다. 새 구매는 보내지 않았다.', true);
    return;
  }
  if (send(command) !== true) {
    clearPendingWrite('lottery', chunkId);
    finishLotteryPurchase('복권 구매 요청을 보내지 못했다. 연결을 확인한 뒤 다시 시도해 달라.', true);
    return;
  }
  armPendingWrite('lottery', send);
}

export function recoverLotteryPurchase() {
  const row = pendingWrite('lottery');
  if (!row?.purchase || row.message.chunkId !== row.requestId) return;
  S.lotteryPurchase = { ...row.purchase };
  S.lotteryBusy = true;
  checkPendingWrite('lottery', send);
}

/** 서버가 원자 주문 하나를 확정한 뒤에만 다음 묶음을 보낸다. */
export function lotteryBuyAck(m) {
  const row = pendingWrite('lottery');
  if (!row || m.chunkId !== row.requestId || m.purchaseId !== row.message.purchaseId) return;
  if (m.state === 'confirmed' && (m.quantity !== row.message.quantity || m.drawNo !== row.message.drawNo)) {
    checkPendingWrite('lottery', send, true);
    return;
  }
  const outcome = resolvePendingWrite('lottery', m, send);
  if (outcome === 'ignore' || outcome === 'pending' || outcome === 'retrying') return;
  const q = S.lotteryPurchase?.id === row.purchase?.id ? S.lotteryPurchase : { ...row.purchase };
  S.lotteryPurchase = q;
  if (outcome !== 'confirmed') {
    finishLotteryPurchase(`복권 ${q.bought.toLocaleString()}게임 구매 뒤 ${outcome === 'rejected' ? '다음 묶음이 거절됐다' : '다음 묶음의 결과를 확정하지 못했다'}.`, true);
    return;
  }
  q.bought += row.message.quantity;
  q.remaining -= row.message.quantity;
  if (q.cancelled || q.remaining <= 0) { finishLotteryPurchase(); return; }
  sendLotteryChunk();
  render(true);
}

/**
 * Q276(사용자 결정 2026-10-13) — **늘 보이는 다섯 칸**(가방·스킬·지도·행사·메뉴) 중 지금 창이 어느 칸에 속하는지.
 * 가방·스킬·행사·메뉴 창은 자기 칸, 나머지 창(메뉴에서 연 창·마을 NPC 가 연 창)은 [메뉴] 칸에 불을 켠다 —
 * 지금 메뉴 안 어딘가에 있다는 것을 다섯 칸이 말한다. 전에는 창 위 탭 줄(13칸)이 같은 일을 했다.
 */
const BAR_PANELS = new Set(['inv', 'skills', 'events', 'menu']);
const barOf = (p) => (BAR_PANELS.has(p) ? p : 'menu');

/** `GR` — 패널 머리에는 지금 하는 일, 그 아래에는 지금 서 있는 곳을 따로 말한다. */
const PANEL_NAME = {
  tower: '시련의 탑',
  resident: '원주민 살펴보기',
  person: '이름표', party: '파티',
  nativeKing: '원주민 왕', nativeMarket: '성문 밖 매입소',
  legendarySmith: '전설의 대장장이',
  alchemy: '연금술사',
  inv: '가방', skills: '스킬', forge: '강화', shop: '상점', potion: '물약 상점', weapon: '무기 상점',
  armor: '방어구 상점', sell: '팔기', acc: '악세사리 상점', vault: '창고', trade: '거래',
  rank: '랭킹', dex: '도감', help: '도움말', race: '슬라임 경주', temple: '신전',
  teleport: '역참', gamble: '운장수', goblin: '고블린 상인', pets: '펫 상인', lottery: '복권 상점', blackjack: '블랙잭', slot: '슬롯머신', account: '계정', board: '마을 게시판', guild: '길드', appearance: '외형 변경',
  realty: '부동산', settings: '설정', hellgate: '지옥문', hall: '명예의 전당', dps: '초당 피해',
  // Q276 — 메뉴 한 화면·행사·동료·세계 수명·소식
  menu: '메뉴', events: '행사', companions: '동료', worldlife: '세계 수명', news: '소식',
};

/**
 * UNI-Q185 지옥문 창이 보는 자리 — 서버 입장·퇴장 판정과 같은 보급소 함수(화면 미러)로 잰다.
 * 좌표 판정표 D14 — 2.0 사냥터 소켓 위에서는 좌표가 사냥터 좌표라(넓힌 땅은 같은 숫자의 다른 곳) 보급소 함수로 묻지 않는다.
 * 보급소·지옥문 곁은 원천 땅이라(R110 `net.js` `originalFieldAt`) 사냥터 소켓 위에서는 문 곁이 아니고, 안쪽인지는 사냥터 이름으로 안다.
 */
function hellWhere(y) {
  const field = nativeFieldGeometry()?.fieldId;
  if (field) return { atGate: false, atExit: false, inside: field === 'surface:hell' };
  return { atGate: basinCampAt(y.x, y.y), atExit: hellCampAt(y.x, y.y), inside: hellFieldAt(y.x, y.y) };
}

/**
 * R220·R227(레드팀 P2-10 ①, DESIGN 14.417) — **파티 창.** 짧은 메뉴 동안(Lv10 전, R159 사용자 결정 A) 같은 날 처음 온
 * 친구 둘이 파티를 못 만들었다. Q276 부터 메뉴 › 사람 › 파티 한 곳(문턱 전에도 보인다)·도움말 「처음이라면 ⑦」·이름표 카드 안내가
 * 이 창을 연다. 그리기는 `party.js` `partySection` 한 벌이다. 파티 정보는 서버 `you.party` 가 준다.
 */
function partyPanel(ctx) {
  return partySection(ctx) || '<div class="sec"><h3>파티</h3><div class="muted">파티 정보를 받는 중이다.</div></div>';
}

/**
 * UNI-Q110 ② — 모바일 하단 시트.
 * 좁은 화면에서 패널은 아래에서 62% 높이로 올라온다(`#panel.sheet`). 머리를 끌어올리면 전체(`.full`),
 * 끌어내리면 접히거나(전체→반) 닫힌다(반→닫힘). 설정값(머리 윗부분)를 짧게 두드리면 반↔전체.
 * 마지막 높이는 세션 동안 기억한다 — 매번 반으로 돌아가면 긴 목록을 보던 사람이 손해 본다.
 * 본문 스크롤(#pbody)은 그대로고 끌기는 머리에서만 시작한다. PC 는 손대지 않는다.
 */
/**
 * UNI-Q110 ⑦ — 긴 목록 가상화(도감 부위별 격자·재료·랭킹 25줄·게시글 10건 덩어리 = `.lazy-sec`).
 * HTML 문자열은 전부 만들어 붙인 뒤(검사기와 스크롤 복원은 전체를 본다), **접힌 곳에서 두 화면 아래**의
 * 덩어리만 제목(h3)을 남기고 자식을 떼어 두고 높이 자리만 남긴다. 스크롤이 600px 안으로 오면 붙인다.
 * 인라인 onclick 은 노드에 붙어 있어 떼었다 붙여도 산다. IntersectionObserver 가 없으면 아무것도 안 한다.
 */
const lazyStash = new WeakMap();
let lazyIO = null, lazyUnhook = null;
function mountLazy(pbody) {
  if (typeof IntersectionObserver === 'undefined' || !pbody) return;
  lazyIO?.disconnect(); lazyIO = null; lazyUnhook?.(); lazyUnhook = null;
  const secs = [...pbody.querySelectorAll('.lazy-sec')];
  if (secs.length < 2) return;
  // ⚠ 스크롤 상자는 둘이다(아래 render 주석과 같은 이유) — PC 의 분할 화면은 `.scroller` 가, 한 장짜리·모바일은
  //    `#pbody` 가 스크롤한다. 실제로 넘치는 쪽을 고른다. 이름으로 고르면 PC 도감이 영영 안 풀린다(실측).
  const sc = [pbody.querySelector('.scroller'), pbody].find((e) => e && e.scrollHeight > e.clientHeight + 1) || pbody;
  const restore = (el) => {
    const frag = lazyStash.get(el);
    if (!frag) return;
    el.appendChild(frag); lazyStash.delete(el); el.style.minHeight = '';
  };
  const REACH = 600;
  lazyIO = new IntersectionObserver((entries) => {
    for (const en of entries) if (en.isIntersecting) { restore(en.target); lazyIO?.unobserve(en.target); }
  }, { root: sc, rootMargin: `${REACH}px 0px` });
  const scTop = sc.getBoundingClientRect().top;
  const pending = new Set();
  for (const el of secs) {
    if (el.getBoundingClientRect().top - scTop < sc.clientHeight * 2) continue;   // 처음 두 화면분은 그대로
    const height = el.offsetHeight;
    const frag = document.createDocumentFragment();
    for (const child of [...el.children]) if (child.tagName !== 'H3') frag.appendChild(child);
    if (!frag.childNodes.length) continue;
    lazyStash.set(el, frag); el.style.minHeight = `${height}px`;
    lazyIO.observe(el); pending.add(el);
  }
  if (!pending.size) return;
  // 관찰자가 늦게 우는 브라우저를 위한 스크롤 되풀이 — 같은 판정을 스크롤마다 한 번 더 한다.
  const onScroll = () => {
    const top = sc.getBoundingClientRect().top, ch = sc.clientHeight;
    for (const el of pending) {
      const r = el.getBoundingClientRect();
      if (r.bottom - top > -REACH && r.top - top < ch + REACH) { restore(el); lazyIO?.unobserve(el); pending.delete(el); }
    }
    if (!pending.size) lazyUnhook?.();
  };
  sc.addEventListener('scroll', onScroll, { passive: true });
  lazyUnhook = () => { sc.removeEventListener('scroll', onScroll); lazyUnhook = null; };
}

// 짧은 가로 폰은 오른쪽 패널을 써서 화면 중심의 캐릭터를 남긴다.
const SHEET_MEDIA = '(max-width:760px) and (max-aspect-ratio:119/100)';
let sheetFull = false, sheetWired = false;
function syncSheetSize(panel) {
  panel.classList.toggle('full', sheetFull);
  const size = $('#psize');
  if (size) {
    size.textContent = sheetFull ? '작게' : '크게';
    size.setAttribute('aria-expanded', String(sheetFull));
    size.setAttribute('aria-label', sheetFull ? '창 작게 보기' : '창 크게 보기');
  }
}
function openSheet() {
  const panel = $('#panel'); if (!panel) return;
  const mobile = typeof matchMedia === 'function' && matchMedia(SHEET_MEDIA).matches;
  if (panel.classList.contains('sheet') !== mobile) panel.style.height = '';
  panel.classList.toggle('sheet', mobile);
  syncSheetSize(panel);
  if (!mobile) panel.classList.remove('full');
  if (mobile && !sheetWired) { sheetWired = true; wireSheet(panel); }
}
// 패널을 연 채 폰을 돌려도 시트/측면 패널의 배선과 높이가 즉시 바뀐다.
addEventListener('resize', () => {
  if ($('#panel')?.classList.contains('on')) openSheet();
});
function wireSheet(panel) {
  const head = panel.querySelector('.panelhead'); if (!head) return;
  $('#psize')?.addEventListener('click', () => {
    sheetFull = !sheetFull;
    syncSheetSize(panel);
  });
  panel.addEventListener('focusin', (e) => {
    if (!panel.classList.contains('sheet') || !e.target.matches('input,textarea,select')) return;
    sheetFull = true;
    syncSheetSize(panel);
  });
  let startY = 0, startH = 0, pointerId = null, moved = false;
  const maxH = () => (window.visualViewport?.height ?? innerHeight) - 52
    - parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--barh')) - 6;
  head.addEventListener('pointerdown', (e) => {
    if (!panel.classList.contains('sheet') || e.target.closest('button')) return;
    pointerId = e.pointerId; startY = e.clientY; startH = panel.getBoundingClientRect().height; moved = false;
    head.setPointerCapture?.(pointerId);
  });
  head.addEventListener('pointermove', (e) => {
    if (pointerId === null || e.pointerId !== pointerId) return;
    const dy = e.clientY - startY;
    if (!moved && Math.abs(dy) < 8) return;
    moved = true;
    panel.classList.add('dragging');
    panel.style.height = `${Math.max(120, Math.min(maxH(), startH - dy))}px`;
  });
  const settle = (e) => {
    if (pointerId === null || (e && e.pointerId !== pointerId)) return;
    pointerId = null;
    panel.classList.remove('dragging');
    const h = panel.getBoundingClientRect().height, top = maxH();
    panel.style.height = '';
    if (!moved) {                       // 설정값 두드림: 반 ↔ 전체
      if (e && e.clientY - head.getBoundingClientRect().top < 18) sheetFull = !sheetFull;
    } else if (h > top * 0.8) sheetFull = true;
    else if (h < top * 0.62 * 0.55) { closePanel(); return; }
    else sheetFull = false;
    syncSheetSize(panel);
  };
  head.addEventListener('pointerup', settle);
  head.addEventListener('pointercancel', settle);
}

/**
 * R5(DESIGN 14.327) — 「의견」 탭(`boardList`)은 1.0에서도 마을·전초지 전용이다
 * (`town.ts` `townAction`의 `inTown`/`inOutpost` 위치 판정 — 정착지 밖에서는 이 판정에
 * 닿지도 못하고 "여기서는 안 된다. 마을이나 전초지로 가라." 를 듣는다). 네이티브 필드
 * (사냥터)는 그 "정착지 밖" 이라 `net.js` `NATIVE_SOURCE_READS` 에도 넣지 않았다(공지·
 * 현상금과 다른 결 — 그 둘은 1.0도 어디서나 된다). 그래서 사냥터에서 보내면 `net.js` 가
 * 조용히 버리고 `S.board`가 계속 null로 남아 "불러오는 중…" 이 영구히 뜬다(R5). 사냥터에서는
 * 아예 보내지 않고, 1.0이 실제로 돌려주는 문구를 그 자리에서 채운다.
 */
function requestBoardList() {
  if (nativeFieldGeometry()) {
    S.board = { posts: [], canModerate: false, error: '여기서는 안 된다. 마을이나 전초지에서 이용해 달라.' };
    return;
  }
  S.board = null; send({ t: 'boardList' });
}
/** R229 — 원주민 창을 열면(다른 원주민을 눌러도) 그 원주민과 나의 관계를 받는다. 몸 id 와 이름을 함께 보낸다(사냥터 원주민은 원천에 몸이 없다) */
function residentTarget() {
  const r = S.players.find((o) => o.id === S.residentId);
  if (!r) return null;
  S.residentRelAsked = { id: r.id, at: Date.now() };
  return { id: String(r.id), name: String(r.n || '') };
}
function requestResidentRel() {
  const r = residentTarget();
  if (r) send({ t: 'residentGet', ...r });
}
/** R232 — 「사고팔기」 탭도 의견 탭과 같은 마을 게시판 행위다(`TOWN_ACTIONS`). 사냥터에서는 보내지 않고 같은 문구를 채운다(R5). */
function requestTradeBoard() {
  if (nativeFieldGeometry()) {
    S.tradeBoard = { posts: [], canModerate: false, limits: null, error: '여기서는 안 된다. 마을에서 게시판을 이용해 달라.' };
    return;
  }
  S.tradeBoard = null; send({ t: 'boardTradeList' });
}
/** DESIGN 14.609 — 「사고팔기」 탭은 두 칸(거래소 · 팝니다·삽니다 글): 보고 있는 칸의 자료만 받는다 */
function requestTradeTab() {
  if (S.tradeView === 'posts') requestTradeBoard();
  else exchange.requestExchange(send);
}
/** 거래소 올리기 칸 — 권 수·값을 고치는 동안 안내 줄과 [올리기]만 고친다(서버 판정을 대신하지 않는 안내) */
function exchangeFormSync() {
  const f = S.exchangeForm, lim = S.exchange?.limits, y = S.you;
  if (!f || !y) return;
  const pct = Number.isSafeInteger(Number(lim?.taxPct)) ? Number(lim.taxPct) : null, min = Number(lim?.minPrice) || 1;
  const price = Math.floor(Number(f.price));
  const held = f.kind === 'book' ? Math.max(0, Math.floor(Number(y.inv?.junk?.[f.pick]) || 0)) : 1;
  const line = $('#exchnet'); if (line) line.innerHTML = exchange.exchangeNetLine(price, pct, min);
  const button = $('#exchpost');
  if (button) button.disabled = !f.pick || !Number.isSafeInteger(price) || price < min || !!S.exchangeBusy || lim?.on === 0
    || (f.kind === 'book' && (f.qty < 1 || f.qty > held));
}

/** A board write is pending only after the transport accepted it. Keep drafts until the server ACK. */
function sendBoardWrite(message, trade = false, commentId = null) {
  const kind = trade ? 'trade' : 'board';
  if (pendingWrite(kind)) { checkPendingWrite(kind, send, true); return false; }
  const worldN = S.world?.n;
  if (!Number.isSafeInteger(worldN) || worldN < 1) { log('세계 정보를 확인한 뒤 게시판을 이용해 달라.', 'bad'); return false; }
  const requestId = crypto.randomUUID();
  const command = { ...message, requestId, worldN };
  const action = { boardPost: 'post', boardReport: 'report', boardRemove: 'remove',
    boardComment: 'comment', boardCommentRemove: 'commentRemove', boardTradePost: 'tradePost', boardTradeRemove: 'tradeRemove' }[message.t];
  if (!savePendingWrite(kind, command, { action, commentId })) {
    log('게시판 요청을 보관하지 못했다. 다시 접속한 뒤 시도해 달라.', 'bad');
    return false;
  }
  if (send(command) !== true) {
    clearPendingWrite(kind, requestId);
    log('게시판에 보내지 못했다. 연결을 확인한 뒤 다시 눌러 달라.', 'bad');
    return false;
  }
  if (trade) S.tradeBusy = true;
  else { S.boardBusy = true; if (commentId !== null) S.commentPending = commentId; }
  armPendingWrite(kind, send);
  render(true);
  return true;
}

export function recoverBoardWrites() {
  for (const kind of ['board', 'trade']) {
    const row = pendingWrite(kind);
    if (!row) continue;
    if (kind === 'trade') {
      S.tradeBusy = true;
      if (row.action === 'tradePost' && !S.tradeDraft) S.tradeDraft = row.message.text || '';
    } else {
      S.boardBusy = true;
      if (row.action === 'post' && !S.boardDraft) S.boardDraft = row.message.text || '';
      if (row.action === 'comment') {
        S.commentPending = row.commentId || row.message.id;
        if (S.commentPending && !S.commentDraft[S.commentPending]) S.commentDraft[S.commentPending] = row.message.text || '';
      }
    }
    checkPendingWrite(kind, send);
  }
}

/** A receipt belongs to this character even after its socket or page is replaced. */
export function recoverTownWrites() {
  const rename = pendingWrite('rename');
  if (rename && S.renameBusy !== rename.requestId) {
    S.renameBusy = rename.requestId;
    S.renameNotice = '이름 변경 결과를 확인 중이다.';
    checkPendingWrite('rename', send);
  }
  const goblin = pendingWrite('goblin');
  if (goblin && S.goblinBusy !== goblin.requestId) {
    S.goblinBusy = goblin.requestId; checkPendingWrite('goblin', send);
  }
  const alchemy = pendingWrite('alchemy');
  if (alchemy && S.alchemyRequest !== alchemy.requestId) {
    S.alchemyRequest = alchemy.requestId;
    S.alchemyBusy = alchemy.kindName;
    S.alchemyAuto = alchemy.autoStopped ? null : alchemy.auto || null;
    checkPendingWrite('alchemy', send);
  }
}

export function renameAck(m) {
  const row = pendingWrite('rename');
  if (!row || m.requestId !== row.requestId) return;
  const outcome = resolvePendingWrite('rename', m, send);
  if (outcome === 'ignore') return;
  if (outcome === 'pending' || outcome === 'retrying') {
    S.renameBusy = row.requestId;
    S.renameNotice = '이름 변경 결과를 확인 중이다.';
  } else if (['confirmed', 'rejected', 'expired', 'conflict'].includes(outcome)) {
    S.renameBusy = null;
    S.renameNotice = outcome === 'confirmed'
      ? `닉네임을 ${m.name || row.message.name}로 바꿨다.`
      : m.message || '이름을 바꾸지 못했다. 이름과 보유 은화를 확인한 뒤 다시 시도해 달라.';
    log(S.renameNotice, outcome === 'confirmed' ? 'info' : 'bad');
  }
  if (S.panel) render(true);
}

/** DESIGN 14.609 — 거래소 세 쓰기의 결과(원천 소켓 · 게임 서버 관문 · 결과 확인 읽기가 같은 모양으로 보낸다) */
export function exchangeAck(m, sound) {
  exchange.onExchangeAck(m, send, () => { if (S.panel) render(true); }, sound);
}

export function goblinBuyAck(m) {
  const row = pendingWrite('goblin');
  if (!row || m.requestId !== row.requestId) return;
  const outcome = resolvePendingWrite('goblin', m, send);
  if (!['confirmed', 'rejected', 'expired', 'conflict'].includes(outcome)) return;
  S.goblinBusy = false;
  if (outcome !== 'confirmed') log('고블린 구매가 확정되지 않았다. 보유 수량을 확인해 달라.', 'bad');
  if (S.panel) render(true);
}

let rerolledGear = null;
const gearIdentity = (e) => {
  // applyReroll은 옛 rolled 미지정 장비에 1을 명시한다. 둘은 같은 굴림 장비다(고정 0은 구별).
  const item = { ...e, rolled: e.rolled ?? 1 };
  return JSON.stringify(Object.keys(item).filter((k) => k !== 'id').sort().map((k) => [k, item[k]]));
};
function reconcileGearWork(y) {
  const before = rerolledGear;
  if (!before) return;
  if (before.charId !== S.charId || before.worldN !== S.world?.n) { rerolledGear = null; return; }
  const equips = y.inv.equips || [];
  if (equips.some((e) => e.id === before.id)) return; // 확정 응답보다 몸 상태가 늦게 올 수 있다.
  const ids = new Set(equips.map((e) => e.id));
  const previous = new Set(before.ids);
  const removed = before.ids.filter((id) => !ids.has(id));
  const added = equips.filter((e) => !previous.has(e.id));
  const next = removed.length === 1 && removed[0] === before.id && added.length === 1
    && gearIdentity(added[0]) === before.identity ? added[0].id : null;
  rerolledGear = null;
  if (!next) {
    if (S.alchemySel === before.id) S.alchemySel = null;
    if (S.gearWorkId === before.id) S.gearWorkId = null;
    log('재추첨 결과는 확정됐다. 장비 목록이 함께 바뀌어 새 장비를 직접 골라야 한다.', 'info');
    return;
  }
  if (S.alchemySel === before.id) S.alchemySel = next;
  if (S.invSel === before.id) S.invSel = next;
  if (S.gearWorkId === before.id) S.gearWorkId = next;
  S.forgeSel = S.forgeSel.map((id) => id === before.id ? next : id);
}
/** 사라진 장비를 가리키는 선택과 다른 창으로 넘어간 선택을 내려놓는다(2026-10-25 잔상 신고). */
function settleSelections(y) {
  // 판 장비·맡긴 장비는 가방에서 사라진다. 고른 칸이 그 장비를 가리키면 빈 [닫기] 띠만 남는다.
  // 잡템 `j:`·소모품 `c:` 칸은 수량 0 에도 설명을 보여 주는 칸이라 건드리지 않는다. 가방을 보고 있을 때만 판정한다 —
  // 재추첨 확정은 새 장비보다 먼저 올 수 있어 다른 창에서는 기다린다.
  if (S.panel === 'inv' && S.invSel && !/^[jc]:/.test(S.invSel) && !(y.inv.equips || []).some((e) => e.id === S.invSel)) S.invSel = null;
  // 넘겨받은 창(창고)을 떠나면 넘긴 장비도 내려놓는다 — 다른 창 위에 옛 장비가 붙지 않게
  if (S.gearWorkId && S.panel !== S.gearWorkPanel) { S.gearWorkId = null; S.gearWorkPanel = null; }
}
export function alchemyActionAck(m) {
  const row = pendingWrite('alchemy');
  if (!row || m.requestId !== row.requestId) return;
  const outcome = resolvePendingWrite('alchemy', m, send);
  if (!['confirmed', 'rejected', 'expired', 'conflict'].includes(outcome)) return;
  const auto = row.autoStopped ? null : S.alchemyAuto;
  S.alchemyRequest = null;
  S.alchemyBusy = null;
  const next = typeof m?.auto?.id === 'string' ? m.auto.id : '';
  if (outcome === 'confirmed' && next && !row.autoStopped) {
    S.alchemySel = next; S.invSel = next;
  }
  if (outcome === 'confirmed' && row.rerollBefore && !next) {
    rerolledGear = { ...row.rerollBefore, charId: row.charId, worldN: row.message.worldN };
  }
  if (outcome === 'confirmed' && m?.auto?.continue && auto && next) {
    S.alchemyBusy = 'auto-next';
    setTimeout(() => {
      if (S.alchemyAuto !== auto || S.alchemyBusy !== 'auto-next' || S.alchemyRequest || pendingWrite('alchemy')) return;
      S.alchemyBusy = null;
      window.act.alchemyAction('auto', { t: 'alchemyAutoReroll', id: next, target: auto.target });
    }, 80);
  } else {
    S.alchemyAuto = null;
    if (outcome !== 'confirmed') log('연금 요청이 확정되지 않았다. 재료와 장비를 확인해 달라.', 'bad');
  }
  if (S.panel) render(true);
}

export function togglePanel(p, force) {
  hideTip(); // 화면을 갈아치우는데 옛 칸의 설명이 떠 있으면 그건 거짓말이 된다
  // 상점은 직전에 말을 건 NPC의 대사를 재사용하지 않는다. 그렇지 않으면
  // 조련사 바우를 보고 나온 뒤 모든 상점 상단에 바우의 문장이 남는다.
  if (p === 'shop') S.npcLine = null;
  if (S.panel === p && !force) { closePanel(); return; }
  S.panel = p;
  if(p==='teleport'){restoreEscapeEntry();send({t:'escapeFieldInfo'});}
  if(p==='hellgate'){restoreHellEntry();send({t:'hellFieldInfo'});}
  // 화면 위에 새 탐색층이 생기면 [자동] 위 작은 창은 즉시 물러난다. 클릭·단축키·
  // NPC·패널 내부 이동 중 어느 길로 들어와도 mobile.js 한 곳이 접근성 상태까지 닫는다.
  dispatchEvent(new CustomEvent('unige:panel-opened', { detail: p }));
  /**
   * **여는 순간에 읽은 것으로 친다.** 그리는 쪽(`news-panel.js`)에서 부르면
   * 검사기가 화면을 그려보기만 해도 읽은 것이 되고, 다시 그릴 때마다 또 쓴다.
   * 점도 여기서 같이 내린다 — 표시와 상태가 한 자리에 있어야 안 갈라진다. Q276 — 소식은 메뉴 › 시스템 › 소식 창이다.
   */
  if (p === 'news') { markNewsRead(); syncNewsBadge(); }
  $('#panel').classList.add('on');
  openSheet();
  // Q276 — 늘 보이는 다섯 칸 중 지금 창의 칸에 불을 켠다. 창 머리의 [‹ 메뉴]는 다섯 칸이 여는 창이 아닐 때만 보인다
  const bar = barOf(p);
  document.querySelectorAll('#mainbar button[data-m]').forEach((b) => b.classList.toggle('on', b.dataset.m === bar));
  const back = $('#pback'); if (back) back.hidden = BAR_PANELS.has(p);
  document.body.classList.add('panel-open');
  /**
   * **못 불러오면 그렇게 말한다.**
   *
   * 전에는 응답을 안 보고 `S.vault = j.vault` 를 넣었다. 실패하면 `undefined` 가
   * 들어가고, 두 화면 모두 `if (!S.vault)` → **"불러오는 중…" 에서 영원히 멈춘다.**
   * 기다리면 될 것처럼 보이지만 아무 일도 일어나지 않는다 — 이 세션에서 계속 나온
   * "조용한 실패" 의 또 다른 얼굴이다.
   */
  /**
   * R257(DESIGN 14.416) — 브라우저 영문(`Failed to fetch`·`Unexpected token '<'`)을 사람에게 보이지 않는다. 망 실패(TypeError)·HTML
   * 응답(SyntaxError)·서버 오류(5xx)는 한국어로 말하고, 원문은 콘솔에만 남긴다.
   */
  const load = (url, set, options) => fetch(url, options)
    .then((r) => { if (!r.ok) throw new Error(r.status >= 500 ? '서버가 잠시 답하지 못했다.' : '불러오지 못했다.'); return r.json(); })
    .then((j) => { set(j); S.loadErr = null; })
    .catch((e) => {
      if (e instanceof TypeError || e instanceof SyntaxError) console.warn('[unige] 패널 자료 오류', url, e);
      S.loadErr = e instanceof TypeError ? '서버에 연결하지 못했다. 연결을 확인해 달라.'
        : e instanceof SyntaxError ? '서버 응답을 읽지 못했다.' : (e.message || '연결에 실패했다.');
    })
    .finally(() => render(true));
  /**
   * **은화는 보관 위치가 아니라 계정의 결제 재원이다.**
   *
   * 예전에는 창고를 읽을 패널을 `SPENDS` 손 목록으로 골랐다. 역참·운장수를 그 목록에서
   * 빠뜨리자 서버는 지갑→창고 순으로 결제할 수 있는데 화면이 지갑만 보고 버튼을 막았다.
   * 다음 소비 화면이 생길 때마다 또 빠질 수 있는 구조였다.
   *
   * 패널 종류를 추측하지 않고 로그인 뒤 **어느 패널이든 처음 열 때** 계정 창고를 한 번
   * 받는다. 이후 서버가 창고를 건드리면 `vault`를 밀어주며, 창고 화면을 직접 열 때만
   * 최신값을 다시 읽는다. 화면이 잠시 늦어도 최종 결제 판정은 서버가 한다(common.js).
   */
  if (S.token && (!S.vault || p === 'vault')) {
    load('/api/vault', (j) => { S.vault = j.vault; }, {
      headers: { 'x-unige-token': S.token },
    });
  }
  // POWER-R1 — 검사 항목(레벨/전투력)에 맞는 표를 받는다. 검사 항목은 S.rankBy 가 든다
  if (p === 'rank') load('/api/rank' + (S.rankBy === 'power' ? '?by=power' : ''), (j) => { S.rank = j.rank; });
  if (p === 'tomb') load('/api/epitaphs', (j) => { S.epitaphs = j.epitaphs; });
  if (p === 'dex' && nativeFieldGeometry()) send({ t: 'dexGet' });
  // UNI-Q193 — 명예의 전당은 월드가 들고 있는 목록을 소켓으로 받는다(켬끔·보이는 세계 수는 서버 설정값)
  if (p === 'hall') { S.hall = null; send({ t: 'hallGet' }); }
  // UNI-Q161 — 표는 서버가 만든다(권위). 열 때마다 지금 갈래를 다시 받는다
  if (p === 'dps') { S.dpsBoard = null; send({ t: 'dpsBoard', scope: S.dpsScope }); }
  if (p === 'board') {
    // Q276 — 게시판의 탭은 의견·사고팔기 둘. 옛 탭 이름(공지·현상금·부동산·모의 공성전)이 남아 있으면 의견으로 연다
    if (!board.BOARD_TABS.includes(S.boardTab)) S.boardTab = 'board';
    requestBoardList();
    if (S.boardTab === 'trade') requestTradeTab();
    checkPendingWrite('board', send, true); checkPendingWrite('trade', send, true); checkPendingWrite('exchange', send, true);
  }
  // Q276 — [행사]: 고른 칸의 자료만 받는다(점이 켜진 칸이 있으면 그 칸부터)
  if (p === 'events') { S.eventTab = eventTabNext || events.eventTabOnOpen(S.you); eventTabNext = null; requestEventTab(S.eventTab); }
  if (p === 'worldlife') temple.requestRanks(() => render(true));
  if (p === 'resident') requestResidentRel();
  if (p === 'tower') { tower.refresh(); tower.rank(S.towerRankScope); checkPendingWrite('tower', send, true); }
  if (p === 'nativeMarket') { S.nativeMarket = null; send({ t: 'nativeMarketGet' }); }
  if (p === 'guild') { S.guild = null; S.nativeGuilds = null; S.nativeMembership = null; send({ t: 'guildGet' }); send({ t: 'nativeGuildGet' }); }
  // UNI-Q28 — 부동산 메뉴는 어디서든 열린다(서버 REALTY_ANYWHERE). 여는 순간 초대 점을 내린다.
  // Q276 — 매물(전에는 게시판 부동산 탭)도 이 창에서 본다 — 목록도 어디서나 읽힌다(REALTY_ANYWHERE_ACTIONS 의 realtyList)
  if (p === 'realty') {
    S.realtyHome = null; S.realty = null; S.realtyInviteDot = false;
    syncMenuDot();
    send({ t: 'realtyHome' }); send({ t: 'realtyList' });
  }
  if (p === 'lottery') { S.lottery = null; send({ t: 'lotteryGet' }); recoverLotteryPurchase(); }
  if (p === 'blackjack') { S.blackjack = null; send({ t: 'bjGet' }); }
  if (p === 'slot') { S.slot = null; send({ t: 'slotGet' }); checkPendingWrite('slot', send, true); }
  // 메뉴의 갬블과 상점의 갬블 탭은 같은 허브다. 잭팟은 슬롯의 공동 원장 읽기를 재사용한다.
  if (shop.gambleHubOpen()) {
    S.slot = null;
    S.fieldReadFail = { ...S.fieldReadFail, slotGet: null };
    if (S.you && where(S.you) === 'town') {
      const sent = send({ t: 'slotGet' });
      if (sent !== true) S.fieldReadFail.slotGet = sent === 'link_moving'
        ? '이동이 끝나면 다시 확인해 달라.' : '서버에 연결한 뒤 다시 확인해 달라.';
    }
  }
  if (p === 'temple') temple.requestRanks(() => render(true));
  render(true);
}

/**
 * Q276 — [행사]를 정한 칸으로 연다(공성전 한 줄·모의 공성전 모집 창의 [행사에서 보기]·현상금 「더 걸기」).
 * 칸을 정하지 않으면 고른 칸(점이 켜진 칸이 먼저)으로 연다.
 */
let eventTabNext = null;
export function openEvents(tab) {
  eventTabNext = events.EVENT_TABS.some((t) => t.id === tab) ? tab : null;
  togglePanel('events', true);
}
const bountyShown = () => S.panel === 'events' && S.eventTab === 'bounty';

function submitBounty(name, amount) {
  if (!name || !Number.isSafeInteger(amount) || amount <= 0 || !nativeActionAllowed('bountyPost')) return false;
  const previous = pendingWrite('bounty');
  if (previous) { S.bountyBusy = previous.requestId; checkPendingWrite('bounty', send, true); render(true); return false; }
  if (S.bountyBusy) return false;
  const worldN = S.world?.n;
  if (!Number.isSafeInteger(worldN) || worldN < 1) { log('세계 정보를 확인한 뒤 현상금을 걸어 달라.', 'bad'); return false; }
  const command = { t: 'bountyPost', name, amount, requestId: crypto.randomUUID(), worldN };
  if (!savePendingWrite('bounty', command)) {
    log('현상금 요청을 보관하지 못했다. 다시 접속한 뒤 시도해 달라.', 'bad'); return false;
  }
  S.bountyBusy = command.requestId;
  if (send(command) !== true) {
    clearPendingWrite('bounty', command.requestId);
    if (S.bountyBusy === command.requestId) S.bountyBusy = false;
    log('현상금 요청을 보내지 못했다. 연결을 확인한 뒤 다시 눌러 달라.', 'bad'); return false;
  }
  armPendingWrite('bounty', send);
  render(true);
  return true;
}

export function recoverBountyPost() {
  const row = pendingWrite('bounty');
  if (!row || S.bountyBusy === row.requestId) return;
  S.bountyBusy = row.requestId;
  if (!S.bountyDraft.name.trim()) S.bountyDraft.name = row.message.name;
  if (!String(S.bountyDraft.amount)) S.bountyDraft.amount = String(row.message.amount);
  checkPendingWrite('bounty', send);
}

export function bountyPostAck(m) {
  const row = pendingWrite('bounty');
  if (!row || m.requestId !== row.requestId) return;
  const outcome = resolvePendingWrite('bounty', m, send);
  if (!['confirmed', 'rejected', 'expired', 'conflict'].includes(outcome)) return;
  S.bountyBusy = false;
  if (outcome === 'confirmed') {
    if (S.bountyDraft.name.trim() === row.message.name && Number(S.bountyDraft.amount) === row.message.amount)
      S.bountyDraft = { name: '', amount: '' };
    send({ t: 'bountyList' });
  } else log('현상금 등록이 확정되지 않았다. 창고와 수배 목록을 확인해 달라.', 'bad');
  if (bountyShown()) render(true);
}

/** Q276 — [행사] 칸마다 받는 자료(전에는 게시판 탭·길드 탭·탑 창이 따로 받았다 — 보내는 요청은 같다) */
function requestEventTab(tab) {
  if (tab === 'siege') send({ t: 'siegeGet' });
  else if (tab === 'mockSiege') send({ t: 'mockSiegeGet' });
  else if (tab === 'tower') { tower.refresh(); tower.rank(S.towerRankScope); }
  else if (tab === 'bounty') send({ t: 'bountyList' });
  else if (tab === 'ann') send({ t: 'annList' });
}

/**
 * Q276 — 늘 보이는 칸의 점: [메뉴](거래 요청·파티 초대·부동산 초대·새 소식)와 [행사](모집 중인 모의 공성전·공성전·현상금·탑 보상).
 * 무엇인지는 눌러서 본다(팝업 금지 — 절대규칙 4). 상태를 받을 때마다(hud.js) 그리고 점의 원인이 바뀌는 회신 때 부른다(main-bar.js 한 곳).
 */
export const syncMenuDot = (y = S.you) => syncMainBar(y);

export function contributionRanksAck() { temple.ranksReceived(); }
// 툴팁은 `#game` 에 붙어 있어 패널이 닫혀도 남는다 — 키보드(i/Esc)로 닫으면
// `onmouseleave` 가 안 오므로 설명이 허공에 떠 있었다. 닫을 때 같이 지운다
/**
 * **안 읽은 소식이 있으면 점을 찍는다** — Q276 부터 [메뉴] 칸과 메뉴 화면의 「소식」 칸(전에는 도움말 탭).
 *
 * ⚠ 팝업으로 안 띄운다 — 절대규칙 4(*"튜토리얼 팝업을 추가하는 변경은 반려 대상"*).
 * 점은 **막지 않으면서 보인다.** 궁금한 사람만 누른다. `newsUnread` 는 메뉴 모듈의 점 표(`itemDots`)가 읽는다.
 */
export function syncNewsBadge() {
  menu.refreshNewsDot();
  syncMenuDot();
  if (S.panel === 'menu') render(true);
}

export function closePanel() {
  panelPress?.clear();
  hideTip();
  const panel = $('#panel');
  panel.classList.remove('on', 'sheet', 'full', 'dragging'); panel.style.height = '';   // UNI-Q110 ② 시트 상태 정리
  document.querySelectorAll('#mainbar button.on').forEach((b) => b.classList.remove('on'));   // Q276 — 다섯 칸의 불을 끈다
  document.body.classList.remove('panel-open');
  S.panel = null; lastSig = null; lastDrawn = null; lastHtml = null; lastMobileSelection = null;
  // 닫으면 고른 칸도 내려놓는다. 남겨 두면 다시 열 때·나갔다 들어올 때 옛 장비 화면이 그대로 떠 있다(2026-10-25 신고)
  S.invSel = null; S.gearWorkId = null; S.gearWorkPanel = null;
}

/**
 * 거래 상태가 바뀌면 **탭에 표시를 띄우고** 열려 있으면 다시 그린다 (14.43).
 *
 * 요청이 왔는데 알림이 없으면 그 요청은 없는 것과 같다 — 상대는 기다리고
 * 이쪽은 모른다. 우상단 스탯 창을 없앨 때 쓴 방법(가방 버튼의 배지)을 그대로 쓴다:
 * **새 덮개를 띄우지 않고 이미 있는 자리에 표시**한다.
 */
window.addEventListener('unige:trade', () => {
  syncMenuDot();   // Q276 — 거래 요청·파티 초대는 [메뉴] 칸의 점과 메뉴 화면의 「거래」·「파티」 칸 점으로 알린다
  if (S.panel) render(true);
});

/**
 * 다시 그릴 필요가 있는지 판별하는 서명.
 *
 * ★ 이게 없으면 패널이 **초당 10번 통째로 새로 그려진다.**
 *   그러면 사용자가 마우스를 누르고 떼는 사이에 버튼 엘리먼트가 교체되고,
 *   브라우저는 click 이벤트를 아예 발생시키지 않는다 — 버튼이 "안 먹히는" 것처럼 보인다.
 *   실제로 그 증상이 보고됐고, 코드에서 button.click() 을 동기로 부르는 테스트로는
 *   절대 재현되지 않는다. 사람의 손만 겪는 버그였다.
 */
function signature(y, at) {
  const eq = (y.inv.equips || [])
    .map((e) => `${e.id}:${e.plus}:${e.blessed}:${e.crude || 0}:${e.grade || 0}`).join(',');
  // 가방의 날개 카드는 남은 재사용 시간을 분 단위로 보여준다. 저장된 만료 시각만
  // 서명에 넣으면 시간이 흘러도 문자열이 같아서 패널이 영원히 옛 분 수를 표시한다.
  const wing = y.inv.wing ?? '';
  const wingCdMinute = wing
    ? Math.ceil(Math.max(0, ((y.inv.wingCd ?? {})[wing] ?? 0) - Date.now() / 1000) / 60)
    : 0;
  return [
    S.panel, at, S.shopTab, S.invView, y.silver, y.level, y.atk, y.def,
    S.panel === 'inv' ? JSON.stringify([y.name ?? '', y.renameCost ?? null, S.renameBusy ?? null, S.renameNotice ?? '',
      S.connected ? 1 : 0, S.ws?.readyState ?? 0, y.dead > 0 ? 1 : 0]) : '',
    // POWER-R1 — 전투력이 바뀌면(장비 교체 등) 착용 절이 다시 그려져야 한다
    y.power ?? 0,
    JSON.stringify(y.alignment ?? null),
    JSON.stringify(y.levelGrowth ?? null),
    JSON.stringify(y.inv.junk), JSON.stringify(y.inv.consum),
    eq, JSON.stringify(y.inv.equipped), wing, JSON.stringify(y.inv.wingCd ?? {}), wingCdMinute,
    S.forgeSel.join('|'), S.invSel ?? '', S.npcLine?.id ?? '', S.alchemySel ?? '', String(S.alchemyTarget ?? ''),
    y.acc ?? '', y.statFree ?? 0, y.skillFree ?? 0, JSON.stringify(y.stats ?? {}), y.cap ?? 0,
    S.vault ? JSON.stringify(S.vault) : '', S.rank ? S.rank.length : '',
    S.race ? `${S.race.id}:${S.race.phase}:${S.race.pool.join(',')}:${S.race.carry || 0}:${(S.race.wins || []).join(',')}:${Math.ceil(S.race.until)}` : '',
    S.panel === 'lottery' ? JSON.stringify(S.lottery ?? null) : '',
    // 블랙잭은 서버가 단계·손패가 바뀔 때만 민다. 판돈 배수 초안은 서명에 안 넣는다(입력 중 재렌더가 포커스를 끊는다)
    S.panel === 'blackjack' ? JSON.stringify(S.blackjack ?? null) : '',
    // UNI-Q184 슬롯 — 기금·결과·멈춘 칸 수·돌리는 중. 판돈 배수 초안은 안 넣는다(입력 중 재렌더가 포커스를 끊는다)
    S.panel === 'slot' ? JSON.stringify([S.slot ?? null, S.slotResult ?? null, S.slotStops ?? 0, !!S.slotBusy]) : '',
    S.panel === 'shop' && S.shopTab === 'gamble' ? JSON.stringify([S.slot?.fund ?? null, S.fieldReadFail?.slotGet ?? '', !!S.connected]) : '',
    // UNI-Q185 지옥문 — 안내 값과 보급소 안팎. 보급소 경계를 넘을 때만 다시 그린다(걷는 동안 매 틱 갈지 않는다)
    S.panel === 'hellgate' ? JSON.stringify([S.hellFieldInfo ?? null, hellWhere(y)]) : '',
    // 거래는 **상대가 움직여도** 바뀐다. 여기 안 넣으면 상대가 올린 것이 화면에 안 뜬다
    S.trade ? JSON.stringify(S.trade) : '', S.tradeAsk ? S.tradeAsk.id : '',
    // UNI-Q129 — 거래 탭의 파티 칸. 안 넣으면 떠나기·추방·수락 뒤에도 옛 파티원과 「파티 떠나기」가 그대로 남아
    // 「떠나기가 안 된다」로 보였다(사용자 실보고). 체력은 10% 단위·끊김 남은 초는 10초 단위만 넣는다 —
    // 전투 중 파티원 체력이 바뀔 때마다 다시 그리면 누르는 사이 버튼이 갈려 클릭이 사라진다(위 ★).
    (S.panel === 'trade' || S.panel === 'party') && y.party ? JSON.stringify([y.party.on, y.party.max, y.party.bonusPct, y.party.shareRadius, y.party.grace, y.party.leader, y.party.invite?.id ?? '',
      (y.party.members || []).map((m) => [m.id, m.name, m.level, m.online ? 1 : 0, m.location || (m.near ? 'near' : 'far'),
        m.hp == null ? null : Math.floor(m.hp / 10), Math.ceil((m.away || 0) / 10)])]) : '',
    S.panel === 'forge' && S.autoEnhance ? JSON.stringify(S.autoEnhance) : '',
    // Fortune/property and ad expiry change the actual attempt odds without changing the selected equipment.
    S.panel === 'forge' ? `${y.forgeLuck ?? ''}:${y.forgeBoost ?? ''}` : '',
    S.panel === 'inv' ? inv.expeditionStateKey(y) : '',
    (S.panel === 'inv' || S.panel === 'temple') ? JSON.stringify(y.soul ?? null) : '',
    // 안드로이드의 설치 기회는 **접속 뒤에 늦게** 온다(beforeinstallprompt).
    // 서명에 안 넣으면 도움말을 이미 열어둔 사람에게는 버튼이 끝내 안 나타난다.
    S.canInstall ? 1 : 0,
    S.busy ?? '',
    S.auth ? `${S.auth.ready ? 1 : 0}:${S.auth.enabled ? 1 : 0}:${S.auth.linked ? 1 : 0}:${S.auth.bad ? 1 : 0}:${S.auth.message}` : '',
    // 신전은 **세계 시각**을 보여준다. 서명에 안 넣으면 봉헌으로 시계가 늘어도
    // 화면이 옛 시각 그대로다 — 방금 바친 사람이 바뀐 것을 못 본다
    S.panel === 'temple' ? temple.stateKey() : '',
    // 도감/비석은 별도 서버 메시지다. 패널을 연 채 획득·봉헌하면 즉시 바뀌어야 한다.
    S.panel === 'dex' && S.dex ? JSON.stringify(S.dex) : '',
    // UNI-Q193 — 명예의 전당도 서버 회신(`hall`)으로만 바뀐다. 안 넣으면 받은 뒤에도 「불러오는 중」이 남는다
    S.panel === 'hall' ? JSON.stringify(S.hall ?? null) : '',
    // 랭킹 「내 기록」의 이번 세계 PK 처치 — 드문 사건이라 바뀔 때만 다시 그린다
    S.panel === 'rank' ? y.inv.pkKills ?? 0 : '',
    JSON.stringify(y.inv.passives ?? []),
    JSON.stringify(y.inv.imprints ?? []), y.inv.imprint ?? '',
    S.panel === 'skills' ? JSON.stringify(y.imprints ?? []) : '',
    // 스킬 화면은 강화·자동 설정·쿨을 보여준다. 자동값이 빠지면 서버와 스킬바는
    // 즉시 바뀌는데 카드만 옛 ON/OFF를 1초 넘게 말한다. 쿨은 초 단위만 반응시켜
    // 버튼을 10Hz로 갈아치우지 않는다 — 누르고 떼는 사이 DOM이 바뀌면 클릭이 사라진다.
    S.panel === 'skills'
      ? (y.skills || []).map((s) => `${s.id}:${s.rank}:${s.auto ? 1 : 0}:${Math.ceil(s.cd)}:${s.currentEffect || ""}:${s.nextEffect || ""}`).join(',') : '',
    // 입력 중인 길드명/소개 초안은 넣지 않는다. 10Hz 상태 수신이 textarea를 다시 만들면
    // 첫 글자 뒤 포커스가 끊긴다. 문양·색 선택은 해당 action이 명시적으로 render한다.
    S.panel === 'guild' ? `${S.guildView}:${JSON.stringify(S.guild ?? null)}` : '',
    /**
     * UNI-Q161 — 초당 피해 표와 **살아 있는 측정 창**. 서명에 안 넣으면 표를 받아도
     * 화면이 안 바뀌고 *"불러오는 중…"* 에서 멈춘다(이 레포가 반복해 데인 자리).
     */
    S.panel === 'dps' ? `${S.dpsScope}:${JSON.stringify(S.dpsBoard ?? null)}:${JSON.stringify(S.dpsLast ?? null)}` : '',
    y.dps ? `${y.dps.left}:${y.dps.total}` : '',
    S.panel === 'resident' ? resident.stateKey() : '',
    // R227 — 이름표 카드: 그 사람의 공개 표식·거리(타일 단위)·내 파티·거래 상태가 바뀔 때만 다시 그린다
    S.panel === 'person' ? person.stateKey() : '',
    // R220 — 파티 창의 초대 목록(보이는 사람)은 사람이 드나들 때 바뀐다
    S.panel === 'party' ? S.players.filter((o) => !o.d && !isResident(o)).map((o) => o.id).slice(0, 12).join(',') : '',
    // 부동산 메뉴는 서버 회신으로만 바뀐다. 임대 만료 카운트다운은 분 단위로만 다시 그린다.
    S.panel === 'realty' ? `${JSON.stringify(S.realtyHome ?? null)}:${Math.floor(Date.now() / 60000)}` : '',
    // UNI-Q173 — 가방에 저장되는 자동 설정. 버튼은 서버에 보내기만 하고 다시 그리지 않으므로, 여기 없으면
    // 누른 뒤에도 「켜짐 — 누르면 끈다」가 그대로 남았다(가방 물품·장비·능력 화면과 설정 화면 공통).
    // 켜고 끌 때만 바뀌는 값이라 틱마다 다시 그리지 않는다.
    JSON.stringify(y.inv.autoPot ?? null), y.inv.autoEquip !== false ? 1 : 0, y.inv.autoRetaliate === true ? 1 : 0,
    y.inv.autoStats === true ? 1 : 0, y.inv.autoBreakdownGrade ?? '',
    S.panel === 'settings' ? settings.stateKey(y) : '',
    // Q276 — 메뉴 한 화면(문턱·점)·행사(칸·점·칸 자료)·동료·세계 수명. 동료의 체력은 10% 단위만 넣는다(전투 중 버튼이 갈리지 않게)
    S.panel === 'menu' ? menu.stateKey(y) : '',
    S.panel === 'events' ? events.stateKey(y) : '',
    S.panel === 'companions' ? JSON.stringify([(y.bodyguard?.list || []).map((g) => [g.id, g.lv, g.kind, g.active ? 1 : 0, g.resting ? 1 : 0, g.down ? 1 : 0,
      Math.floor((Number(g.hp) || 0) / 10), g.revive ?? null, g.next?.shards ?? null, g.next?.silver ?? null]), y.bodyguard?.cap ?? 0, y.bodyguard?.enh ?? 0,
      y.pet?.active ?? null, y.pet?.activeDead ?? null, (y.pet?.owned || []).map((o) => [o.id, o.rank ?? 0, o.dead ? 1 : 0]), S.petRevivePending?.kind ?? null]) : '',
    S.panel === 'worldlife' ? worldlife.stateKey() : '',
  ].join('§');
}
let lastSig = null;
let panelPress = null;
let lastHtml = null;
/** 마지막으로 그린 화면 — 화면이 바뀌면 스크롤을 이어붙이지 않는다 */
let lastDrawn = null;
let lastMobileSelection = null;
let lastNavigationKey = null;

/** 공통 탐색의 갱신은 본문·입력·스크롤을 다시 만들지 않는다. */
function syncPanelNavigation(y) {
  const nav = $('#pnav'); if (!nav) return;
  const key = menu.navigationStateKey(y);
  if (key === lastNavigationKey) return;
  const activeId = document.activeElement?.closest?.('#pnav [data-menu-id]')?.dataset.menuId;
  const top = nav.scrollTop;
  nav.innerHTML = menu.renderNavigation({ y });
  lastNavigationKey = key;
  nav.scrollTop = top;
  if (activeId) {
    const button = [...nav.querySelectorAll('[data-menu-id]')].find((b) => b.dataset.menuId === activeId);
    button?.focus({ preventScroll: true });
  }
}

export function render(force) {
  const y = S.you; if (!y || !S.panel) return;
  panelPress ??= preservePanelPress($('#pbody'), () => render(true));
  if (S.panel !== lastDrawn) panelPress.clear();
  else if (panelPress.defer()) return;
  reconcileGearWork(y);
  S.forgeSel = S.forgeSel.filter((id) => (y.inv.equips || []).some((e) => e.id === id));
  settleSelections(y);
  const panel = $('#panel');
  panel.classList.toggle('menu-catalog', S.panel === 'menu');
  if (S.panel !== lastDrawn) panel.classList.remove('nav-open');
  const navToggle = $('#pnavtoggle');
  if (navToggle) {
    navToggle.hidden = S.panel === 'menu';
    navToggle.setAttribute('aria-expanded', String(panel.classList.contains('nav-open')));
  }
  syncPanelNavigation(y);
  /**
   * **자리를 불리언이 아니라 이름으로 넘긴다.**
   *
   * 전초지가 생기면서 "마을인가" 하나로는 답이 안 나온다 — 같은 자리에서
   * 파는 것은 되고 벼리는 것은 안 된다. `at` 을 넘기고 행위별로 `canAct` 에
   * 물어야 화면과 서버가 같은 답을 낸다.
   */
  const at = where(y);
  const town = at === 'town';
  const sig = signature(y, at);
  if (!force && sig === lastSig) return; // 바뀐 게 없으면 손대지 않는다
  lastSig = sig;

  const ctx = {
    y, at, town,
    petRevivePending: S.petRevivePending?.kind ?? null,
    eq: y.inv.equips || [],
    j: y.inv.junk || {},
    c: y.inv.consum || {},
  };
  /**
   * **제목이 자리를 말한다.** 전초지에 서 있는데 "마을 밖 — 가방과 도움말만" 이라고
   * 적혀 있으면 거짓말이다. 거기서는 팔고 사고 창고를 쓴다.
   */
  $('#ptitle').textContent = PANEL_NAME[S.panel] || '메뉴';
  // 정착지 밖 NPC 곁이면 그 사람의 이름을 말한다 — 「마을 밖」이라 적힌 채 역참이 열리면 거짓말이다(UNI-Q23)
  const serviceNpc = at === 'service' ? serviceNpcAt(y.x, y.y) : null;
  /**
   * R167(레드팀 C23) — 부제는 **여기서 못 하는 것만** 말한다. 전에는 「모든 생활 기능 사용 가능」·「전투·가방·스킬·계정 기능
   * 사용 가능」처럼 되는 것을 늘어놓아 매번 같은 줄이었고, 한 줄(말줄임)이라 폰에서는 정작 뒤의 안 되는 것이 잘렸다.
   * 다 되는 마을은 그 정착지 이름(`SETTLEMENTS.ko`)만 적는다. 버튼마다의 안 되는 이유는 `whyNot()` 이 따로 단다.
   */
  const settlement = at === 'town' ? settlementAt(y.x, y.y, 2) : null;
  $('#ploc').textContent = y.inv.towerRunId && ['active','cleared'].includes(S.tower?.run?.phase) ? '시련의 탑 · 마을 기능은 탑을 나간 뒤'
    : at === 'town' ? (settlement?.ko || '마을')
    : at === 'outpost' ? '전초지 · 강화 등 마을 시설은 없다'
    // 길드 영지(UNI-Q113) — 표는 GUILD_ESTATE_ACTIONS · 없는 것은 TOWN_ACTIONS 와의 차집합(경주·블랙잭·슬롯·신전·게시판·부동산…)
    : at === 'estate' ? '길드 영지 · 경주·신전·게시판 등은 공개 마을'
    : serviceNpc ? `${serviceNpc.name} 곁 · 상점·강화는 마을`
    : '마을 밖 · 상점·창고·강화는 마을';

  let h = '';
  switch (S.panel) {
    case 'resident': h = resident.render(ctx); break;
    case 'person': h = person.render(ctx); break;
    case 'party': h = partyPanel(ctx); break;
    case 'nativeKing': h = nativeVillage.king(ctx); break;
    case 'nativeMarket': h = nativeVillage.market(ctx); break;
    case 'inv': h = inv.render(ctx); break;
    case 'skills': h = skills.render(ctx); break;
    // 상점 칸은 **물건을 편다.** 악세는 자기 모듈이 그리므로 함수를 넘긴다 —
    // shop.js 가 acc.js 를 직접 부르면 두 화면이 서로를 알게 되고, 나중에
    // 분류를 하나 더 넣을 때 그 얽힘이 따라 늘어난다.
    case 'shop': h = shop.renderShop(ctx, acc.render); break;
    case 'potion': h = shop.renderPotion(ctx); break;
    case 'sell': h = shop.renderSell(ctx); break;
    case 'weapon': h = shop.renderGear({ ...ctx, slot: 'weapon' }); break;
    case 'armor': h = shop.renderGear({ ...ctx, slot: 'armor' }); break;
    case 'acc': h = acc.render(ctx); break;
    case 'race': h = race.render(ctx); break;
    case 'lottery': h = lottery.render(ctx); break;
    case 'slot': h = slot.render(ctx); break;
    case 'blackjack': h = blackjack.render(ctx); break;
    case 'tomb': h = tomb.render(ctx); break;
    case 'hall': h = hall.render(ctx); break;
    case 'forge': h = forge.render(ctx); break;
    case 'alchemy': h = alchemy.render(ctx); break;
    case 'legendarySmith': h = legendarySmith.render(ctx); break;
    case 'vault': h = vault.render(ctx); break;
    case 'rank': h = rank.render(ctx); break;
    case 'dps': h = dps.render(ctx); break;
    case 'help': h = help.render(ctx); break;
    case 'trade': h = trade.render(ctx); break;
    case 'temple': h = temple.render(ctx); break;
    case 'teleport': h = teleport.render(ctx); break;
    case 'hellgate': h = hellEntryCard(hellWhere(y)); break;
    case 'gamble': h = gamble.render(ctx); break;
    case 'goblin': h = goblin.render(ctx); break;
    case 'pets': h = pets.render(ctx); break;
    case 'dex': h = dex.render(ctx); break;
    case 'account': h = account.render(ctx); break;
    case 'board': h = board.render(ctx); break;
    case 'tower': h = tower.render(ctx); break;
    case 'guild': h = guild.render(ctx); break;
    case 'appearance': h = appearance.render(ctx); break;
    case 'realty': h = realty.render(ctx); break;
    case 'settings': h = settings.render(ctx); break;
    // Q276 — 메뉴 한 화면·행사·동료·세계 수명·소식
    case 'menu': h = menu.render(ctx); break;
    case 'events': h = events.render(ctx); break;
    case 'companions': h = companions.render(ctx); break;
    case 'worldlife': h = worldlife.render(ctx); break;
    case 'news': h = newsPanel.render(ctx); break;
  }
  /**
   * ── **누를 때마다 목록이 맨 위로 튀던 것** (사용자 신고) ──
   *
   * 스탯을 찍으면 화면이 위로 올라갔다. **여러 번 찍어야 하는 화면이라 찍을
   * 때마다 튀면 사실상 못 쓴다.**
   *
   * 원인은 스탯 화면이 아니라 **여기**다 — `innerHTML` 로 갈아 끼우면 자식이
   * 통째로 새로 만들어지고, 스크롤 위치는 **그 자식이 들고 있던 값**이라 0 이 된다.
   * 그래서 **버튼을 눌러 다시 그려지는 모든 목록**이 같은 증상을 갖는다:
   * 가방 · 강화 · 상점 · 창고 · 거래 · 랭킹 — 스탯만 고치면 나머지가 남는다.
   *
   * 한 자리에서 고친다. 갈아 끼우기 **직전에 스크롤을 재고 직후에 되돌린다.**
   *
   * ⚠ **화면이 바뀔 때는 되돌리지 않는다.** 가방에서 상점으로 옮겼는데 가방에서
   * 내려둔 만큼 내려가 있으면 그건 남의 자리다. 같은 화면일 때만 이어붙인다.
   *
   * ⚠ 스크롤 상자는 둘이다 — `#pbody` 자체(한 장짜리 화면)와 `.split .scroller`
   * (고른 것/분류·목록·하단 행동 띠). **둘 다 재야 한다.** 하나만 재면 `split` 을 쓰는
   * 세 화면(가방·강화·상점)에서 증상이 그대로 남는다.
   */
  const pbody = $('#pbody');
  // 강제 갱신도 같은 본문을 교체하지 않는다. 누르고 있는 버튼·입력·hover는 그대로 둔다.
  if (S.panel === lastDrawn && h === lastHtml) return;
  const keep = S.panel === lastDrawn
    ? { body: pbody.scrollTop, list: pbody.querySelector('.scroller')?.scrollTop || 0 }
    : null;
  lastDrawn = S.panel;
  lastHtml = h;

  // 입력 중인 칸은 다시 그린 뒤 포커스·커서를 돌려준다(길드 금액·부동산 초대 이름).
  const active = pbody.contains?.(document.activeElement) ? document.activeElement : null;
  const focusId = keep ? active?.id : null;
  const selection = active ? { start: active.selectionStart, end: active.selectionEnd } : null;
  const drafts = keep ? [...pbody.querySelectorAll('input[id],textarea[id],select[id]')].map((el) => ({
    id: el.id, value: el.value, initial: el.tagName === 'SELECT'
      ? [...el.options].filter((o) => o.defaultSelected).map((o) => o.value).join('|') : el.defaultValue,
    checked: el.checked, defaultChecked: el.defaultChecked,
  })) : [];
  // Q276 — 같은 창을 다시 그려도 사람이 펼친 [자세히]·접힌 안내는 펼친 채로 둔다(`data-fold` — common.js fold·lore)
  const opened = keep ? new Map([...pbody.querySelectorAll('details[data-fold],details[id]')]
    .map((d) => [d.dataset.fold || d.id, d.open])) : null;
  pbody.innerHTML = h;
  if (opened?.size) for (const d of pbody.querySelectorAll('details[data-fold],details[id]')) {
    const key = d.dataset.fold || d.id;
    if (d.dataset.forceOpen !== 'true' && opened.has(key)) d.open = opened.get(key);
  }
  for (const draft of drafts) {
    const el = document.getElementById(draft.id);
    if (!el || !pbody.contains(el)) continue;
    const initial = el.tagName === 'SELECT'
      ? [...el.options].filter((o) => o.defaultSelected).map((o) => o.value).join('|') : el.defaultValue;
    // 서버/행동이 새 초깃값을 준 칸은 그 값을 따른다. 사람이 쓰던 초안만 보존한다.
    if (initial === draft.initial) el.value = draft.value;
    if (el.defaultChecked === draft.defaultChecked && typeof draft.checked === 'boolean') el.checked = draft.checked;
  }
  formatVisibleNumbers(pbody);
  pixelGlyphText(pbody); // R169 — 표에 있는 이모지(💀·슬롯 릴 …)를 도트 글리프로
  mountLazy(pbody);
  if (focusId) {
    const input = $('#' + focusId);
    if (input && !input.disabled) {
      input.focus({ preventScroll: true });
      if (Number.isInteger(selection?.start) && typeof input.setSelectionRange === 'function') {
        try { input.setSelectionRange(selection.start, selection.end); } catch { /* number/select는 커서 범위가 없다. */ }
      }
    }
  }

  if (keep) {
    pbody.scrollTop = keep.body;
    const list = pbody.querySelector('.scroller');
    if (list) list.scrollTop = keep.list;
  }
  // 상자가 새 DOM 이라 스크롤 단서(data-scroll)도 새로 붙인다 — 위치 복원 뒤에 재야 맞는 값이다.
  markScrollCues(pbody);
  /**
   * 분류·목록·행동을 나누는 화면은 `#pbody` 자체가 세로 flex 여야
   * 아래 상자만 스크롤한다. `:has()` 로 고르면 안 되는 브라우저에서 **화면이
   * 통째로 무너지므로** 코드가 직접 붙인다.
   */
  /**
   * ⚠ **문자열로 맞추지 않는다.** 처음엔 `h.startsWith('<div class="split"')` 로
   * 봤는데, 그건 `common.js` 의 마크업과 이 파일이 **글자로 묶인 것**이라
   * `split()` 이 클래스를 하나만 더 붙여도 **레이아웃이 조용히 안 먹는다**
   * (에러도 안 난다 — 그냥 스크롤이 이상해질 뿐이다).
   * 이미 붙인 DOM 을 보면 그 이음매가 없어진다.
   */
  $('#pbody').classList.toggle('hassplit',
    !!$('#pbody').firstElementChild?.classList.contains('split'));
  // 모바일은 한 본문이므로 새로 고른 장비의 행동 영역으로 이동한다.
  // 같은 선택의 서버 갱신은 읽던 위치를 움직이지 않는다.
  const mobileSelection = JSON.stringify([S.panel, S.invSel, S.forgeSel, S.alchemySel]);
  if (window.matchMedia?.('(max-width:760px), (max-width:1000px) and (max-height:520px)')?.matches
    && lastMobileSelection !== mobileSelection) {
    const action = pbody.querySelector('.split > .act');
    if (action) pbody.scrollTop += action.getBoundingClientRect().top - pbody.getBoundingClientRect().top;
    else pbody.scrollTop = 0;
  }
  lastMobileSelection = mobileSelection;
  // GIS 버튼은 문자열 마크업이 아니라 Google 공식 코드가 실제 DOM에 그린다.
  // 패널을 다시 그릴 때 컨테이너도 새로 생기므로 innerHTML 뒤마다 다시 붙인다.
  if (S.panel === 'account') { void mountGoogleAuthPanel(); void mountNaverAuthPanel(); }
  // 아이콘 격자는 위임으로 받는다 — 칸마다 onclick 을 박으면 문자열이 감당이 안 된다
  const body = $('#pbody');
  // 툴팁 — 칸 위에 올리면 설명이 뜬다. title 속성은 느리고 모바일에서 안 뜬다.
  /**
   * ⚠ **대장간 칸(`f:`)에는 툴팁을 안 띄운다 — 일부러다.**
   *
   * 대장간은 누르면 **하단 행동 띠에 그 자루의 전부**가 뜬다(이름·안전수치·비용·
   * 버튼). 그 위에 툴팁까지 겹치면 같은 것을 두 번 말하는 셈이고, 하필 손가락
   * 아래에서 뜬다. 확인해보니 `f:` 키는 툴팁이 조용히 빈 채로 숨어 있었는데,
   * **우연히 안전한 것과 그렇게 하기로 한 것은 다르다** — 다음 사람이 tip.js 를
   * 고치다 이 자리를 되살릴 수 있어서 조건을 눈에 보이게 적는다.
   */
  body.onmousemove = (ev) => {
    const c = ev.target.closest('.cell[data-k]');
    if (c && !c.dataset.k.startsWith('f:')) showTip(c.dataset.k, ev.clientX, ev.clientY);
    else hideTip();
  };
  body.onmouseleave = hideTip;
  /**
   * **툴팁이 모바일에서는 한 번도 뜨지 않았다.**
   *
   * `tip.js` 는 자기 첫 줄에 "`title` 속성은 모바일에서 아예 안 뜬다. 직접 그린다"
   * 라고 적어놓고, 정작 호출은 `onmousemove` 하나뿐이었다 — 터치에는 hover 가
   * 없으므로 **폰에서는 아무 설명도 볼 수 없었다.** 강화석·축복받은 강화석이
   * 무엇인지 알 방법이 화면 어디에도 없다는 뜻이다.
   * 터치에서는 **탭이 곧 "이게 뭔지 보여달라"** 다.
   */
  body.onclick = (ev) => {
    const cellEl = ev.target.closest('.cell[data-k]');
    if (!cellEl) { hideTip(); return; }
    const k = cellEl.dataset.k;
    window.act.pick(k);
    // 가방은 고른 칸의 상세·버튼을 아래 띠에 이미 편다. 손가락 자리에 같은 설명을 또 띄우면 그 띠의
    // [팔기]·[보관] 버튼을 덮는다(2026-10-25 로컬 390폭 실측). 말풍선은 띠가 없는 화면의 탭에만 쓴다.
    if (S.invSel === k && S.panel !== 'inv') showTip(k, ev.clientX, ev.clientY); else hideTip();
  };
}

/**
 * R257(DESIGN 14.416) — 사냥터 조회 다리가 실패하면 그 종류의 답은 오지 않는다. 열린 패널을 곧바로 다시 그려 「불러오는 중」 대신
 * 이유와 [다시 불러오기]를 보인다(`common.js` `loadingOr`). 닫혀 있으면 다음에 열 때 다시 보낸다.
 */
on('fieldReadFail', () => { if (S.panel) render(true); });

// 패널 버튼이 부르는 동작들
let forgeConfirm = null, renameConfirm = null;
window.act = {
  admTowerSave: () => saveAdminConfig('towerConfig','admtower'),
  // UNI-Q186 공성전 콘솔 — 설정 저장 · 예정/진행 판 무효(선포 비용 반환) · 준비 시간 건너뛰기(시험)
  admSiegeSave: () => saveAdminConfig('siegeConfig','admsiege'),
  admSiegeCancel: () => { if (confirm('예정·진행 중인 공성전을 무효로 닫을까? 보상·건물 벌 없이 끝나고 선포 비용은 길드 금고로 돌아간다.')) admPost({ cmd: 'siegeConfig', action: 'cancel' }); },
  admSiegeForceClose: () => { if (confirm('정산이 멈춘 공성전을 닫을까? 이미 나간 보상·적용된 건물 벌은 그대로 두고, 안 된 것은 하지 않는다. 선포 비용은 돌려주지 않는다.')) admPost({ cmd: 'siegeConfig', action: 'forceClose' }); },
  admSiegeStartNow: () => { if (confirm('준비 시간을 건너뛰고 지금 공성전을 시작할까? 신청한 사람과 NPC 가 곧바로 전장으로 옮겨진다.')) admPost({ cmd: 'siegeConfig', action: 'startNow' }); },

  // UNI-Q236 모의 공성전 콘솔 — 설정 저장 · 진행 중인 판 무효(신청은 돈을 안 건드리니 반환할 것도 없다) · 신청 창 건너뛰기(시험)
  admMockSiegeSave: () => saveAdminConfig('mockSiegeConfig','admmocksiege'),
  admMockSiegeCancel: () => { if (confirm('신청·진행 중인 모의 공성전을 무효로 닫을까? 상금 없이 끝난다.')) admPost({ cmd: 'mockSiegeConfig', action: 'cancel' }); },
  admMockSiegeCloseNow: () => { if (confirm('신청 창을 지금 닫고 판정할까? 지금까지 신청한 인원으로 정족수를 확인한다.')) admPost({ cmd: 'mockSiegeConfig', action: 'closeNow' }); },
  // UNI-Q236 모의 공성전 — 마을 게시판 「모의 공성전」 탭의 참가 신청/취소
  mockSiegeJoin: () => send({ t: 'mockSiegeJoin' }),
  mockSiegeLeave: () => send({ t: 'mockSiegeLeave' }),
  // N5(2026-09-26) — 유저라면 누구나 모집을 연다(게시판 탭 버튼 · 참여 팝업 [참여] 버튼이 공유)
  mockSiegeOpen: () => send({ t: 'mockSiegeOpen' }),

  // UNI-Q194 원주민 라이벌 알림 콘솔
  admRivalSave: () => saveAdminConfig('rivalConfig','admrival'),
  admFirstStepsSave: () => saveAdminConfig('firstStepsConfig','admfs'),
  admDailyGoalsSave: () => saveAdminConfig('dailyGoalsConfig','admdg'),
  admGrowthFlowSave: () => saveAdminConfig('growthFlowConfig','admgf'), // 묶음 Y(14.429)
  admRespawnTierSave: () => saveAdminConfig('respawnTierConfig','admrt'), // 14.526 등급별 리스폰
  admRaidRoamerSave: () => saveAdminConfig('raidRoamerConfig','admraid'), // F23(14.530) 급습 몬스터
  admPetSave: () => saveAdminConfig('petConfig','admpet'),
  admPartySave: () => saveAdminConfig('partyConfig','admparty'),
  admChatSave: () => saveAdminConfig('chatConfig','admchat'), // R230
  admTradeBoardSave: () => saveAdminConfig('tradeBoardConfig','admtrade'), // R232
  admExchangeSave: () => saveAdminConfig('exchangeConfig','admexch'), // DESIGN 14.609
  // UNI-Q192 — 경비병 반격·속죄 기부·보디가드
  admBodyguardSave: () => saveAdminConfig('bodyguardConfig','admbg'),
  /** F24(14.531) — 접속 중인 사람의 보디가드 한 명의 강화 단계(절대값 0~10). 돈·조각은 안 오가고 편집 기록이 남는다 */
  admBodyguardLevel: (name, id, inputId) => {
    const lv = Math.floor(Number($('#' + inputId)?.value));
    if (!name || !id || !Number.isInteger(lv) || lv < 0 || lv > 10) { toast('강화 단계는 0~10 정수여야 한다.', 'bad'); return; }
    if (!confirm(`${name} — 보디가드 ${id} 강화 단계 저장: +${lv} (돈·조각은 안 오간다). 맞나?`)) return;
    // 응답은 글 한 줄이다 — 표가 고친 값을 보이도록 설정 절을 다시 읽는다
    Promise.resolve(admPost({ cmd: 'bodyguardLevel', name, id, lv })).then(() => admPost({ cmd: 'bodyguardConfig' }));
  },
  admHitFeelSave: () => saveAdminConfig('hitFeelConfig','admhitfeel'),
  admBossEntranceSave: () => saveAdminConfig('bossEntranceConfig','admbossfx'),
  admHudFxSave: () => saveAdminConfig('hudFxConfig','admhudfx'),
  admMaterialSave: () => saveAdminConfig('materialConfig','admmaterial'),
  admAtmosphereSave: () => saveAdminConfig('atmosphereConfig','admatmo'),
  admIsoViewSave: () => saveAdminConfig('isoViewConfig','admiso'),
  admQualitySave: () => saveAdminConfig('qualityConfig','admquality'),
  admRoyalSave: () => saveAdminConfig('royalTax','admroyal'),
  // UNI-Q184 슬롯머신 콘솔
  admSlotGet: () => admPost({ cmd: 'slotMachine' }),
  admSlotSave: () => saveAdminConfig('slotMachine', 'admslot'),
  admLairGimmickSave: () => saveAdminConfig('lairGimmick','admlairg'),
  towerOpen: () => openEvents('tower'),   // Q276 — 시련의 탑 안내·순위는 [행사] › 시련의 탑(탑 앞 안내인은 여전히 탑 창을 연다)
  /**
   * R257(DESIGN 14.416) — 사냥터 조회 다리가 실패한 패널의 [다시 불러오기](`common.js` `loadingOr`). 그 종류를 그대로 다시 보낸다
   * (갈래가 있는 표는 지금 보는 갈래로). 보내는 순간 net.js 가 실패 표시를 지워 「불러오는 중」으로 돌아간다.
   */
  fieldRead: (t) => {
    if (t === 'dpsBoard') send({ t, scope: S.dpsScope });
    else if (t === 'towerRank') tower.rank(S.towerRankScope);
    else if (typeof t === 'string' && /^[a-zA-Z]{1,32}$/.test(t)) send({ t });
    render(true);
  },
  // UNI-Q193 — 명예의 전당(Q276 — 메뉴 › 세계 › 명예의 전당 한 곳. 읽기 실패의 [다시 불러오기]도 이것을 부른다)
  hallOpen: () => togglePanel('hall', true),
  dexRefresh: () => { if (nativeFieldGeometry()) { S.dex = null; send({ t: 'dexGet' }); render(true); } },
  /**
   * F5(DESIGN 14.511) — 회차별 공개 주소(`/hall/{세계}`) 「공유」: 모바일 공유 시트가 있으면 그것으로(취소는 조용히), 없으면 주소를 복사한다.
   * 「주소 복사」는 늘 복사한다. 복사도 못 하면(권한·옛 브라우저) 주소를 알림에 그대로 띄워 손으로 옮기게 한다.
   */
  hallShare: (world) => {
    const url = hall.hallShareUrl(world);
    if (typeof navigator !== 'undefined' && typeof navigator.share === 'function') {
      navigator.share({ title: `유니지 제 ${world} 세계 명예의 전당`, text: `제 ${world} 세계 명예의 전당 — 세계 랭커와 기록`, url })
        .catch((e) => { if (e?.name !== 'AbortError') window.act.hallCopy(world); });
      return;
    }
    window.act.hallCopy(world);
  },
  hallCopy: (world) => {
    const url = hall.hallShareUrl(world);
    const done = () => toast(`제 ${world} 세계 명예의 전당 주소를 복사했다 — ${url}`, 'good');
    const fail = () => toast(`주소를 복사하지 못했다 — ${url}`, 'bad');
    try { navigator.clipboard.writeText(url).then(done, fail); } catch { fail(); }
  },
  /** UNI-Q161 초당 피해 — 갈래를 바꾸면 **서버에서 그 갈래를 다시 받는다** */
  dpsScope: (v) => {
    const next = v === 'all' ? 'all' : 'world';
    if (S.dpsScope === next) return;
    S.dpsScope = next; S.dpsBoard = null;
    send({ t: 'dpsBoard', scope: next });
    togglePanel('dps', true);
  },
  /** 랭킹 패널에서 초당 피해로 건너간다(명예의 전당과 같은 결) */
  dpsPanel: () => togglePanel('dps', true),
  dpsBack: () => togglePanel('rank', true),
  towerRefresh: () => { tower.refresh(); checkPendingWrite('tower', send, true); },
  towerEnter: () => tower.request('towerEnter',render),
  towerNext: () => tower.request('towerNext',render),
  towerReturn: () => tower.request('towerReturn',render),
  towerAbandon: () => tower.request('towerAbandon',render),
  towerClaim: (i) => tower.request('towerClaim',render,i),
  towerClaimAll: () => tower.request('towerClaim',render,'all'),
  towerFight: () => closePanel(),
  towerBag: () => togglePanel('inv',true),
  towerRankWeek: () => {tower.rank('week');render(true);},
  towerRankWorld: () => {tower.rank('world');render(true);},
  towerRankAll: () => {tower.rank('all');render(true);},
  // 10-21 운영 신고 「왕도 매입상에게 왜 물약은 판매가 안되지?」 — 물약은 가방의 `consum` 에 있는데 잡템(`junk`)만 세서
  //   판매 버튼이 아무것도 보내지 않았다. 서버가 준 판매 줄(rows — consum·junk·벗은 장비)의 수량을 그대로 쓴다.
  nativeMarketSell: (item) => {
    const row = S.nativeMarket?.rows?.find((r) => r.key === item);
    const inv = S.you?.inv || {};
    const have = row?.equip ? 1 : Number(inv.consum?.[item] ?? inv.junk?.[item] ?? row?.qty ?? 0);
    if (have > 0) send({ t: 'nativeMarketSell', item, qty: Math.floor(have) });
    else toast('판매할 수량이 없다.', 'bad');
  },
  nativeKingAudience: () => send({ t: 'nativeKingAudience' }),
  nativeTradeQuote: () => {
    if (!nativeTradeOpen()) return;
    S.nativeTrade={npcId:S.residentId,status:'loading'}; send({t:'nativeTrade',action:'quote',npcId:S.residentId}); nativeTradeWatch(); render(true);
  },
  nativeGiftQuote: () => {
    const item = String($('#nativegiftitem')?.value || ''), quantity = Math.floor(Number($('#nativegiftqty')?.value || 0));
    if (!item || !Number.isSafeInteger(quantity) || quantity < 1) return;
    if (!nativeTradeOpen()) return;
    S.nativeTrade={npcId:S.residentId,status:'loading'};
    send({t:'nativeTrade',action:'giftQuote',npcId:S.residentId,item,quantity}); nativeTradeWatch(); render(true);
  },
  nativeTradeAccept: () => { const o=S.nativeTrade?.offer;if(!o||S.nativeTrade.status!=='offered')return;if(!nativeTradeOpen())return;S.nativeTrade.status='pending';send({t:'nativeTrade',action:'accept',id:o.id,npcId:S.residentId});render(true); },
  nativeTradeCancel: () => { const o=S.nativeTrade?.offer;if(!o||S.nativeTrade.status!=='offered')return;send({t:'nativeTrade',action:'cancel',id:o.id});S.nativeTrade={npcId:S.residentId,status:'cancelled'};render(true); },
  boardDraft: (v) => {
    S.boardDraft = String(v || '').slice(0, 280);
    const count = $('#boardcount'); if (count) count.textContent = `${S.boardDraft.length}/280자 · 계정당 30초에 1개, 하루 10개`;
    const button = $('#boardpost'); if (button) button.disabled = !S.boardDraft.trim() || S.boardBusy;
  },
  boardRefresh: () => { requestBoardList(); render(true); },
  boardRecheck: () => { checkPendingWrite('board', send, true); render(true); },
  boardPost: () => {
    const text = S.boardDraft.trim();
    if (!text || S.boardBusy) return;
    sendBoardWrite({ t: 'boardPost', text });
  },
  boardReport: (id) => {
    if (S.boardBusy) return;
    askConfirm('운영자에게 이 글을 신고할까? 신고 수만으로 자동 삭제되지는 않는다.', () => {
      if (S.boardBusy) return;
      sendBoardWrite({ t: 'boardReport', id });
    }, { ok: '신고한다' });
  },
  boardRemove: (id, moderate) => {
    if (S.boardBusy) return;
    askConfirm(moderate ? '운영 검토로 이 글을 내릴까? 기록은 감사용으로 남는다.' : '내 글을 게시판에서 내릴까?', () => {
      if (S.boardBusy) return;
      sendBoardWrite({ t: 'boardRemove', id });
    }, { ok: '내린다', danger: true });
  },
  // R229 — 원주민 「인사하기」(LLM 없는 정해진 인사 · 판정·대기 초는 서버) · 관계를 못 받았을 때 다시 받기
  residentGreet: () => { const r = residentTarget(); if (r) send({ t: 'residentGreet', ...r }); render(true); },
  residentRelRetry: () => { requestResidentRel(); render(true); },
  // R232 — 사고팔기 글. 한도는 서버 limits 로만 센다(여기 숫자를 적지 않는다)
  tradeSide: (side) => { S.tradeSide = side === 'buy' ? 'buy' : 'sell'; render(true); },
  tradeDraft: (v) => {
    const max = Number(S.tradeBoard?.limits?.maxLen) || 280;
    S.tradeDraft = String(v || '').slice(0, max);
    const count = $('#tradecount'); if (count) count.textContent = `${S.tradeDraft.length}/${max}자`;
    const button = $('#tradepost'); if (button) button.disabled = !S.tradeDraft.trim() || S.tradeBusy || S.tradeBoard?.limits?.on === 0;
  },
  tradeRefresh: () => { requestTradeBoard(); render(true); },
  tradeRecheck: () => { checkPendingWrite('trade', send, true); render(true); },
  tradePost: () => {
    const text = S.tradeDraft.trim();
    if (!text || S.tradeBusy) return;
    sendBoardWrite({ t: 'boardTradePost', side: S.tradeSide, text }, true);
  },
  tradeRemove: (id, moderate) => {
    if (S.tradeBusy) return;
    askConfirm(moderate ? '운영 검토로 이 사고팔기 글을 내릴까? 기록은 감사용으로 남는다.' : '내 사고팔기 글을 내릴까?', () => {
      if (S.tradeBusy) return;
      sendBoardWrite({ t: 'boardTradeRemove', id }, true);
    }, { ok: '내린다', danger: true });
  },
  // 글쓴이에게 귓말(R230) — 채팅칸을 「/w 이름 」으로 채워 연다. 보내는 것은 사람이 이어 쓰고 Enter
  tradeWhisper: (name) => {
    const who = String(name || '').trim();
    if (!who) return;
    closePanel();
    openChatWith(`/w ${who} `);
  },
  // 댓글 — 글별 초안(전체 재렌더는 피하고 그 글 버튼만 갱신해 입력 포커스 보존).
  commentDraft: (id, v) => {
    S.commentDraft[id] = String(v || '').slice(0, 280);
    const b = $('#cbtn-' + id);
    if (b) b.disabled = !S.commentDraft[id].trim() || S.boardBusy;
  },
  commentPost: (id) => {
    const text = (S.commentDraft[id] || '').trim();
    if (!text || S.boardBusy) return;
    sendBoardWrite({ t: 'boardComment', id, text }, false, id); // 성공 ack 때 이 글 초안만 지운다
  },
  commentRemove: (id, moderate) => {
    if (S.boardBusy) return;
    askConfirm(moderate ? '운영 검토로 이 댓글을 내릴까? 기록은 감사용으로 남는다.' : '내 댓글을 내릴까?', () => {
      if (S.boardBusy) return;
      sendBoardWrite({ t: 'boardCommentRemove', id });
    }, { ok: '내린다', danger: true });
  },
  // BOUNTY-R2 P2 — 마을 게시판 탭 전환. 처음 여는 탭만 서버에서 받는다.
  // Q276 — 게시판 탭은 의견·사고팔기 둘(공지·현상금·모의 공성전은 [행사], 부동산 매물은 메뉴 › 마을 › 부동산)
  boardTab: (tab) => {
    S.boardTab = board.BOARD_TABS.includes(tab) ? tab : 'board';
    if (S.boardTab === 'trade') requestTradeTab();
    render(true);
  },
  // DESIGN 14.609 — 「사고팔기」 탭의 두 칸(거래소 · 팝니다·삽니다 글)
  tradeView: (view) => {
    S.tradeView = view === 'posts' ? 'posts' : 'exchange';
    requestTradeTab();
    render(true);
  },
  exchangeRefresh: () => { exchange.requestExchange(send); render(true); },
  exchangeRecheck: () => {
    S.exchangeNotice = checkPendingWrite('exchange', send, true) ? '거래소 요청 결과를 다시 확인 중이다.' : '연결을 복구한 뒤 결과를 다시 확인해 달라.';
    render(true);
  },
  // 찾기·종류·정렬은 걸린 줄 칸만 다시 그린다(찾기 칸의 입력이 끊기지 않게)
  exchangeFind: (v) => { S.exchangeFind = String(v || '').slice(0, 40); const el = $('#exchrows'); if (el) el.innerHTML = exchange.exchangeRows(); },
  exchangeKind: (v) => { S.exchangeKind = String(v || 'all'); const el = $('#exchrows'); if (el) el.innerHTML = exchange.exchangeRows(); },
  exchangeSort: (v) => { S.exchangeSort = ['new', 'cheap', 'dear'].includes(v) ? v : 'new'; const el = $('#exchrows'); if (el) el.innerHTML = exchange.exchangeRows(); },
  exchangeOpen: () => { S.exchangeForm = { kind: 'gear', pick: null, qty: 1, price: '' }; S.exchangeNotice = ''; render(true); },
  exchangeClose: () => { S.exchangeForm = null; render(true); },
  exchangeFormKind: (kind) => {
    if (!S.exchangeForm) return;
    S.exchangeForm = { ...S.exchangeForm, kind: kind === 'book' ? 'book' : 'gear', pick: null, qty: 1 };
    render(true);
  },
  exchangePick: (id) => {
    if (!S.exchangeForm) return;
    S.exchangeForm = { ...S.exchangeForm, pick: String(id), qty: 1 };
    render(true);
  },
  // 권 수·값은 고르는 동안 아래 안내 줄과 [올리기]만 고친다(입력 칸을 다시 그리지 않는다)
  exchangeQty: (v) => { if (!S.exchangeForm) return; S.exchangeForm.qty = Math.floor(Number(v)) || 0; exchangeFormSync(); },
  exchangePrice: (v) => { if (!S.exchangeForm) return; S.exchangeForm.price = String(v ?? '').trim(); exchangeFormSync(); },
  exchangePost: () => {
    const f = S.exchangeForm, lim = S.exchange?.limits;
    if (!f?.pick || S.exchangeBusy) return;
    const price = Math.floor(Number(f.price));
    const equip = f.kind === 'gear' ? (S.you?.inv?.equips || []).find((e) => e.id === f.pick) : null;
    const name = exchange.exchangeLabel(f.kind === 'gear' ? { kind: 'gear', equip } : { kind: 'book', key: f.pick, qty: f.qty });
    askConfirm(`${name}${josa(name, '을')} ${num(price)} 은화에 거래소에 걸까?\n거는 동안 물건은 가방에서 빠진다. [내리기]로 언제든 되찾는다.\n`
      + exchange.exchangeNetLine(price, Number.isSafeInteger(Number(lim?.taxPct)) ? Number(lim.taxPct) : null, Number(lim?.minPrice) || 1).replace(/<[^>]*>/g, ''), () => {
      exchange.writeExchange(f.kind === 'gear'
        ? { t: 'exchangePost', kind: 'gear', itemId: f.pick, key: null, qty: null, price }
        : { t: 'exchangePost', kind: 'book', itemId: null, key: f.pick, qty: Math.floor(Number(f.qty)), price }, send, () => render(true));
    }, { ok: '걸기' });
  },
  exchangeCancel: (id) => {
    if (S.exchangeBusy) return;
    const row = S.exchange?.listings?.find((l) => l.id === id);
    const name = row ? exchange.exchangeLabel(row) : '이 물건';
    askConfirm(`${name}${josa(name, '을')} 거래소에서 내릴까? 가방으로 돌아온다.`, () => {
      exchange.writeExchange({ t: 'exchangeCancel', id }, send, () => render(true));
    }, { ok: '내리기' });
  },
  exchangeBuy: (id) => {
    if (S.exchangeBusy) return;
    const row = S.exchange?.listings?.find((l) => l.id === id);
    if (!row) return;
    const price = Number(row.price);
    const name = exchange.exchangeLabel(row);
    askConfirm(`${name}${josa(name, '을')} ${num(price)} 은화에 살까?\n`
      + `판 사람: ${row.seller} · 가방 은화부터, 모자라면 계정 창고에서 낸다. 산 물건은 가방에 들어간다.`, () => {
      exchange.writeExchange({ t: 'exchangeBuy', id, price }, send, () => render(true));
    }, { ok: `${num(price)} 은화에 사기` });
  },
  /** Q276 — [행사] 칸 전환. 칸마다 받는 요청은 옮기기 전 게시판 탭·길드 탭·탑 창과 같다 */
  eventTab: (tab) => {
    if (!events.EVENT_TABS.some((t) => t.id === tab)) return;
    S.eventTab = tab;
    requestEventTab(tab);
    render(true);
  },
  /**
   * Q276 — 메뉴 한 화면의 칸을 누르면 그 창을 연다. 능력·갬블은 가방·상점 안의 한 칸이라 그 칸을 골라 둔 채로 연다.
   * 나가기·후원은 창이 아니라 동작이다(나가기는 확인 창, 후원은 안내 창).
   */
  menuOpen: (id) => {
    const item = menu.navigationItems().find((i) => i.id === id);
    if (!item) return;
    if (item.id === 'map') { document.querySelector('#mainbar button[data-m="map"]')?.click(); return; }
    if (item.action === 'logout') { window.dispatchEvent(new CustomEvent('unige:logout')); return; }
    if (item.action === 'support') { window.dispatchEvent(new CustomEvent('unige:support')); return; }
    // 같은 항목은 그대로 둔다. 입력·선택을 지우거나 자료를 다시 요청하지 않는다.
    if (item.eventTab) {
      if (S.panel === 'events' && events.eventTabOf() === item.eventTab) return;
      openEvents(item.eventTab); return;
    }
    const sameView = item.view?.invView ? S.invView === item.view.invView
      : item.view?.shopTab ? S.shopTab === item.view.shopTab
      : item.id === 'inv' ? S.invView !== 'stats'
      : item.id === 'shop' ? S.shopTab !== 'gamble' : true;
    if (S.panel === item.panel && sameView) return;
    if (item.id === 'inv' && S.invView === 'stats') { S.invView = 'gear'; S.invSel = null; }
    if (item.view?.invView) { S.invView = item.view.invView; S.invSel = null; }
    if (item.view?.shopTab) S.shopTab = item.view.shopTab;
    else if (item.id === 'shop' && S.shopTab === 'gamble') S.shopTab = 'potion';   // 상점 칸은 상점의 처음 칸으로(갬블은 따로 있다)
    if (item.panel === 'shop') S.npcLine = null;
    togglePanel(item.panel, true);
  },
  /** Q276 — 창 머리의 [‹ 메뉴] */
  menuBack: () => togglePanel('menu', true),
  /**
   * ADS-BOOST-R1 — 광고 부스트 둘(드롭×3 1시간 · 강화×2 10분). Q276 부터 메뉴 화면의 「광고 보상」 줄(서버 켬끔 rewarded 가 켜진 날만).
   * 남은 횟수·시간 판정은 전부 서버 몫 — 여기는 광고를 보여주고 신호만 보낸다(전에는 더보기 칸의 main.js 배선과 같은 일).
   */
  adBoost: async (kind) => {
    if (!['drop', 'forge'].includes(kind) || !adsStatus().rewarded || !nativeActionAllowed('adBoost')) return;
    const r = await showRewarded('boost_' + kind);
    if (r.viewed) send({ t: 'adBoost', kind });
    else log('광고가 나오지 않았다 — ' + r.status, 'bad');
  },
  realtyApply: (propertyId, mode) => {
    // R166 — 브라우저 prompt 대신 도트 입력 창. 취소하면 신청하지 않는다(옛 prompt 는 취소해도 빈 메시지로 신청했다)
    askText('소유자에게 보낼 신청 메시지(선택, 160자 이내)', (message) => {
      send({ t: 'realtyApply', propertyId, mode, message: message.slice(0, 160) });
    }, { maxLength: 160, placeholder: '비워 두어도 신청된다', ok: '신청한다' });
  },
  realtyDecide: (applicationId, accept) => {
    askConfirm(accept ? '이 신청을 승인할까?' : '신청을 거절하고 예치금을 환불할까?',
      () => send({ t: 'realtyDecide', applicationId, accept: !!accept }), { ok: accept ? '승인한다' : '거절한다' });
  },
  realtyRecall: () => send({ t: 'scroll' }),
  // UNI-Q21/Q22 — 부동산 메뉴 액션. 판정은 전부 서버(realty.ts)가 한다.
  realtyInviteDraft: (v) => { S.realtyInviteDraft = String(v || '').slice(0, 24); const b = $('#realty-invite-name')?.nextElementSibling; if (b) b.disabled = !S.realtyInviteDraft.trim(); },
  realtyInvite: () => {
    const name = String(S.realtyInviteDraft || '').trim();
    if (!name) return;
    send({ t: 'realtyInvite', name }); S.realtyInviteDraft = ''; render(true);
  },
  realtyInviteAnswer: (propertyId, accept) => {
    if (!accept) { send({ t: 'realtyInviteAnswer', propertyId, accept: !!accept }); return; }
    askConfirm('이 집의 거주자가 될까? 거주 중에는 자기 집을 계약할 수 없다.',
      () => send({ t: 'realtyInviteAnswer', propertyId, accept: !!accept }), { ok: '거주자가 된다' });
  },
  realtyKick: (characterId) => askConfirm('이 거주자를 내보낼까?', () => send({ t: 'realtyKick', characterId }), { ok: '내보낸다', danger: true }),
  /**
   * R257(DESIGN 14.416) — 나가는 집을 싣는다. 사냥터(러스트 `ClientMessage::RealtyLeave{propertyId}`)와 Worker 목표 수령은 이 값이
   * 필수라, 전에 없이 보내면 러스트가 모르는 행동으로 보고 소켓을 닫았다(끊김 덮개 → 사냥터에서 영영 못 나감). 1.0 원천은 몸의 집을 쓰고
   * 이 값을 무시하므로 마을에서도 같다. 값은 이 창이 받은 `realtyHome` 회신(거주자 카드)에서만 온다.
   */
  realtyLeave: () => {
    const home = S.realtyHome?.home;
    const propertyId = home?.role === 'resident' && typeof home.propertyId === 'string' ? home.propertyId : '';
    if (!propertyId) return;
    askConfirm('이 집에서 나갈까? 귀환 주문서는 다시 마을로 간다.', () => send({ t: 'realtyLeave', propertyId }), { ok: '나간다', danger: true });
  },
  realtyReturnDefault: (dest) => send({ t: 'realtyReturnDefault', dest }),
  realtyListing: (propertyId, listed) => send({ t: 'realtyListing', propertyId, listed: !!listed }),
  realtySetHome: (propertyId) => send({ t: 'realtySetHome', propertyId }),
  realtyInvest: (propertyId, axis = 'luck') => {
    const amount = Number(($(`#realty-invest-${propertyId}-${axis}`) || $(`#realty-invest-${propertyId}`))?.value || 0);
    if (Number.isSafeInteger(amount) && amount > 0 && ['luck','evade','stats','carry'].includes(axis)) send({ t: 'realtyInvest', propertyId, amount, axis });
  },
  bountyRefresh: () => { S.bounty = null; send({ t: 'bountyList' }); render(true); },
  // GUARD-R2 — 속죄·뇌물 확인·면죄부 구매. 판정·가격·소각은 전부 서버(guard.ts)가 한다
  // R216(D2-19) — 사냥터 소켓은 둘 다 받지 않는다. 카드 버튼은 꺼 두지만, 눌렸다면 확인 창 대신 이유를 말한다
  guardAtone: () => (nativeActionAllowed('guardAtone') ? send({ t: 'guardAtone' }) : toast(CRIME_TOWN_ONLY, 'bad')),
  // UNI-Q192 — 속죄 기부(한 단계·왕도 금고로)·보디가드 고용/내보내기. 값·문턱·한도는 서버(pubSelf.donate·bodyguard)가 준다
  crimeDonate: () => {
    const price = Number(S.you?.donate) || 0;
    if (price <= 0) return;
    if (!nativeActionAllowed('crimeDonate')) { toast(CRIME_TOWN_ONLY, 'bad'); return; }
    askConfirm(`왕도 금고에 ${price.toLocaleString()} 은화를 기부하고 범죄레벨 💀 를 한 단계 내릴까? (가방 먼저, 모자라면 창고에서)`,
      () => send({ t: 'crimeDonate' }), { ok: '기부한다' });
  },
  bodyguardHire: () => send({ t: 'bodyguardHire' }),
  // UNI-Q210 — 소환·소환 해제. 기록은 그대로 두고 몸만 물린다(해고와 다른 문)
  // UNI-Q210 — **개체마다** 물리고 부른다(id 가 온다). 전체 한 번에가 아니다
  bodyguardRest: (id, rest) => send({ t: 'bodyguardRest', id: String(id), rest: !!rest }),
  // F24(14.531) — 강화(조각+은화 · 확정)·부활(단계 × 은화). 값은 서버가 준 줄 값을 그대로 묻는다. `from` 은 지금 단계 —
  // 두 번 눌러도 서버가 이미 오른 줄은 거절한다(한 번 누름 = 한 번 차감)
  bodyguardEnhance: (id, from, shards, silver) => {
    if (!nativeActionAllowed('bodyguardEnhance')) { toast('보디가드 강화는 마을에서 한다.', 'bad'); return; }
    askConfirm(`보디가드를 강화할까? (+${Number(from) + 1}) 경비병의 조각 ${Number(shards).toLocaleString()}개 · 은화 ${Number(silver).toLocaleString()}(가방 먼저, 모자라면 창고). 확정 성공이다.`,
      () => send({ t: 'bodyguardEnhance', id: String(id), from: Number(from) }), { ok: '강화한다' });
  },
  // 10-20 사용자 「보디가드 강화도 보유한 경비병의 조각이 충분하다면 한번에 최대까지 강화 가능하도록 버튼 추가」 — 한 번 묻고, 서버가 준 다음 단계 값으로
  //   +1 을 차례로 보낸다(한 단계 = 한 번 차감 · 서버가 매 단계 다시 판단). 조각·은화가 모자라거나 끝에 닿거나 단계가 6초 안 오르면 멈춘다.
  //   다시 누르면 새 차례가 앞 차례를 대신한다(두 차례가 같이 돌지 않는다).
  bodyguardEnhanceAllShards: (id) => {
    if (!nativeActionAllowed('bodyguardEnhance')) { toast('보디가드 강화는 마을에서 한다.', 'bad'); return; }
    askConfirm('경비병의 조각이 되는 만큼 이 보디가드를 끝까지 강화할까? 단계마다 조각과 은화(가방 먼저, 모자라면 창고)가 나간다. 확정 성공이다.', () => {
      let waitingFrom = -1, since = Date.now();
      const run = (S.bgEnhanceRun = (Number(S.bgEnhanceRun) || 0) + 1);
      const step = () => {
        if (S.bgEnhanceRun !== run) return;
        // 서버가 주는 칸은 `you.bodyguard`(단수 — inv.js 와 같은 값). 10-21 운영 신고: 복수형으로 읽어 버튼이 아무 말 없이 끝났다
        const b = S.you?.bodyguard, g = b?.list?.find((x) => String(x.id) === String(id));
        const shards = Math.max(0, Math.floor(Number(S.you?.inv?.junk?.guard_shard) || 0));
        const lv = Math.max(0, Math.floor(Number(g?.lv) || 0));
        if (!g || g.down || !b?.enh || lv >= (b.max ?? 10) || !g.next || shards < g.next.shards || S.you?.dead > 0) {
          if (waitingFrom >= 0) toast(`보디가드 강화 — +${lv} 에서 멈췄다.`, 'gear');
          else toast(!g ? '보디가드를 찾지 못했다. 창을 다시 열어 달라.' : g.down ? '쓰러진 보디가드는 먼저 부활시켜야 한다.'
            : !b?.enh ? '지금은 보디가드 강화가 닫혀 있다.' : lv >= (b.max ?? 10) || !g.next ? `이미 +${lv} 끝이다.`
            : S.you?.dead > 0 ? '죽은 동안에는 강화할 수 없다.' : `경비병의 조각이 모자란다 (${shards} / ${g.next.shards}).`, 'bad');
          return;
        }
        // 은화(가방 + 창고) — 창고 값을 아직 안 받았으면(S.vault 없음) 가방만으로는 멈추지 않는다(서버가 창고까지 센다)
        const silverHave = Number(S.you?.silver || 0) + Number(S.vault?.silver || 0);
        if (S.vault && silverHave < Number(g.next.silver || 0)) {
          toast(`보디가드 강화 — +${lv} 에서 멈췄다. 은화가 모자란다 (${silverHave.toLocaleString()} / ${Number(g.next.silver).toLocaleString()}).`, 'bad');
          return;
        }
        if (waitingFrom === lv) {
          // 서버가 거절하면 단계가 안 오른다(거절 문장은 서버가 따로 띄운다) — 오래 기다리지 않고 멈춘다
          if (Date.now() - since > 6000) { toast(`보디가드 강화 — +${lv} 에서 더 오르지 않아 멈췄다. 은화·조각을 확인해 달라.`, 'bad'); return; }
          setTimeout(step, 300); return;
        }
        waitingFrom = lv; since = Date.now();
        send({ t: 'bodyguardEnhance', id: String(id), from: lv });
        setTimeout(step, 300);
      };
      step();
    }, { ok: '끝까지 강화' });
  },
  bodyguardRevive: (id, lv, silver) => {
    if (!nativeActionAllowed('bodyguardRevive')) { toast('보디가드 부활은 마을에서 한다.', 'bad'); return; }
    askConfirm(`쓰러진 +${Number(lv)} 보디가드를 부활시킬까? 은화 ${Number(silver).toLocaleString()} (가방 먼저, 모자라면 창고)`,
      () => send({ t: 'bodyguardRevive', id: String(id) }), { ok: '부활시킨다' });
  },
  bodyguardDismiss: (id) => {
    askConfirm('이 보디가드를 내보낼까? 내보낸 보디가드와 쓴 조각은 돌아오지 않는다.',
      () => send({ t: 'bodyguardDismiss', id }), { ok: '내보낸다', danger: true });
  },
  guardBribePay: () => send({ t: 'guardBribePay' }),
  guardBribeCancel: () => send({ t: 'guardBribeCancel' }),
  // 묶음 R-B — 사냥터에서는 목표 수령 관으로 가서 결과(`goalClaimResult` 'pardonBuy')가 올 때까지 창구 단추를 잠근다(두 번 눌러 두 장 사지 않게 —
  // 서버도 몸 하나에 수령 하나만 받는다). 결과가 끝내 안 오면 12초 뒤 풀어 준다(연결이 바뀌면 그 요청은 새 사냥터가 안 받는다).
  pardonBuy: (key) => {
    if (S.pardonBusy) return;
    send({ t: 'pardonBuy', key });
    if (!nativeFieldGeometry()) return;
    S.pardonBusy = { key, at: Date.now() };
    setTimeout(() => { if (S.pardonBusy?.key === key && Date.now() - S.pardonBusy.at >= 11_500) { S.pardonBusy = null; if (bountyShown()) render(true); } }, 12_000);
    if (bountyShown()) render(true);
  },
  // 걸기 원문은 브라우저 메모리에만. 버튼 활성만 즉시 갱신하고 전체 재렌더는 피한다(boardDraft 와 같은 결).
  bountyDraft: (field, v) => {
    if (field === 'name') S.bountyDraft.name = String(v || '').slice(0, 24);
    else S.bountyDraft.amount = String(v || '').replace(/[^0-9]/g, '').slice(0, 12);
    const b = $('#bountypost');
    if (b) b.disabled = !S.bountyDraft.name.trim() || !(Number(S.bountyDraft.amount) > 0) || S.bountyBusy;
  },
  bountySubmit: () => {
    const name = S.bountyDraft.name.trim();
    const amount = Number(S.bountyDraft.amount);
    submitBounty(name, amount);
  },
  // 포스터 「더 걸기」·(후속) 부고 진입점 — 대상 이름을 채워 [행사] › 현상금 칸을 연다(Q276 — 전에는 게시판 현상금 탭).
  bountyOpen: (name) => {
    S.bountyDraft.name = String(name || '').slice(0, 24);
    if (bountyShown()) render(true);
    else openEvents('bounty'); // togglePanel 이 목록을 받고 render 한다
    // 전단에서 고른 대상은 이전 접힘 상태보다 우선한다. 바로 금액을 적을 수 있게 잇는다.
    const composer = $('#bounty-composer');
    if (composer) composer.open = true;
    const amount = $('#bountyamt');
    amount?.focus?.({ preventScroll: true });
    amount?.scrollIntoView?.({ block: 'center' });
  },
  guildRefresh: () => { S.guild = null; S.nativeGuilds = null; S.nativeMembership = null; send({ t: 'guildGet' }); send({ t: 'nativeGuildGet' }); render(true); },
  nativeGuildApply: (id) => send({ t:'nativeGuildApply', organizationId:String(id) }),
  nativeGuildLeave: (id, name) => {
    askConfirm(`원주민회 「${name}」${josa(String(name ?? ''), '을')} 떠날까? 떠나야 다른 길드에 들 수 있다.`,
      () => send({ t:'nativeGuildLeave', organizationId:String(id) }), { ok: '떠난다', danger: true });
  },
  guildMoneyAmount: (v) => guildMoneyAmount(v),
  guildMoneyAdd: (v) => guildMoneyAdd(v, render),
  guildMoneyMax: () => guildMoneyMax(render),
  guildMoneySubmit: () => guildMoneySubmit(render),
  guildEstateTravel: (out=false) => { send({t:'guildEstateTravel',direction:out?'out':'in',token:S.guild?.estate?.travel?.token}); },
  guildEstateBuy: (id) => guildEstateBuy(id,render),
  guildMoneyConfirm: () => guildMoneyConfirm(render),
  guildMoneyCancel: () => guildMoneyCancel(render),
  guildMoneyRetry: () => guildMoneyRetry(render),
  guildShopChoose: (id) => guildShopChoose(id, render),
  guildShopConfirm: () => guildShopConfirm(render),
  guildShopQuantity: (v) => guildShopQuantity(v, render),
  guildShopCancel: () => guildShopCancel(render),
  guildShopRetry: () => guildShopRetry(render),
  guildShopFilter: (key, value) => guildShopFilter(key, value, render),
  guildMoneyMode: (v) => {
    const d = S.guildMoneyDraft;
    guildMoneyChoose(v, v === 'allocate' ? 'building' : 'treasury', d.building, render);
  },
  guildMoneyTarget: (v) => {
    guildMoneyChoose(S.guildMoneyDraft.mode, v === 'treasury' ? 'treasury' : 'building', v === 'treasury' ? null : v, render);
  },
  guildMoneyBuilding: (v) => {
    if (S.guildMoneyPending) return;
    if (S.guild?.me?.role !== 'master') return;
    S.guildView = 'overview'; guildMoneyChoose('allocate', 'building', v, render);
    const body = $('#pbody'); if (body) body.scrollTop = 0;
  },
  guildView: (v) => { S.guildView = String(v || 'overview'); render(true); },
  // UNI-Q186 공성전 — 선포는 최종 확인 뒤에만 보내고(영수증 UUID 로 재전송에도 한 번), 신청·입장·나가기는 서버가 다시 판정한다
  siegeRefresh: () => { S.siege = null; send({ t: 'siegeGet' }); render(true); },
  siegeDeclarePick: (kind, id) => {
    const t = (S.siege?.targets || []).find((x) => x.kind === kind && x.id === id);
    if (!t || t.why || !S.siege?.canDeclare) return;
    S.siegeConfirm = { kind: t.kind, id: t.id, name: t.name, receipt: crypto.randomUUID() };
    render(true);
  },
  siegeDeclareCancel: () => { S.siegeConfirm = null; render(true); },
  siegeDeclareConfirm: () => {
    const c = S.siegeConfirm; if (!c) return;
    S.siegeConfirm = null;
    send({ t: 'siegeDeclare', target: { kind: c.kind, id: c.id }, receipt: c.receipt });
    render(true);
  },
  siegeJoin: () => send({ t: 'siegeJoin' }),
  siegeCancelJoin: () => send({ t: 'siegeCancelJoin' }),
  siegeLeave: () => askConfirm('전장에서 나갈까? 나가면 체력은 들어올 때로 돌아오고, 우리 편 자리는 NPC 가 채울 수 있다.', () => send({ t: 'siegeLeave' }), { ok: '나간다' }),
  guildName: (v) => {
    S.guildDraft.name = String(v || '').slice(0, 12);
    // 14.607 — 재가입 대기는 떠난 그 길드에만 걸린다. 새 길드 창설은 대기와 무관하다(서버 `rejoinOpenSql`)
    const button = $('#guildcreate'); if (button) button.disabled = [...S.guildDraft.name.trim()].length < 2;
    const preview = $('#guildnamepreview'); if (preview) preview.textContent = S.guildDraft.name || '새 길드';
  },
  guildIntro: (v) => {
    S.guildDraft.intro = String(v || '').slice(0, 80);
    const count = $('#guildintrocount'); if (count) count.textContent = `${[...S.guildDraft.intro].length}/80`;
  },
  guildEmblem: (v) => { S.guildDraft.emblem = String(v || 'star'); render(true); },
  guildColor: (v) => { S.guildDraft.color = String(v || 'amber'); render(true); },
  guildCreate: () => {
    const d = S.guildDraft;
    if ([...d.name.trim()].length < 2) return;
    send({ t: 'guildCreate', name: d.name, intro: d.intro, emblem: d.emblem, color: d.color });
  },
  guildApply: (id) => send({ t: 'guildApply', id }),
  guildCancel: () => askConfirm('보낸 가입 신청을 거둘까?', () => send({ t: 'guildCancel' }), { ok: '거둔다' }),
  guildAccept: (id) => send({ t: 'guildAccept', id }),
  guildDecline: (id) => askConfirm('이 길드의 초대를 거절할까?', () => send({ t: 'guildDecline', id }), { ok: '거절한다' }),
  guildInviteName: (v) => { S.guildDraft.invite = String(v || '').slice(0, 12); },
  guildInvite: () => {
    const name = S.guildDraft.invite.trim(); if (!name) return;
    S.guildDraft.invite = '';
    send({ t: 'guildInvite', name });
    render(true);
  },
  guildApprove: (id) => send({ t: 'guildApprove', id }),
  guildReject: (id) => askConfirm('이 가입 신청을 거절할까?', () => send({ t: 'guildReject', id }), { ok: '거절한다' }),
  guildLeave: () => {
    askConfirm('길드를 떠나면 이 길드에는 72시간 뒤에 다시 들어올 수 있다. 다른 길드에는 바로 가입할 수 있고, 새 길드의 버프와 명예 상점은 가입 24시간 뒤 열린다. 탈퇴할까?', () => send({ t: 'guildLeave' }), { ok: '탈퇴한다', danger: true });
  },
  guildKick: (id, name) => {
    askConfirm(`회원 ${name}: 길드에서 내보낼까? 상대는 이 길드에 72시간 동안 다시 들어올 수 없다(다른 길드는 바로 가입할 수 있다).`, () => send({ t: 'guildKick', id }), { ok: '내보낸다', danger: true });
  },
  guildRole: (id, role) => send({ t: 'guildRole', id, role }),
  guildTransfer: (id, name) => {
    askConfirm(`${name}에게 길드장을 위임할까? 나는 부길드장이 되며 이 선택은 자동으로 되돌아오지 않는다.`, () => send({ t: 'guildTransfer', id }), { ok: '위임한다', danger: true });
  },
  guildLiveIntro: (v) => { if (S.guild?.me?.guild) S.guild.me.guild.intro = String(v || '').slice(0, 80); },
  guildRecruiting: (v) => { if (S.guild?.me?.guild) S.guild.me.guild.recruiting = v ? 1 : 0; },
  guildLiveEmblem: (v) => {
    if (!S.guild?.me?.guild) return;
    S.guild.me.guild.emblem = String(v);
    S.guild.me.guild.symbol = S.guild.options?.emblems?.find((x) => x.id === v)?.symbol || S.guild.me.guild.symbol;
    render(true);
  },
  guildLiveColor: (v) => {
    if (!S.guild?.me?.guild) return;
    S.guild.me.guild.colorId = String(v);
    S.guild.me.guild.color = S.guild.options?.colors?.find((x) => x.id === v)?.hex || S.guild.me.guild.color;
    render(true);
  },
  guildSettings: () => {
    const g = S.guild?.me?.guild; if (!g) return;
    send({ t: 'guildSettings', intro: g.intro, recruiting: !!g.recruiting, emblem: g.emblem, color: g.colorId });
  },
  textSize: (value) => setTextSize(value),
  setQuality: (value) => { setQualityPreference(value); render(true); },
  audioToggle: () => {
    const on = toggleSound();
    setGoogleAdSound(on);
    render(true);
  },
  musicVol: (v) => {
    const value = Math.round(setMusicVolume(Number(v) / 100) * 100);
    const out = $('#musicvol'); if (out) out.textContent = `${value}%`;
  },
  sfxVol: (v) => {
    const value = Math.round(setSfxVolume(Number(v) / 100) * 100);
    const out = $('#sfxvol'); if (out) out.textContent = `${value}%`;
  },
  ambVol: (v) => {
    const value = Math.round(setAmbientVolume(Number(v) / 100) * 100);
    const out = $('#ambvol'); if (out) out.textContent = `${value}%`;
  },
  // 묶음 SM(14.435) — 전투 음악 고조(강도 층) 개인 켬끔
  musicSwell: (on) => { setMusicSwell(on); render(true); },
  use: (id) => send({ t: 'use', id }),
  consumeLifeStone: () => consumeLifeStoneFromBag(() => render(true)),
  useCarry: (id) => send({ t: 'useCarry', id }),
  equip: (id) => send({ t: 'equip', id }),
  equipWing: (id) => send({ t: 'equipWing', id }),
  unequipWing: () => send({ t: 'unequipWing' }),
  unequip: (slot) => send({ t: 'unequip', slot }),
  sellGear: (id) => send({ t: 'sellGear', id }),
  sell: () => send({ t: 'sell' }),
  buy: (id, qty) => send({ t: 'buy', id, qty }),
  buyGear: (slot) => send({ t: 'buyGear', slot }),
  buyItem: (slot, grade) => send({ t: 'buyItem', slot, grade }),
  shape: (slot) => send({ t: 'shape', slot }),
  buyAcc: (id) => send({ t: 'buyAcc', id }),
  buyCarry: (id) => send({ t: 'buyCarry', id }),
  equipAcc: (id) => send({ t: 'equipAcc', id }),
  sellAcc: () => send({ t: 'sellAcc' }),
  /**
   * 경주 베팅 — 금액은 옆 칸에서 읽는다.
   * 서버가 다시 검증하므로(하한·소지 은화·회차) 이 값은 편의일 뿐이다.
   * 같은 슬라임이든 다른 슬라임이든 누를 때마다 서버가 한 표에 누적한다.
   */
  bet: (slime) => {
    const el = $('#betamt');
    const amount = Math.floor(Number((el && el.value) || S.raceBetAmount || 0));
    if (!Number.isFinite(amount) || amount <= 0) { S.loadErr = null; return; }
    send({ t: 'bet', slime, amount });
  },
  /** 간편 버튼은 누를 때마다 더한다. +1만을 다섯 번 누르면 정확히 5만이다. */
  betAdd: (amount) => race.addBetAmount(amount),
  betInput: (amount) => race.setBetAmount(amount),
  lotteryMode: (mode) => {
    S.lotteryMode = mode === 'manual' ? 'manual' : 'auto';
    render(true);
  },
  lotteryPick: (n) => {
    const max = Number(S.lottery?.config?.numberMax || 20);
    const count = Number(S.lottery?.config?.pickCount || 5);
    const v = Math.floor(Number(n));
    if (v < 1 || v > max) return;
    const picks = (S.lotteryPicks || []).slice();
    const at = picks.indexOf(v);
    if (at >= 0) picks.splice(at, 1);
    else if (picks.length < count) picks.push(v);
    S.lotteryPicks = picks.sort((a, b) => a - b);
    render(true);
  },
  lotteryQty: (n) => {
    const price = Math.max(1, Number(S.lottery?.config?.ticketPrice) || 10_000);
    const safeGames = Math.floor(Number.MAX_SAFE_INTEGER / price);
    S.lotteryQty = Math.max(1, Math.min(safeGames, Math.floor(Number(n) || 1)));
    S.lotteryQtyPicked = true;
    render(true);
  },
  /**
   * 갬블 공통 간편 버튼(은화 +10만 … +10억) — 은화를 장 수로 바꿔 더한다(금액 ÷ 장당 가격, 내림). 아직 수량을 안 고른 칸은 0 에서 더한다.
   * 수량·가격·잔액은 서버가 다시 검증한다.
   */
  lotteryStakeAdd: (silver) => {
    const price = Math.max(1, Number(S.lottery?.config?.ticketPrice) || 10_000);
    const safeGames = Math.floor(Number.MAX_SAFE_INTEGER / price);
    const base = S.lotteryQtyPicked ? Math.max(1, Math.floor(Number(S.lotteryQty) || 1)) : 0;
    S.lotteryQty = Math.max(1, Math.min(safeGames, base + Math.floor((Number(silver) || 0) / price)));
    S.lotteryQtyPicked = true;
    render(true);
  },
  lotteryBuy: () => {
    if (S.lotteryBusy || !S.lottery) return;
    if (pendingWrite('lottery')) { recoverLotteryPurchase(); return; }
    const total = Math.floor(Number(S.lotteryQty));
    if (!Number.isSafeInteger(total) || total < 1) return;
    const worldN = S.world?.n, drawNo = S.lottery.drawNo;
    if (!Number.isSafeInteger(worldN) || worldN < 1 || !Number.isSafeInteger(drawNo) || drawNo < 1 || S.lottery.closing) {
      log('복권 회차를 확인하는 중이다. 다시 열어 달라.', 'bad');
      return;
    }
    const id = crypto.randomUUID();
    const batch = Math.max(1, Math.floor(Number(S.lottery?.config?.requestBatch) || 100));
    S.lotteryPurchase = {
      id, total, remaining: total, bought: 0, cancelled: false,
      mode: S.lotteryMode === 'manual' ? 'manual' : 'auto',
      picks: (S.lotteryPicks || []).slice(), batch, worldN, drawNo,
    };
    S.lotteryBusy = true;
    sendLotteryChunk();
    render(true);
  },
  lotteryCancel: () => {
    const q = S.lotteryPurchase;
    if (!q) return;
    const row = pendingWrite('lottery');
    if (row && !savePendingWrite('lottery', row.message, { purchase: { ...q, cancelled: true } })) {
      log('복권 구매 중지 선택을 보관하지 못했다. 다시 시도해 달라.', 'bad');
      return;
    }
    q.cancelled = true;
    // 진행 중 한 묶음의 응답까지 받은 뒤 멈춘다. 확정된 주문을 취소/환불하진 않는다.
    render(true);
  },
  lotteryRecheck: () => { checkPendingWrite('lottery', send, true); render(true); },
  /**
   * 신전 봉헌 — **화면은 결과를 미리 그리지 않는다.**
   * 상한이 찼거나 D1 이 실패하면 서버는 **돌을 안 쓰고** 사유를 말한다.
   * 여기서 낙관적으로 개수를 줄이면 거절된 순간 화면이 거짓말을 한다.
   */
  offer: () => send({ t: 'offer' }),
  contributionRanks: () => temple.requestRanks(() => render(true)),
  // UNI-Q36 — 사제에게 서약의 반지를 청한다. 사제가 세 번 물리치고 네 번째에 내준다(서버 카운터)
  templeRing: () => send({ t: 'templeRing' }),
  /**
   * **정류장 id 만 보낸다.** ⚠ 좌표를 보내게 하면 아무 데나 갈 수 있다 —
   * 요금·목적지·내려서는 자리는 전부 서버가 정한다(`town.ts` `teleport`).
   *
   * 낙관적으로 안 그린다. 은화가 모자라거나 제자리면 서버가 거절하고
   * 사유를 말한다 — 미리 옮겨두면 거절된 순간 화면이 거짓말이 된다.
   */
  // C9(DESIGN 14.476) — 누른 순간 「이동 중 — 정류장」(몸이 옮겨지면 지우고, 거절되면 그 까닭을 잠깐 보인다 — ui/crossing-cue.js)
  // Q281(14.568) — 요청 번호를 붙여 보낸다: 서버는 어떤 거절이든 그 번호로 답하고, 답이 그 요청의 덮개만 걷는다(못 보냈으면 그 자리에서)
  teleport: (to) => {
    const stop = stopById(to);
    travelRequest({ msg: { t: 'teleport', to }, dest: stop?.ko || null, sendFn: send });
    // UNI-Q246 — 사냥터·갱도 정류장이면 그 사냥터의 준비 확인을 미리 데운다(캐시 예열 — 내려설 자리는 여전히 서버가 정한다)
    if (stop) prewarmFieldEntryAt(stop.x, stop.y);
  },
  escapeEntry: () => submitEscapeEntry(render),
  escapeEntryRetry: () => retryEscapeEntry(render),
  escapeEntryInfo: () => send({t:'escapeFieldInfo'}),
  hellEntry: () => { const y = S.you; if (y) submitHellEntry(render, hellWhere(y)); },
  hellEntryRetry: () => retryHellEntry(render),
  hellEntryInfo: () => send({t:'hellFieldInfo'}),
  hellLeave: () => leaveHell(render),
  admEscapeSave: () => admPost({cmd:'escapeField',set:true,patch:{on:$('#admescapeon')?.value==='1',fee:Number($('#admescapefee')?.value)}}),
  admOwrSave: () => saveAdminConfig('overweightRescue', 'admowr'),
  admNilSave: () => saveAdminConfig('nativeInputLimit', 'admnil'),
  admSilSave: () => saveAdminConfig('sourceInputLimit', 'admsil'), // R258 섬 소켓 입력 한도
  admAclSave: () => saveAdminConfig('accountCreateLimit', 'admacl'), // R258 새 계정 생성 한도
  admLhSave: () => saveAdminConfig('linkHold', 'admlh'),
  admSrSave: () => saveAdminConfig('saveRescue', 'admsr'), // T12 저장 거절 구조 문턱
  admLpSave: () => saveAdminConfig('ledgerPrune', 'admlp'), // UNI-Q238 사냥터 원장 정리
  admFpSave: () => saveAdminConfig('fieldPoll', 'admfp', {}, { skip: /^selfRestart/ }), // R254 사냥터 원천 호출 주기·드레인 물러남
  admFsrSave: () => saveAdminConfig('fieldPoll', 'admfp', {}, { only: /^selfRestart/ }), // F38 격리 사냥터 자동 재기동(같은 fieldPoll 설정의 네 칸)
  admNlsSave: () => saveAdminConfig('nativeLifeStone', 'admnls'),
  admNrsSave: () => saveAdminConfig('nativeRealty', 'admnrs'),
  admDirectCrossingSave: () => saveAdminConfig('directCrossing', 'admdcx'),
  admFieldKillSwitchSave: () => saveAdminConfig('fieldKillSwitch', 'admfks'),
  admFieldEvacuationSave: () => saveAdminConfig('fieldEvacuation', 'admfev'),
  // R69(DESIGN 14.353) — 적용 뒤 목록을 다시 읽는다(적용됨·남은 몸).
  admFieldEvacuate: async (worldN, fieldId, index) => {
    const acknowledgeLoss = $('#admfevloss' + index)?.checked === true;
    if (!confirm(`${fieldId} 의 몸을 전부 원천으로 돌려보낸다. 사냥터 서버를 멈추고 evacuate 도구를 실행한 뒤에만 된다. 계속할까?`)) return;
    await admPost({ cmd: 'fieldEvacuate', worldN, fieldId, acknowledgeLoss });
    await admPost({ cmd: 'fieldEvacuation' });
  },
  admHellSave: () => saveAdminConfig('hellField', 'admhell'),
  // UNI-Q207 보스 스킬 — 지옥 분지 저장과 같은 뼈대(접두 admboss)
  admBossSkillSave: () => saveAdminConfig('bossSkill', 'admboss'),
  admPaidCombatSave: () => saveAdminConfig('paidCombat', 'admpaid'),
  // HEAVY-R2(14.313) 강타 예고 — 같은 뼈대(접두 admheavy)
  admHeavyStrikeSave: () => saveAdminConfig('heavyStrike', 'admheavy'),
  // V2-FIELDDIST-R1(14.324) 확장 사냥터 분포 — 입구 안전 반경·기울기 세기·정예 바깥 문턱
  admFieldDistributionGet: () => admPost({ cmd: 'fieldDistribution' }),
  admFieldDistributionSave: () => saveAdminConfig('fieldDistribution', 'admfielddist'),
  admAwakenSave: () => saveAdminConfig('awaken', 'admawaken'),   // UNI-Q222 각성
  /**
   * ⚠ **인자가 없다.** 등급도 부위도 개수도 안 보낸다 — 클라가 뭘 뽑을지
   * 말하게 하면 그건 뽑기가 아니다. 값·개수·확률은 전부 `game/gamble.ts` 가 정한다.
   */
  gamble: () => send({ t: 'gamble' }),
  /**
   * 블랙잭(UNI-Q41) — 판돈 배수는 옆 칸에서 읽는다. 단위·잔액·접수 마감은 서버가 다시 검증한다.
   * 히트/스탠드는 인자가 없다 — 카드는 서버가 뽑는다(클라가 카드를 말하게 하면 그건 카드 게임이 아니다).
   */
  bjJoin: () => {
    // 칸은 은화다 — 단위로 내린 배수(S.bjUnits)를 보낸다
    const el = $('#bjstake');
    if (el) blackjack.setStake(el.value, true);
    const units = Math.max(1, Math.floor(Number(S.bjUnits) || 0));
    if (!Number.isSafeInteger(units)) return;
    send({ t: 'bjJoin', units });
  },
  bjStake: (silver) => blackjack.setStake(silver, true),
  bjStakeSet: (silver) => { blackjack.setStake(silver); render(true); },
  bjStakeAdd: (silver) => { blackjack.addStake(silver); render(true); },
  // UNI-Q184 슬롯머신 — 칸·버튼은 은화, 서버에는 판돈 배수(S.slotUnits)를 보낸다. 단위·잔액·세금은 서버가 다시 검증한다
  slotSpin: () => { const el = $('#slotstake'); if (el) slot.setStake(el.value, true); slot.startSpin(S.slotUnits || 1, send, () => render(true)); },
  slotRecheck: () => { checkPendingWrite('slot', send, true); render(true); },
  slotStake: (silver) => slot.setStake(silver, true),
  slotStakeSet: (silver) => { slot.setStake(silver); render(true); },
  slotStakeAdd: (silver) => { slot.addStake(silver); render(true); },
  bjHit: () => send({ t: 'bjHit' }),
  bjStand: () => send({ t: 'bjStand' }),
  // 값·개수는 서버가 판정한다 — 화면은 무엇을 몇 개 원하는지만 보낸다
  goblinCount: (item, value) => { if (!(item in S.goblinCounts)) return; S.goblinCounts[item] = value; render(true); },
  goblinBuy: (item, n) => {
    if (pendingWrite('goblin')) { checkPendingWrite('goblin', send, true); return; }
    if (S.goblinBusy || !['shard', 'bstone'].includes(item)) return;
    const raw = n ?? S.goblinCounts[item], count = Number(raw);
    if (!/^\d+$/.test(String(raw)) || !Number.isSafeInteger(count) || count < 1) return;
    // R166 — 막는 알림창 대신 토스트(연결이 돌아오면 다시 누르면 된다)
    if (!S.ws || S.ws.readyState !== 1) { toast('서버 연결이 끊겼다. 다시 연결된 뒤 구매해 달라.', 'bad'); return; }
    const worldN = S.world?.n;
    if (!Number.isSafeInteger(worldN) || worldN < 1) { log('세계 정보를 확인한 뒤 구매해 달라.', 'bad'); return; }
    const requestId = crypto.randomUUID();
    const command = { t: 'goblinBuy', item, n: count, requestId, worldN };
    if (!savePendingWrite('goblin', command, { action: 'goblinBuy' })) {
      log('구매 요청 번호를 보관하지 못했다. 요청은 보내지 않았다.', 'bad'); return;
    }
    S.goblinBusy = requestId;
    if (send(command) !== true) {
      if (clearPendingWrite('goblin', requestId)) S.goblinBusy = false;
      log('구매 요청을 보내지 못했다. 연결을 확인해 달라.', 'bad'); render(true); return;
    }
    armPendingWrite('goblin', send); render(true);
  },
  petBuy: (kind) => send({ t: 'petBuy', kind }),
  petEnhance: (kind, count) => send({ t: 'petEnhance', kind, count }),
  petPick: (kind) => send({ t: 'petPick', kind }),
  // INVITE-R1 — 링크 발급·복사
  inviteLink: () => send({ t: 'inviteLink' }),
  inviteCopy: () => {
    const el = $('#invurl');
    if (!el) return;
    el.select?.();
    const done = () => log('초대 링크를 복사했다. 친구에게 공유해 달라.', 'good');
    if (navigator.clipboard?.writeText) navigator.clipboard.writeText(el.value).then(done, () => document.execCommand?.('copy') && done());
    else { document.execCommand?.('copy'); done(); }
  },
  petRevive: (kind) => {
    if (!nativeFieldGeometry()) { send({ t: 'petRevive', kind }); return; }
    if (S.petRevivePending) return;
    const pending = { kind, timer: 0 };
    S.petRevivePending = pending;
    pending.timer = setTimeout(() => {
      if (S.petRevivePending !== pending) return;
      S.petRevivePending = null;
      log('펫 부활 결과가 늦어지고 있다. 상태를 확인한 뒤 다시 시도해 달라.', 'bad');
      render(true);
    }, 15000);
    send({ t: 'petRevive', kind });
    render(true);
  },
  /**
   * POWER-R1 랭킹 검사 항목 전환. ⚠ **표를 다시 받는다** — 받은 20명을 클라에서
   * 재정렬하면 그 20명이 레벨 상위일 뿐이라 **전투력 상위가 표 밖에 있다.**
   */
  rankBy: (v) => {
    const next = v === 'power' ? 'power' : 'level';
    if (S.rankBy === next) return;
    S.rankBy = next; S.rank = null;
    togglePanel('rank', true);
  },
  /**
   * 새 세계 알림 — **사람이 누른 그 순간에만** 브라우저 권한을 묻는다.
   * 막혀 있으면 그 사실을 화면이 말한다(`help.js` 가 `notifyState` 를 읽는다).
   */
  webPushOn: async () => { await enableWorldNotify(); render(true); },
  webPushOff: async () => { await disableWorldNotify(); render(true); },
  webPushRefresh: async () => { await refreshWorldNotify(); render(true); },
  // UNI-Q187 ③ — 종류별(새 세계·오늘의 목표·탑 주간 결과) 켬끔. 기기 먼저/서버 먼저 순서는 world-notify.js 가 정한다
  webPushKind: async (kind, on) => { await setWorldNotifyKind(kind, on === true); render(true); },
  admPushGet: () => admPost({ cmd: 'worldNotify' }),
  admPushTest: () => admPost({ cmd: 'worldNotify', test: true }),
  admPushSave: () => {
    const input = $('#admPushEnabled'); if (!input || !S.adm.worldNotify) return;
    // UNI-Q187 ③ — 오늘의 목표·탑 주간 결과 켬끔도 같은 저장에(칸이 없으면 보내지 않아 서버 값 그대로)
    const kind = (id) => { const el = $(id); return el ? el.value === '1' : undefined; };
    // R217 ⓓ — 세계 종료 전 알림 켬끔과 남은 시간(정수 시간). 빈 칸·정수 아님은 보내지 않는다(서버 값 그대로 — 범위도 서버가 다시 본다)
    const hoursEl = $('#admPushEndHours'), hours = hoursEl && /^\d+$/.test(hoursEl.value.trim()) ? Number(hoursEl.value.trim()) : undefined;
    return admPost({ cmd: 'worldNotify', enabled: input.value === '1', daily: kind('#admPushDaily'), tower: kind('#admPushTower'),
      end: kind('#admPushEnd'), endHours: hours });
  },
  notifyOn: async () => { await enableNotify(); render(true); },
  notifyOff: () => { disableNotify(); render(true); },
  /**
   * 처음 오는 이에게 주는 것 — 계정 × 세계로 한 번. 판정은 전부 서버가 한다.
   *
   * ⚠ **누르면 잠근다.** 두 번 누르면 두 번째가 *"이미 받았다"* 로 거절되어
   * **방금 받은 사람에게 실패처럼 보인다.** 서버 직렬화는 데이터를 지키지
   * 화면을 지키지 않는다.
   *
   * 푸는 조건이 둘이다 — 서버가 무엇으로 답하든 풀리게:
   *   · 가방이 바뀌면(`you`) → 받았다
   *   · 2초 뒤 → 거절이었다(거절은 로그만 오고 가방이 안 바뀐다)
   * 하나만 두면 거절된 사람의 버튼이 영영 잠긴다.
   */
  /** Google H5 일반 광고. 보상은 클라이언트 콜백으로 발행하지 않는다. */
  adSupport: async () => {
    if (S.busy === 'ad') return;
    S.busy = 'ad';
    render(true);
    const result = await showInterstitial('support_from_shop');
    S.busy = null;
    if (result.shown) log('광고 시청 완료. 게임 운영을 응원해줘서 고맙다.');
    else if (result.status === 'publisherMissing') log('광고를 준비 중이다. 잠시 뒤 다시 시도해 달라.', 'bad');
    else if (result.status === 'frequencyCapped') log('광고 노출 간격이 아직 지나지 않았다.', 'bad');
    else log('지금 보여줄 수 있는 광고가 없다. 게임은 그대로 계속된다.', 'bad');
    render(true);
  },
  starter: () => {
    if (S.busy === 'starter') return;
    S.busy = 'starter';
    send({ t: 'starter' });
    render(true);
    setTimeout(() => { if (S.busy === 'starter') { S.busy = null; render(true); } }, 2000);
  },

  /**
   * ── 관리자 ──
   * 대상은 **목록에서 고른다.** 손으로 치면 오타 하나로 엉뚱한 사람에게 준다.
   * 권한은 서버가 본다 — 여기 버튼이 보인다고 되는 것이 아니다.
   */
  /**
   * 자동 물약 — **설정만 보낸다.** 마실지 말지는 서버가 판정한다.
   * 슬라이더를 끄는 동안에는 숫자만 바꾸고(`preview`), 손을 뗄 때 보낸다 —
   * 끄는 내내 보내면 10Hz 로 서버를 두드린다.
   */
  /** 버리기 — 바닥에 둔다(도로 주울 수 있다). 전부 버릴 때만 한 번 묻는다 */
  drop: (kind, qty) => {
    const n = Math.floor(Number(qty) || 0);
    if (n < 1) return;
    if (n <= 20) { send({ t: 'drop', kind, qty: n }); return; }
    askConfirm(`${n}개를 바닥에 둔다. 맞나?`, () => send({ t: 'drop', kind, qty: n }), { ok: '바닥에 둔다' });
  },
  autoPot: (on, pct) => send({ t: 'autoPotion', on: !!on, pct: Number(pct) }),
  // UNI-Q173 — 설정 화면이 부르는 셋. 자동 공격은 하단 [자동] 버튼과 같은 서버 토글, 강공은 A 키와 같은 함수
  autoAttack: () => send({ t: 'autoToggle' }),
  forceMode: () => { setForce(!S.forceMode); render(true); },
  fxEffects: (on) => {
    setFxOff(!on);
    // 끄는 것은 바로 — 켜는 것은 다음 상태 틱에 서버 값(운영 스위치 포함)이 돌아온다
    if (!on && S.you) S.you.hitFeel = 0;
    render(true);
  },
  // UNI-Q179 — 첫 걸음 목표 줄 보임/숨김(이 기기). 줄은 다음 HUD 갱신을 기다리지 않고 바로 바뀐다.
  goalLine: (on) => { setGoalLineOff(!on); syncGoalLine(); render(true); },
  // 전투 HUD — 대상 프레임·보스 체력줄·보상 흐름 글자·구역 제목 카드·파티 프레임을 한 번에.
  hudFxToggle: (on) => { setHudFxOff(!on); render(true); },
  // 묶음 HUD1 — 첫 조작 자리 힌트 켬끔(이 기기). 켜면 다음 접속 처음 10초에 다시 뜬다
  firstHint: (on) => { setFirstHint(!!on); render(true); },
  // R184 — 프레임 시간 표시 켬끔(이 기기). 표시는 다음 프레임부터 바로 나타나고 꺼지면 바로 사라진다.
  frameMeter: (on) => { setFrameMeterOn(!!on); render(true); },
  openPanel: (p) => togglePanel(String(p), true),
  hallWorldSelect: (world) => { hall.selectWorld(world); render(true); },
  autoEquip: (on) => send({ t: 'autoEquip', on: !!on }),
  autoRetaliate: (on) => send({ t: 'autoRetaliate', on: !!on }),
  autoStats: (on) => send({ t: 'autoStats', on: !!on }),
  autoBreakdown: (grade) => send({ t: 'autoBreakdown', grade: Number(grade) }),
  autoForge: () => { S.forgeSel = []; togglePanel('forge', true); },
  autoPotPreview: (v) => {
    // 2026-10-21 — 문구를 찾지 않고 표식(data-autopot-pct)으로 고른다. 문구로 찾으면 줄을 다듬은 날 엉뚱한 첫 칸 숫자를 덮어썼다
    const el = $('#pbody [data-autopot-pct]');
    if (el) el.textContent = `HP ${Math.round(Number(v))}%`;
  },
  /** 가방의 세 화면. 자리를 바꾸면 옛 물건 선택은 닫아 엉뚱한 동작 띠가 남지 않게 한다. */
  invView: (v) => {
    if (!['gear', 'items', 'stats'].includes(v)) return;
    S.invView = v; S.invSel = null; hideTip(); render(true);
  },
  admList: () => admPost({ cmd: 'list' }),
  /** UNI-Q239 — 못 받은 목록 하나(물건·접속자)만 다시 받는다 */
  admReread: (cmd) => rereadAdmin(String(cmd || '')),
  admGuilds: () => admPost({ cmd: 'guilds' }),
  /**
   * 찾기·줄세우기 — **서버를 안 탄다.** 입력 중에는 초안만 저장하고, Enter/[찾기]가
   * 눌린 때만 실제 필터를 바꾼다. 한글 이름을 끝까지 쓰기 전에 목록이 반응하지 않는다.
   */
  admQ: (v) => {
    S.adm.qDraft = String(v || '');
    const clear = $('#admqclear');
    if (clear) clear.disabled = !(S.adm.q || S.adm.qDraft);
  },
  admApplyQ: () => {
    S.adm.q = S.adm.qDraft.trim();
    filterAdminRows();
  },
  admClearQ: () => {
    S.adm.qDraft = ''; S.adm.q = '';
    redrawAdmin();
  },
  admSort: (k) => { S.adm.sort = String(k || ''); redrawAdmin(); },
  admDesc: () => { S.adm.desc = !S.adm.desc; redrawAdmin(); },
  /** 조회 — 이건 서버에 묻는다(몬스터 표·상수는 서버에만 있다) */
  admMons: (q) => { S.adm.monsQ = String(q || ''); admPost({ cmd: 'mons', q: S.adm.monsQ }); },
  admSpawnMon: (v) => { S.adm.spawnMon = String(v || ''); },
  admSpawnN: (v) => {
    S.adm.spawnN = Math.max(1, Math.min(S.adm.spawnMax, Math.floor(Number(v) || 1)));
  },
  admSpawn: () => {
    const sel = S.adm.sel;
    const spawnMon = $('#admspawnmon')?.value || S.adm.spawnMon;
    const spawnN = S.adm.spawnN;
    if (!sel || !S.adm.whoOnline || !spawnMon) return;
    // 드롭다운과 같은 전체 소환 목록을 본다. 진단 검색 결과를 보면 보스 확인이 조용히 빠진다.
    const mon = S.adm.spawnMons?.find((m) => m.id === spawnMon);
    if ((mon?.boss || spawnN >= 10)
      && !confirm(`${sel} 앞에 ${mon?.name || spawnMon} ${spawnN}마리를 소환한다. 맞나?`)) return;
    admPost({ cmd: 'spawn', name: sel, mon: spawnMon, n: spawnN });
  },
  admDespawn: () => {
    const sel = S.adm.sel;
    if (!sel || !S.adm.whoOnline) return;
    if (!confirm(`${sel} 앞에 운영자가 놓은 시험 소환 몬스터를 회수한다. 맞나?`)) return;
    admPost({ cmd: 'despawn', name: sel });
  },
  admConsts: (q) => { S.adm.constsQ = String(q || ''); admPost({ cmd: 'consts', q: S.adm.constsQ }); },
  admWealth: () => admPost({ cmd: 'wealth' }),
  /**
   * BOUNTY-R2 P1 — 서버 API 설정값. P2(29·포스터 UI)가 이 둘에 버튼을 단다.
   * 계약: bountyPost {name, amount, requestId, worldN} → bountyPostAck · bountyList → {t:'bountyList', rows}
   */
  bountyPost: (name, amount) => submitBounty(String(name || '').trim(), Number(amount)),
  bountyList: () => send({ t: 'bountyList' }),
  annList: () => send({ t: 'annList' }),
  admBountyGet: () => admPost({ cmd: 'bountycfg' }),
  admBountySave: () => admPost({ cmd: 'bountycfg', set: true,
    fee: $('#admbfee')?.value === '' ? null : Number($('#admbfee')?.value) / 100,
    minAmount: Number($('#admbmin')?.value), snapshotSecs: Number($('#admbsnap')?.value),
    raidPotMin: Number($('#admbrpot')?.value), raidGiveUpDeaths: Number($('#admbrdeath')?.value),
    raidGiveUpPower: Number($('#admbrpower')?.value) }),
  admLlmGet: () => admPost({ cmd: 'llmcfg' }),
  admLlmSave: () => admPost({ cmd: 'llmcfg', set: true,
    on: $('#admllmon')?.value === '1',
    pilotCount: Number($('#admllmpilot')?.value), periodMinS: Number($('#admllmpmin')?.value),
    periodMaxS: Number($('#admllmpmax')?.value), dailyCallCap: Number($('#admllmcap')?.value),
    timeoutMs: Number($('#admllmto')?.value), maxInflight: Number($('#admllminflight')?.value), model: $('#admllmmodel')?.value,
    maxTokens: Number($('#admllmtokens')?.value) }),
  admGuildEconGet: () => admPost({ cmd: 'guildeconcfg' }),
  admGuildEstateGet: () => admPost({cmd:'guildestatecfg'}),
  admGuildEstateOperate: adminEstateAction,
  admGuildEstateSave: () => admPost({cmd:'guildestatecfg',set:true,enabled:$('#admestateon')?.value==='1',purchaseSilver:Number($('#admestateprice')?.value)}),
  admGuildEconSave: () => admPost({ cmd: 'guildeconcfg', set: true,
    effectPctPerLevel: Number($('#admgebuff')?.value),
    costBase: $('#admgebase')?.value?.trim(), costGrowthPct: $('#admgegrow')?.value?.trim() }),
  admNativeMarketGet: () => nativeMarketAction({}),
  admNativeMarketDistribute: () => nativeMarketAction({ distribute: true }),
  admNativeMarketSave: () => nativeMarketAction({ set: true, patch: {
    buybackRatio: Number($('#admnmbuy')?.value), bookPrice: Number($('#admnmbook')?.value),
    imprintPrice: Number($('#admnmimprint')?.value), honorRate: Number($('#admnmhonor')?.value),
    wingPrice: Number($('#admnmwing')?.value), nativeGrantEverySecs: Number($('#admnmgrantevery')?.value),
    nativeGrantMaxUnits: Number($('#admnmgrantmax')?.value),
  } }),
  admGuardGet: () => admPost({ cmd: 'guardcfg' }),
  admGuardSave: () => admPost({ cmd: 'guardcfg', set: true,
    hitPct: Number($('#admghit')?.value), dmgCapPct: Number($('#admgcap')?.value),
    regenPct: Number($('#admgregen')?.value), floorPct: Number($('#admgfloor')?.value),
    respawnSecs: Number($('#admgrespawn')?.value), reinforce: Number($('#admgreinf')?.value),
    chaseSpeed: Number($('#admgchase')?.value), bloodSecs: Number($('#admgblood')?.value),
    crimeDecaySecs: Number($('#admgdecay')?.value), stunCastSecs: Number($('#admgstuncast')?.value),
    stunChance: Number($('#admgstunch')?.value), stunSecs: Number($('#admgstunsec')?.value),
    execDmgMult: Number($('#admgexec')?.value), bribeCost: Number($('#admgbribe')?.value),
    atoneBase: Number($('#admgatone')?.value), atoneMult: Number($('#admgatonemult')?.value),
    pardonDrop: Number($('#admgpdrop')?.value), pardonPriceRatio: Number($('#admgpratio')?.value),
    pardonTierWeights: $('#admgpweights')?.value?.trim(),
    caveRIn: Number($('#admgcavein')?.value), caveROut: Number($('#admgcaveout')?.value),
    chaseSkulls: Number($('#admgskulls')?.value), sightR: Number($('#admgsight')?.value), garrison: Number($('#admggarrison')?.value),
    engageMax: Number($('#admgengage')?.value), stunImmuneSecs: Number($('#admgstunimm')?.value), loseSecs: Number($('#admglose')?.value) }),
  admInviteGet: () => admPost({ cmd: 'invitecfg' }),
  admInviteSet: (patch) => admPost({ cmd: 'invitecfg', set: true, ...patch }),
  admInviteSave: () => admPost({ cmd: 'invitecfg', set: true, enabled: $('#adminvenabled')?.value === '1',
    petKind: $('#adminvpet')?.value?.trim(), cap: Number($('#adminvcap')?.value),
    rewardKind: $('#adminvkind')?.value, itemKey: $('#adminvitem')?.value?.trim(), itemQty: Number($('#adminvqty')?.value) }),
  // 아이템 보유자 상세 — 기본은 사용자가 물은 생명의 돌
  admHoldItem: (v) => { S.adm.holdItem = v; },
  admHolders: () => admPost({ cmd: 'holders', item: S.adm.holdItem || 'lifestone' }),
  admWorld: () => admPost({ cmd: 'world' }),
  admRetaliateStats: () => admPost({ cmd: 'retaliateStats' }),
  // 떠돌이 뭉침/얼어붙음을 즉시 턴다 — 결과는 관리 로그에 뜬다(reply)
  admScatter: () => admPost({ cmd: 'scatter' }),
  /** 떠돌이 인구 상한 — 0 이면 전원 삭제 후 스폰 정지(1개체 실험 체제). */
  admWanderCap: () => {
    const el = $('#admwandercap');
    const raw = el?.value?.trim(), v = Number(raw);
    if (!raw || !Number.isSafeInteger(v) || v < 0) { alert('0 이상 정수 인구 상한을 입력해 달라.'); return; }
    // UNI-Q300(DESIGN 14.582) — 지우는 순서를 확인창에서도 말한다(원천·사냥터 몸 한 줄)
    if (v < Number(S.adm.wanderCap?.population || 0) && !confirm('상한을 넘는 원주민은 삭제된다(죽은 몸 → 레벨 낮은 순 · 사냥터에 나가 있는 몸 포함). 인구 상한을 적용할까?')) return;
    admPost({ cmd: 'wandercap', value: v });
  },
  /** D1(DESIGN 14.474) — 순차 투입(한 번에 늘리는 수·늘리는 간격)·사냥터별 상한. 내리면 넘는 떠돌이를 사냥터에서 돌려보낸다(지우지 않는다). */
  admWanderRampSave: () => saveAdminConfig('wanderRamp', 'admwanderramp'),
  // 떠돌이 대인 방어 감쇄율 — 화면은 %, 서버는 0~0.9 비율. value 없으면 현재값만 읽는다.
  admWanderBrainGet: () => admPost({ cmd: 'wanderbrain' }),
  admWanderTrialGet: () => admPost({ cmd: 'wandertrial', action: 'status' }),
  admWanderTrialStart: () => {
    // The card describes this reversible operation and exposes restore. A native
    // confirm blocks the embedded browser; request locking and server idempotency
    // already prevent duplicate starts without a second, inaccessible modal.
    return admPost({ cmd: 'wandertrial', action: 'start', count: 20 });
  },
  admWanderTrialRestore: () => admPost({ cmd: 'wandertrial', action: 'restore' }),
  admWanderTrialEnd: () => admPost({ cmd: 'wandertrial', action: 'end' }),
  admNativeSpawnConfig: () => admPost({cmd:'wandertrial',action:'spawnConfig',count:Number($('#admnativecount')?.value),level:Number($('#admnativelevel')?.value)}),
  admNativeSpawn: () => admPost({cmd:'wandertrial',action:'spawn',count:Number($('#admnativecount')?.value),level:Number($('#admnativelevel')?.value),world:S.adm.wanderTrial?.world,requestId:crypto.randomUUID()}),
  admNativeOracleGet: () => admPost({cmd:'nativeOracle'}),
  admNativeOracleDraft: v => {S.adm.nativeOracleDraft=String(v).slice(0,160);},
  admNativeOracleSet: async action => {
    const d=S.adm.nativeOracle;if(!d||S.adm.nativeOraclePending)return;
    const text=S.adm.nativeOracleDraft||'',id=$('#admoracleid')?.value;
    if(action==='reveal'&&!text.trim()){alert('안내 내용을 적어 달라.');return;}
    const signature=JSON.stringify({action,id,text,worldN:d.worldN});
    if(S.adm.nativeOracleRequest&&S.adm.nativeOracleRequest.signature!==signature){alert('이전 요청 결과를 먼저 같은 내용으로 확인해 달라.');return;}
    const pending=S.adm.nativeOracleRequest??{signature,body:{cmd:'nativeOracle',action,id,text,worldN:d.worldN,revision:d.revision,expiresAt:d.requestExpiresAt,requestId:crypto.randomUUID()}};
    S.adm.nativeOracleRequest=pending;S.adm.nativeOraclePending=true;
    try{const j=await admPost(pending.body);
      const outcome=j.data?.find(v=>v.cmd==='nativeOracle'&&v.outcome?.requestId===pending.body.requestId)?.outcome;
      if(outcome&&!outcome.retry){S.adm.nativeOracleRequest=null;if(outcome.ok&&action==='reveal')S.adm.nativeOracleDraft='';redrawAdmin();}
    }finally{S.adm.nativeOraclePending=false;}
  },
  admWanderSocialGet: () => admPost({ cmd: 'wanderSocial' }),
  admNativeTelemetryGet: () => admPost({ cmd: 'nativeTelemetry' }),
  admNativeTelemetrySave: () => saveAdminConfig('nativeTelemetry','admnt'),
  admNativeTelemetryExport: afterId => admPost({ cmd: 'nativeTelemetry', export: true, afterId }),
  admNativeOrganizationsGet: () => admPost({ cmd: 'nativeOrganizations' }),
  admNativeOrganizationsSave: () => saveAdminConfig('nativeOrganizations','admno'),
  admNativeOrganizationStance: (organizationId, worldN, expected, value) => admPost({cmd:'nativeOrganizations',set:true,stance:{organizationId,worldN,expected,value}}),
  admNpcProtectGet: () => admPost({ cmd: 'npcProtect' }),
  admNpcProtectSave: () => saveAdminConfig('npcProtect','admnp'),
  admNewWorldBonusGet: () => admPost({ cmd: 'newWorldBonus' }),
  // UNI-Q193 — 명예의 전당 설정값·새긴 기록 보기
  admHallGet: () => admPost({ cmd: 'hallOfFame' }),
  admHallSave: () => saveAdminConfig('hallOfFame', 'admhall'),
  // F5(14.511) — 세계 랭커 특전(상금·날개·휘장·동상). 날개 칸은 날개 열쇠(문자열)라 문자열 값도 싣는다
  admRankerPerksGet: () => admPost({ cmd: 'rankerPerks' }),
  admRankerPerksSave: () => saveAdminConfig('rankerPerks', 'admrp', {}, { strings: true }),
  admNewWorldBonusSave: () => saveAdminConfig('newWorldBonus','admnwb'),
  admTempleRingGet: () => admPost({ cmd: 'templeRing' }),
  admTempleRingSave: () => saveAdminConfig('templeRing', 'admtr'),
  admWanderTradeGet: () => admPost({ cmd: 'wanderTrade' }),
  admWanderBrainSave: () => {
    const cfg = S.adm.wanderBrain?.cfg; if (!cfg) return;
    const patch = {};
    for (const [key, value] of Object.entries(cfg)) {
      const input = $('#admwb' + key); if (!input) continue;
      if (typeof value === 'boolean') patch[key] = input.value === '1';
      else if (key === 'profiles') {
        try {
          const rows = JSON.parse(input.value);
          if (!Array.isArray(rows) || rows.length > 32 || rows.some((r) => !r || typeof r.id !== 'string' || !r.id.trim() || !r.tune || typeof r.tune !== 'object' || Array.isArray(r.tune))) throw new Error();
          patch.profiles = rows;
        } catch { alert('프로필 JSON을 확인해 달라. 이름(id)과 성향(tune)이 있는 목록으로 최대 32개까지 넣을 수 있다.'); return; }
      }
      else if (key === 'growthEliteNames') patch[key] = input.value;
      else if (input.value.trim() && Number.isFinite(Number(input.value))) patch[key] = Number(input.value) / (key === 'leisureBudgetPct' ? 100 : 1);
    }
    admPost({ cmd: 'wanderbrain', set: true, patch });
  },
  admWanderSocialSave: () => saveAdminConfig('wanderSocial','admws',{friendThreshold:100}),
  admWanderTradeSave: () => saveAdminConfig('wanderTrade','admwt'),
  admWanderPkGet: () => admPost({ cmd: 'wanderpk' }),
  admWanderPkDraft: (v) => { S.adm.wanderPkDraft = Math.round(Number(v)); },
  admWanderPkQuick: (v) => {
    S.adm.wanderPkDraft = Number(v);
    const input = $('#admwanderpk');
    if (input) input.value = String(v);
  },
  admWanderPkSet: () => {
    const input = $('#admwanderpk');
    const pct = Number(input?.value ?? S.adm.wanderPkDraft);
    if (!Number.isFinite(pct)) return;
    const value = Math.max(0, Math.min(0.9, pct / 100));
    admPost({ cmd: 'wanderpk', value });
  },
  // 구역별 잡몹 밀도 배수 — value 없으면 현재 맵만 읽는다. 다음 스폰·리스폰부터 적용.
  admDensityGet: () => admPost({ cmd: 'densitymult' }),
  admDensitySet: (zone) => {
    const input = $('#admdensity-' + zone);
    const value = Number(input?.value);
    if (!Number.isFinite(value) || value <= 0) return;
    admPost({ cmd: 'densitymult', zone, value });
  },
  // HEAVY-R1(14.312) 구역 사냥 무게 W·공격 배수 A — 둘 다 없으면 현재 맵만 읽는다. 다음 스폰·리스폰부터 적용.
  admHeavyHuntGet: () => admPost({ cmd: 'heavyhunt' }),
  admHeavyHuntSet: (zone) => {
    const w = Number($('#admheavyw-' + zone)?.value);
    const atk = Number($('#admheavyatk-' + zone)?.value);
    if (!Number.isFinite(w) || w <= 0 || !Number.isFinite(atk) || atk <= 0) return;
    admPost({ cmd: 'heavyhunt', zone, w, atk });
  },
  // 떠돌이 사냥 하한(레벨차) — value 없으면 현재값만 읽는다.
  admPreyGapGet: () => admPost({ cmd: 'preygap' }),
  admPreyGapSet: () => {
    const value = Number($('#admpreygap')?.value);
    if (!Number.isFinite(value)) return;
    admPost({ cmd: 'preygap', value });
  },
  // 떠돌이 성장 배수(처치 XP) — value 없으면 현재값만 읽는다.
  admWanderXpGet: () => admPost({ cmd: 'wanderxp' }),
  admWanderXpSet: () => {
    const value = Number($('#admwanderxp')?.value);
    if (!Number.isFinite(value) || value <= 0) return;
    admPost({ cmd: 'wanderxp', value });
  },
  // 떠돌이 레벨 소급 — 번 경험치만 환산 비율로 나눠 레벨을 다시 매긴다(되돌릴 수 없다).
  admWanderRescale: () => {
    const value = Number($('#admwanderrescale')?.value);
    if (!Number.isFinite(value) || value <= 0 || value > 1000) return;
    if (!confirm(`원주민이 번 경험치를 ÷${value} 해서 레벨을 다시 매긴다. 되돌릴 수 없다. 진행할까?`)) return;
    admPost({ cmd: 'wanderrescale', value });
  },
  // 기회 사냥 반경 — value 없으면 현재값만 읽는다.
  admOpportunGet: () => admPost({ cmd: 'opportunrange' }),
  admOpportunSet: () => {
    const value = Number($('#admopportun')?.value);
    if (!Number.isFinite(value) || value < 0) return;
    admPost({ cmd: 'opportunrange', value });
  },
  // 하위 사냥 상한(레벨차) — value 없으면 현재값만 읽는다.
  admHuntUpGet: () => admPost({ cmd: 'huntup' }),
  admHuntUpSet: () => {
    const value = Number($('#admhuntup')?.value);
    if (!Number.isFinite(value)) return;
    admPost({ cmd: 'huntup', value });
  },
  // 떠돌이 진단표 — 라이브 DO 직독(읽기전용).
  admWanderDiag: () => admPost({ cmd: 'wanderdiag' }),
  // 떠돌이 부활 대기(초) — value 없으면 현재값만 읽는다.
  admRespawnSecsGet: () => admPost({ cmd: 'respawnsecs' }),
  admRespawnSecsSet: () => {
    const value = Number($('#admrespawnsecs')?.value);
    if (!Number.isFinite(value) || value <= 0) return;
    admPost({ cmd: 'respawnsecs', value });
  },
  // UNI-Q127 자동 강화 단계 간격(ms) — value 없으면 현재값만 읽는다.
  admAutoEnhanceStepGet: () => admPost({ cmd: 'autoenhancestep' }),
  admAutoEnhanceStepSet: () => {
    const value = Number($('#admautoenhancestep')?.value);
    if (!Number.isFinite(value) || value <= 0) return;
    admPost({ cmd: 'autoenhancestep', value });
  },
  admClaimGapGet: () => admPost({ cmd: 'claimgap' }),
  admClaimGapSet: () => {
    const value = Number($('#admclaimgap')?.value);
    if (!Number.isFinite(value) || value < 1) return;
    admPost({ cmd: 'claimgap', value });
  },
  // UNI-V2-PACKGAP — 무리 배회의 정착지 완충 추가 여유(타일). value 없으면 현재값만 읽는다.
  admPackGapGet: () => admPost({ cmd: 'packgap' }),
  admPackGapSet: () => {
    const value = Number($('#admpackgap')?.value);
    if (!Number.isFinite(value) || value < 0) return;
    admPost({ cmd: 'packgap', value });
  },
  admRetreatMaxGet: () => admPost({ cmd: 'retreatmax' }),
  admRetreatMaxSet: () => {
    const value = Number($('#admretreatmax')?.value);
    if (!Number.isFinite(value) || value < 0) return;
    admPost({ cmd: 'retreatmax', value });
  },
  admExploreLegsGet: () => admPost({ cmd: 'explorelegs' }),
  admExploreLegsSet: () => {
    const value = Number($('#admexplorelegs')?.value);
    if (!Number.isFinite(value) || value < 0) return;
    admPost({ cmd: 'explorelegs', value });
  },
  admSwarmMinGet: () => admPost({ cmd: 'swarmmin' }),
  admSwarmMinSet: () => {
    const value = Number($('#admswarmmin')?.value);
    if (!Number.isFinite(value) || value < 1) return;
    admPost({ cmd: 'swarmmin', value });
  },
  /** UNI-Q161 초당 피해 설정값 — 값 없이 부르면 현재값만 읽는다 */
  admDpsGet: () => admPost({ cmd: 'dps' }),
  admDpsSet: () => {
    const windowSecs = Number($('#admdpswin')?.value);
    const topN = Number($('#admdpstop')?.value);
    if (!Number.isFinite(windowSecs) || !Number.isFinite(topN)) return;
    admPost({ cmd: 'dps', windowSecs, topN });
  },
  admDpsSandbag: (on) => admPost({ cmd: 'dps', sandbagOn: !!on }),
  admDpsKeep: (on) => admPost({ cmd: 'dps', keep: !!on }),
  // 쓰러진 떠돌이 일괄 부활 — 라이브 인구 즉시 복구.
  admReviveWanderers: () => admPost({ cmd: 'reviveall' }),
  admRaceUseGet: () => admPost({ cmd: 'raceuse' }),
  admLotteryGet: () => admPost({ cmd: 'lottery' }),
  admBlackjackGet: () => admPost({ cmd: 'blackjack' }),
  admBlackjackSave: () => saveBlackjackControl(),
  admBlackjackAddPool: () => {
    const v = Math.floor(Number($('#admbjaddpool')?.value));
    if (!Number.isFinite(v) || v < 1) return;
    if (!confirm(`경주·복권·블랙잭·슬롯 공동 기금에 ${v.toLocaleString()} 은화를 운영 발행으로 보탠다. 맞나?`)) return;
    admPost({ cmd: 'blackjack', addPool: v });
  },
  admLotteryBatchSet: () => admPost({ cmd: 'lottery', orderMax: Number($('#admlotbatch')?.value) }),
  admLotteryReplay: () => {
    if (!confirm('최신 복권 결과 팡파레를 모든 접속자에게 다시 방송한다. 당첨금은 재지급되지 않는다. 진행할까?')) return;
    admPost({ cmd: 'lottery', replay: true });
  },
  admRaceUseDraft: (v) => { S.adm.raceUseDraft = Number(v); },
  admRaceUseQuick: (v) => {
    S.adm.raceUseDraft = Number(v);
    const input = $('#admraceuse');
    if (input) input.value = String(v);
  },
  admRaceUseSet: () => {
    const cfg = S.adm.raceUse;
    const input = $('#admraceuse');
    const multiplier = Number(input?.value ?? S.adm.raceUseDraft);
    if (!cfg || !Number.isFinite(multiplier) || multiplier < Number(cfg.min)) return;
    if (!confirm(`슬라임 경주 누적 상금 활용 배율 ×${multiplier} 적용을 확정한다. 맞나?`)) return;
    admPost({ cmd: 'raceuse', multiplier });
  },
  /** DB 검색은 서버가 **가린 뒤** 보이는 값에만 건다. */
  admDbTable: (v) => {
    S.adm.dbTable = String(v || 'characters'); S.adm.dbPage = 0;
    admPost({ cmd: 'db', table: S.adm.dbTable, q: S.adm.dbQ });
  },
  admDbQ: (v) => { S.adm.dbQ = String(v || ''); },
  admDb: () => admPost({ cmd: 'db', table: S.adm.dbTable, q: S.adm.dbQ }),
  admDbSort: (v) => { S.adm.dbSort = String(v || ''); S.adm.dbPage = 0; redrawAdmin(); },
  admDbDesc: () => { S.adm.dbDesc = !S.adm.dbDesc; S.adm.dbPage = 0; redrawAdmin(); },
  admDbPage: (d) => { S.adm.dbPage = Math.max(0, S.adm.dbPage + Math.sign(Number(d) || 0)); redrawAdmin(); },
  /**
   * ── 지우기 두 걸음 ──
   * 첫 걸음은 **아무것도 안 지운다** — 서버가 값을 돌려주고 화면이 그것을 그린다.
   * 값을 못 받으면 두 번째 버튼이 아예 안 생긴다(`delSec`).
   */
  /** 칸만 바뀐다 — 서버를 안 탄다 */
  admName: (v) => { S.adm.name = v; },
  /**
   * 이름으로 고른다. ⚠ **고르는 것과 조회는 한 번에** 한다 —
   * 고르기만 하면 값이 빈 절이 뜨고, 사람은 그것을 *"그 사람이 없다"* 로 읽는다.
   */
  admByName: () => {
    const nm = (S.adm.name || '').trim();
    if (!nm) return;
    S.adm.offlineSearchQ = '';
    S.adm.offlineSearchRows = null;
    S.adm.sel = nm; S.adm.who = null; S.adm.skills = null; S.adm.del = null;
    admPost({ cmd: 'who', name: nm });
    admPost({ cmd: 'skills', name: nm });
  },
  /** 오프라인 캐릭터는 이름 전체를 몰라도 서버의 안전한 최소 결과에서 고른다. */
  admOfflineSearch: () => {
    const q = (S.adm.name || '').trim();
    if (!q) return;
    S.adm.offlineSearchQ = q;
    S.adm.offlineSearchRows = null;
    redrawAdmin();
    admPost({ cmd: 'offlineSearch', q });
  },
  admPickOffline: (name) => {
    const nm = String(name || '').trim();
    if (!nm) return;
    S.adm.name = nm;
    S.adm.sel = nm; S.adm.who = null; S.adm.skills = null; S.adm.del = null;
    admPost({ cmd: 'who', name: nm });
    admPost({ cmd: 'skills', name: nm });
    redrawAdmin();
  },
  /** 콘솔 2단 메뉴 — 클라 상태만 바꾼다. 서버 안 탄다 */
  admControlFilter: (v) => filterAdminControls(v),
  admControlChanged: (v) => filterAdminControls(S.adm.controlQuery, v),
  admControlDefaults: () => restoreAdminControl($('#admrestoregroup')?.value),
  admControlUndo: () => undoAdminControl(),
  admRealtyGet: () => admPost({ cmd: 'realty' }),
  admRealtyAdminGet: () => admPost({ cmd: 'realtyAdmin', op: 'list' }),
  admRealtyAdmin: (op, propertyId) => {
    const id = String(propertyId);
    const val = (k) => { const el = document.getElementById(`admra-${k}-${id}`); return el ? el.value : undefined; };
    if (op === 'setPrice') admPost({ cmd: 'realtyAdmin', op, propertyId: id, salePrice: val('sale'), rentDaily: val('rent') });
    else if (op === 'setListed') admPost({ cmd: 'realtyAdmin', op, propertyId: id, listed: document.getElementById(`admra-listed-${id}`)?.checked ? 1 : 0 });
    else if (op === 'setOwner') admPost({ cmd: 'realtyAdmin', op, propertyId: id, ownerName: val('owner') ?? '' });
  },
  admRealtySave: () => saveRealtyControl(),
  admTab: (v, category, mode) => {
    const tab = String(v || 'overview');
    if (mode === 'refresh') refreshAdminCategory(tab, String(category || ''));
    else if (category) selectAdminCategory(tab, String(category));
    else selectAdminTab(tab);
  },
  /** RANK-HIDE-R1 — 상태를 안 들고 서버가 DB 기준으로 뒤집는다(동시 클릭 안전) */
  admRankHide: () => { if (S.adm.sel) admPost({ cmd: 'rankHide', name: S.adm.sel }); },
  admDelAsk: () => { if (S.adm.sel) admPost({ cmd: 'del', name: S.adm.sel }); },
  admDelCancel: () => { S.adm.del = null; redrawAdmin(); },
  /** ⚠ 여기서만 `confirm: true` 가 나간다. 그 전에는 어떤 경로로도 안 지워진다 */
  admDelGo: () => {
    const d = S.adm.del;
    if (!d || !d.lines || !d.lines.length) return;
    admPost({ cmd: 'del', name: d.name, confirm: true });
  },
  admPick: (name) => {
    S.adm.sel = name; S.adm.who = null; S.adm.skills = null;
    admPost({ cmd: 'who', name });
    // UNI-Q292 — 사냥터 서버가 쥔 원주민 줄(자리 사진뿐 · 원천 몸 없음)은 스킬을 묻지 않는다(묻으면 「캐릭터가 없다」 붉은 줄만 남는다)
    const row = (S.adm.rows || []).find((r) => r.name === name);
    if (!(row?.server === 'native' && row?.runtime === 'wanderer')) admPost({ cmd: 'skills', name });
    redrawAdmin();
  },
  admSkill: (kind, id, rawRank) => {
    const rank = Math.floor(Number(rawRank));
    if (!S.adm.sel || !Number.isFinite(rank)) return;
    const list = kind === 'active' ? S.adm.skills?.active
      : kind === 'passive' ? S.adm.skills?.passive
      : kind === 'levelpassive' ? S.adm.skills?.levelpassive
      : S.adm.skills?.imprint;
    const skill = list?.find((x) => x.id === id);
    const stage = (kind === 'active' || kind === 'levelpassive') ? `+${rank}` : `Lv${rank}`;
    if (!skill || rank === skill.rank) return;
    if (!confirm(`${S.adm.sel} — ${skill.name} 단계 변경: ${stage}. 이 값으로 저장한다. 맞나?`)) {
      redrawAdmin();
      return;
    }
    admPost({ cmd: 'skillset', name: S.adm.sel, kind, id, rank });
  },
  /** 10-21 사용자 지시 — 「모든 스킬 최대치로」(DESIGN 14.604 · 일반 스킬 +끝 · 서적·각인 Lv끝 — 절대값이라 두 번 눌러도 한 번과 같다) */
  admSkillAll: () => {
    if (!S.adm.sel) return;
    const ends = S.adm.skills?.ends ?? {};
    if (!confirm(`${S.adm.sel} — 모든 스킬을 최대치로 맞춘다(배운 직업 스킬 · 레벨 패시브 +${Number(ends.skill) || 100} · 패시브 서적 · 각인 Lv${Number(ends.book) || 10}). 포인트를 쓰는 단계는 올린 만큼 보너스 포인트를 같이 준다. 맞나?`)) return;
    admPost({ cmd: 'skillsetAll', name: S.adm.sel });
  },
  /** 은화 지급 — 큰 수는 되돌릴 수 없으니 한 번 묻는다 */
  admSilver: (vault = false) => {
    const el = $('#admsilver');
    const n = adminAmountText(el?.value);
    if (!S.adm.sel || n === null) return;
    // 10-20 — 계정 창고로(접속·자리와 무관) — 큰 수는 같은 문턱으로 한 번 묻는다
    if (vault === true) {
      if (n > 10000 && !confirm(`은화 ${n.toLocaleString()} — ${S.adm.sel} 의 계정 창고에 넣는다. 맞나?`)) return;
      admPost({ cmd: 'silver', name: S.adm.sel, n, to: 'vault' });
      return;
    }
    // ⚠ 값 뒤에 조사를 고정으로 붙이지 않는다(`을`/`를` 이 받침에 따라 갈린다).
    //    `josa()` 는 서버(`src/game/josa.ts`)에만 있고 클라 미러가 없어서,
    //    **조사가 안 붙는 문장으로 쓴다** — 미러를 하나 더 만드는 것보다 싸다
    if (n > 10000 && !confirm(`은화 ${n.toLocaleString()} — ${S.adm.sel} 에게 준다. 맞나?`)) return;
    admPost({ cmd: 'silver', name: S.adm.sel, n });
  },
  /** 왕도 금고 → 떠돌이 은화. 일반 관리자 은화 지급과 별도 receipt를 쓴다. */
  admRoyalGrant: () => {
    const el = $('#admroyalsilver');
    const n = adminAmountText(el?.value);
    if (!S.adm.sel || S.adm.who?.runtime !== 'wanderer' || n === null) return;
    if (n > 10000 && !confirm(`왕도 금고에서 은화 ${n.toLocaleString()} — ${S.adm.sel}에게 지급한다. 맞나?`)) return;
    admPost({ cmd: 'royalGrant', name: S.adm.sel, n, receipt: crypto.randomUUID() });
  },
  /** **내가 그 사람에게 간다.** `tp`(그 사람을 옮긴다)와 방향이 반대다 */
  admGoto: () => { if (S.adm.sel) admPost({ cmd: 'goto', name: S.adm.sel }); },
  admWho: () => { if (S.adm.sel) admPost({ cmd: 'who', name: S.adm.sel }); },
  admItem: (v) => { S.adm.item = v; },
  admRelic: (v) => { S.adm.relic = String(v || ''); redrawAdmin(); },
  admGiveRelic: () => {
    if (!S.adm.sel || !S.adm.relic) return;
    const relic = S.adm.items.find((x) => x.key === S.adm.relic && x.kind === 'relic');
    if (!relic || !confirm(`${S.adm.sel} 에게 ${relic.name} 1개를 지급한다. 맞나?`)) return;
    admPost({ cmd: 'give', name: S.adm.sel, item: relic.key, n: 1 });
  },
  admAppearance: (gender) => {
    if (!S.adm.sel || !['male', 'female'].includes(gender)) return;
    const label = gender === 'female' ? '여성' : '남성';
    if (!confirm(`${S.adm.sel}의 다음 접속 외형: ${label}. 이 값으로 저장한다. 맞나?`)) return;
    admPost({ cmd: 'appearance', name: S.adm.sel, gender });
  },
  admN: (v) => { S.adm.n = String(v); },
  admGive: (vault = false) => {
    const { sel } = S.adm;
    // **보이는 칸의 값으로 준다.** 따로 저장한 값만 믿으면 화면에 보이는 물건과 보내는 물건이 갈린다
    const item = $('#admitem')?.value || S.adm.item;
    const n = adminAmountText($('#admn')?.value ?? S.adm.n);
    if (!sel || n === null) return;
    if (!item) { toast('줄 물건을 먼저 골라 달라.'); return; }
    // 큰 수는 한 번 더 묻는다 — 0 하나 더 치면 경제가 흔들린다
    // 10-20 — 「창고에 넣기」는 계정 창고로(접속·자리와 무관)
    if (vault === true) {
      if (n > 100 && !confirm(`${sel} 의 계정 창고에 ${n} 개를 넣는다. 맞나?`)) return;
      admPost({ cmd: 'give', name: sel, item, n, to: 'vault' });
      return;
    }
    if (n > 100 && !confirm(`${sel} 에게 ${n} 개를 준다. 맞나?`)) return;
    admPost({ cmd: 'give', name: sel, item, n });
  },
  admTown: () => { if (S.adm.sel) admPost({ cmd: 'tp', name: S.adm.sel, town: true }); },
  admTp: () => {
    const x = Number(($('#admx') || {}).value), y = Number(($('#admy') || {}).value);
    if (!S.adm.sel || !Number.isFinite(x) || !Number.isFinite(y)) return;
    admPost({ cmd: 'tp', name: S.adm.sel, x, y });
  },
  admClean: () => {
    const sel = S.adm.sel;
    if (!sel) return;
    if (!confirm(`${sel} 의 잡템을 전부 버린다. 장비는 안 건드린다. 맞나?`)) return;
    admPost({ cmd: 'clean', name: sel });
  },
  /** 여러 칸을 고쳐도 **사용자가 실제로 바꾼 절대값만** 보낸다. */
  admSet: () => {
    const sel = S.adm.sel;
    if (!sel) return;
    const edits = {};
    for (const el of document.querySelectorAll('#admbody .admfield input[data-key]')) {
      if (el.value === '') continue;
      if (el.dataset.key === 'silver') {
        const value = adminAmountText(el.value, 0);
        if (value === null) return;
        if (Number(value) !== Number(el.dataset.initial)) edits.silver = value;
      } else {
        const n = Math.floor(Number(el.value));
        if (Number.isFinite(n) && n !== Number(el.dataset.initial)) edits[el.dataset.key] = n;
      }
    }
    const entries = Object.entries(edits);
    if (!entries.length) return;
    const labels = entries.map(([k, v]) => {
      const f = S.adm.fields.find((x) => x.key === k);
      return `${f?.label || k} ${v.toLocaleString()}`;
    }).join(' · ');
    if (!confirm(`${sel} — ${labels}\n이 최종값으로 바꾼다. 맞나?`)) return;
    admPost({ cmd: 'set', name: sel, edits });
  },
  // 부위·등급이 바뀌면 종류 표가 갈린다 — 옛 선택을 남기면 없는 이름을 보낸다
  admGearSlot: (v) => { S.adm.gearSlot = String(v || ''); S.adm.gearKind = ''; S.adm.gearRing = ''; redrawAdmin(); },
  admGearGrade: (v) => {
    S.adm.gearGrade = Math.max(0, Math.floor(Number(v) || 0));
    S.adm.gearKind = '';
    redrawAdmin(); // 궁극을 고르면 +10 위 서버 상한이 입력칸에 즉시 열린다
  },
  admGearPlus: (v) => { S.adm.gearPlus = Math.max(0, Math.floor(Number(v) || 0)); },
  admGearBlessed: (v) => { S.adm.gearBlessed = !!v; },
  admGearRolled: (v) => { S.adm.gearRolled = !!v; },
  admGearKind: (v) => { S.adm.gearKind = String(v || ''); },
  /** UNI-Q52 — 반지 종류. 고르면 확인 문구가 바뀌므로 다시 그린다 */
  admGearRing: (v) => { S.adm.gearRing = String(v || ''); redrawAdmin(); },
  /** 굴림 수치 — 넣으면 굴림 장비가 된다(체크박스가 잠기며 켜진다). 지우면 원상 */
  admGearQ: (v) => { const n = String(v || '').trim(); S.adm.gearQ = n === '' ? '' : String(Math.max(55, Math.min(100, Math.floor(Number(n) || 55)))); redrawAdmin(); },
  admGearWear: (v) => { S.adm.gearWear = !!v; },
  admGear: () => {
    const a = S.adm;
    if (!a.sel || !a.gearSlot) return;
    const slot = a.gearSlots.find((x) => x.key === a.gearSlot)?.name || a.gearSlot;
    const grade = a.gearGrades.find((x) => x.grade === a.gearGrade)?.name || `${a.gearGrade}등급`;
    /**
     * 반지는 **종류가 곧 물건**이다(맹세의 왕인 / 서약의 반지). 등급·강화만 적으면
     * 무엇을 주는지 확인 창이 말하지 못한다 — 종류를 이름 자리에 놓는다.
     */
    const ring = a.gearSlot === 'ring' ? a.ringProducts.find((r) => r.key === a.gearRing) : null;
    if (a.gearSlot === 'ring' && !ring) { alert('반지는 종류를 골라야 한다 — 종류 없는 반지는 아무 능력도 주지 않는다.'); return; }
    const label = `${grade} ${ring ? ring.name : slot}${a.gearKind ? ` 〈${a.gearKind}〉` : ''}${a.gearPlus ? ` +${a.gearPlus}` : ''}${a.gearBlessed ? ' ★' : ''}`
      + (ring ? (ring.bind ? ' · 계정 귀속' : ' · 고정 성능')
        : a.gearQ !== '' ? ` · 굴림 ${a.gearQ}` : a.gearRolled ? ' · 랜덤 굴림' : ' · 고정 성능');
    if (!confirm(`${a.sel} — ${label}${a.gearWear ? ' 바로 착용' : ' 가방에 지급'}한다. 맞나?`)) return;
    admPost({ cmd: 'gear', name: a.sel, slot: a.gearSlot, grade: a.gearGrade,
      plus: a.gearPlus, blessed: a.gearBlessed, rolled: !ring && a.gearRolled, wear: a.gearWear,
      // 굴림·종류 지정 — 빈 값은 안 보낸다(현행 유지). 검증은 서버 makeGear 가 한다
      ...(!ring && a.gearQ !== '' ? { q: Number(a.gearQ) } : {}),
      ...(a.gearKind ? { kind: a.gearKind } : {}),
      ...(a.gearRing ? { ring: a.gearRing } : {}) });
  },
  admSupportRef: (v) => {
    S.adm.supportRef = String(v || '').slice(0, 80);
    // 입력 중 전체 화면을 다시 그리면 한글 조합과 커서가 끊긴다. 확정 버튼만 갱신한다.
    const button = document.querySelector('#admbody .supportgift button:last-of-type');
    if (button) button.disabled = !supportGiftReady(S.adm);
  },
  /**
   * 받을 게임 닉네임 — 후원 섹션 **자체** 입력이다. 예전엔 분리된 목록에서 캐릭터를
   * 먼저 골라야(`sel`) 버튼이 풀려, 섹션의 유일한 입력칸(메모)에 닉네임을 적은 운영자의
   * 버튼이 영영 안 풀렸다(실유저 후원 지급 실패, 2026-09-04). 서버가 닉네임을 직접
   * 해석하므로(charSnapshot) 사전 선택이 필요 없다. 한글 조합이 끊기지 않게 재렌더 대신
   * 버튼만 갱신한다.
   */
  admSupportName: (v) => {
    S.adm.supportName = String(v || '').slice(0, 40);
    const button = document.querySelector('#admbody .supportgift button:last-of-type');
    if (button) button.disabled = !supportGiftReady(S.adm);
  },
  admSupportGift: async () => {
    const a = S.adm;
    const reference = a.supportRef.trim();
    const name = a.supportName.trim();
    if (!supportGiftReady(a)) return;
    // R122 — 보상은 후원자 칭호 하나다(장비·은화 없음 · 세계마다 다시 주지 않는다)
    if (!confirm(`${name}의 계정에 후원자 칭호 〈후원자〉를 연다(전투력·장비·은화 없음).\n\n입금 내역과 닉네임을 확인했으며, 이 확인 건은 다시 기록할 수 없다. 맞나?`)) return;
    a.supportSending = true; redrawAdmin();
    const j = await admPost({ cmd: 'supportgift', name, reference });
    const failed = (j.logs || []).some((l) => l.bad);
    if (!failed) {
      a.supportRef = ''; a.supportName = '';
      await admPost({ cmd: 'supporthistory' });
    }
    a.supportSending = false; redrawAdmin();
  },
  admAnnouncement: (v) => {
    S.adm.announcement = String(v || '').slice(0, 200);
    const n = $('#admanncount'); if (n) n.textContent = `${S.adm.announcement.length}/200자`;
  },
  admAnnounce: async () => {
    const text = S.adm.announcement.trim();
    if (!text || !confirm(`전체 공지:\n\n${text}\n\n보낸다. 맞나?`)) return;
    const j = await admPost({ cmd: 'announce', text });
    if (!(j.logs || []).some((l) => l.bad)) { S.adm.announcement = ''; redrawAdmin(); }
  },
  admAirdropText: (v) => { S.adm.airdropText = String(v || '').slice(0, 200); },
  admAirdropKind: (v) => {
    S.adm.airdropKind = v === 'item' ? 'item' : 'silver';
    S.adm.airdropN = S.adm.airdropKind === 'item' ? 1 : 1000;
    redrawAdmin();
  },
  admAirdropItem: (v) => { S.adm.airdropItem = String(v || ''); },
  admAirdropN: (v) => { S.adm.airdropN = String(v); },
  admAirdrop: async () => {
    const a = S.adm;
    const text = a.airdropText.trim();
    const n = adminAmountText($('#admairn')?.value ?? a.airdropN);
    const item = $('#admairitem')?.value || a.airdropItem;
    if (!text || n === null) return;
    const gift = a.airdropKind === 'item'
      ? `${S.adm.items.find((x) => x.key === item)?.name || item} ${n.toLocaleString()}개`
      : `은화 ${n.toLocaleString()}`;
    const body = { cmd: 'airdrop', text, kind: a.airdropKind, item, n };
    const previous = await currentAirdropSubmission(body);
    let separate = false;
    if (previous) {
      if (previous.status?.state === 'none' || previous.status?.state === 'unknown') {
        if (confirm(`이전 에어드롭의 접수·완료를 확인하지 못했습니다.\n\n공지: ${text}\n선물: ${gift}\n\n확인하면 새 지급 번호를 만들지 않고 원래 요청을 다시 전달합니다. 이미 지급된 몫은 중복 지급하지 않습니다. 원래 요청을 다시 전달할까요?`)) {
          await admPost(previous.body);
          return;
        }
        separate = confirm(`앞선 에어드롭의 결과가 불확실합니다. 같은 내용의 별도 새 행사를 만들면 중복 지급될 수 있습니다.\n\n정말 별도 행사를 추가로 지급할까요?`);
        if (!separate) return;
      } else {
        separate = confirm(`같은 내용의 이전 에어드롭은 아직 결과를 확인 중입니다. 다시 누르면 별도의 새 행사가 되어 중복 지급될 수 있습니다.\n\n공지: ${text}\n선물: ${gift}\n\n정말 별도 행사를 추가로 지급할까요? 취소하면 이전 지급 상태만 다시 확인합니다.`);
        if (!separate) {
          await admPost({ cmd: 'grantStatus', intent: previous.body }, { quiet: true });
          return;
        }
      }
    } else if (!confirm(`현재 접속한 사람에게 에어드롭을 지급합니다. NPC·원주민은 제외합니다.\n\n공지: ${text}\n선물: ${gift}\n\n지급 결과는 자동 확인하고 공지는 완료 뒤에 뜹니다. 지급할까요?`)) return;
    await admPost(body, { newGrantIntent: true, separateGrantIntent: separate });
  },
  stat: (key, amount = 1) => send({ t: 'stat', key, amount: Number(amount) === 7 ? 7 : 1 }),
  rename: async () => {
    if (pendingWrite('rename')) { window.act.renameRetry(); return; }
    const charId = S.charId, session = S.session, token = S.token, worldN = S.world?.n, socket = S.ws;
    const expectedName = S.you?.name, cost = inv.renameCost(S.you);
    const ready = () => S.charId === charId && S.session === session && S.token === token && S.world?.n === worldN
      && S.ws === socket && S.connected && socket?.readyState === 1
      && S.you?.name === expectedName && inv.renameCost(S.you) === cost && !(S.you?.dead > 0)
      && nativeActionAllowed('rename') && canAct(where(S.you), 'rename', S.you);
    if (!charId || !session || !token || !Number.isSafeInteger(worldN) || worldN < 1
      || !expectedName || cost === null || !ready()) {
      log('마을에서 연결과 변경 비용을 확인한 뒤 다시 눌러 달라.', 'info'); return;
    }
    if (renameConfirm?.charId === charId && renameConfirm.session === session && renameConfirm.socket === socket) return;
    const confirmation = { charId, session, socket };
    renameConfirm = confirmation;
    try {
      const input = await askText(`새 닉네임을 입력해 달라. (1~12자)\n변경 비용 ${cost.toLocaleString()} 은화`, null,
        { value: expectedName, maxLength: 12, ok: '다음' });
      if (input === null) return;
      if (!ready()) { log('변경 조건이 바뀌었다. 현재 이름과 비용을 확인한 뒤 다시 눌러 달라.', 'info'); return; }
      const name = input.trim();
      if (!name || name.length > 12) { log('닉네임은 1~12자로 입력해 달라.', 'info'); return; }
      if (name === expectedName) { log('지금과 다른 닉네임을 입력해 달라.', 'info'); return; }
      if (/[<>&"'`]/.test(name)) { log('이름에 쓸 수 없는 문자가 있다. 다른 이름을 입력해 달라.', 'info'); return; }
      await askConfirm(`닉네임을 「${expectedName}」에서 「${name}」로 바꿀까?\n${cost.toLocaleString()} 은화는 소지금부터, 부족분은 창고에서 쓴다.`, () => {
        if (!ready()) { log('변경 조건이 바뀌었다. 현재 이름과 비용을 확인한 뒤 다시 눌러 달라.', 'info'); return; }
        if (pendingWrite('rename')) { window.act.renameRetry(); return; }
        const command = { t: 'rename', name, expectedName, requestId: crypto.randomUUID(), worldN };
        if (!savePendingWrite('rename', command, { action: 'rename' })) {
          log('요청을 보관하지 못했다. 다시 접속한 뒤 시도해 달라.', 'bad'); return;
        }
        S.renameBusy = command.requestId;
        S.renameNotice = '이름 변경 결과를 확인 중이다.';
        if (send(command) !== true) {
          if (clearPendingWrite('rename', command.requestId)) {
            S.renameBusy = null;
            S.renameNotice = '요청을 보내지 못했다. 연결을 확인한 뒤 다시 눌러 달라.';
          } else S.renameNotice = '연결을 복구한 뒤 이름 변경 결과를 다시 확인해 달라.';
        }
        armPendingWrite('rename', send);
        render(true);
      }, { ok: '이름 바꾸기', danger: true });
    } finally { if (renameConfirm === confirmation) renameConfirm = null; }
  },
  renameRetry: () => {
    const row = pendingWrite('rename');
    if (!row) return;
    S.renameBusy = row.requestId;
    S.renameNotice = checkPendingWrite('rename', send, true)
      ? '원래 이름 변경 결과를 다시 확인 중이다.'
      : '연결을 복구한 뒤 결과를 다시 확인해 달라.';
    render(true);
  },
  appearance: (gender) => {
    if (!['male', 'female'].includes(gender)) return;
    const label = gender === 'female' ? '여성' : '남성';
    askConfirm(`다음 접속부터 ${label} 외형으로 바꾼다. 직업과 능력치는 그대로다. 진행할까?`, () => send({ t: 'appearance', gender }), { ok: '바꾼다' });
  },
  appearanceReload: () => {
    askConfirm('저장한 외형을 적용하려고 지금 재접속할까?', () => location.reload(), { ok: '재접속' });
  },
  statReset: (spent, cost) => {
    const points = Math.max(0, Math.floor(Number(spent) || 0));
    const silver = Math.max(0, Math.floor(Number(cost) || 0));
    if (!points || !silver) return;
    askConfirm(`투자한 스탯 ${points.toLocaleString()}점을 모두 초기화한다.\n비용 ${silver.toLocaleString()} 은화는 소지금부터, 부족분은 창고에서 사용한다.\n\n진행할까?`,
      () => send({ t: 'statReset' }), { ok: '초기화한다', danger: true });
  },
  /**
   * UNI-Q222 각성 — **되돌릴 수 없는 교환이라 두 번 묻는다.**
   * 버튼 한 번에 일생이 사라지면 안 된다(스킬→스탯 교환과 같은 이유, 거기보다 무겁다).
   */
  awakenForge: () => {
    const soul = S.you?.soul;
    if (!soul || soul.made || !inv.soulCostKnown(soul)) {
      log('영혼석 교환 조건을 확인한 뒤 다시 눌러 달라.', 'info'); return;
    }
    const charId = S.charId, session = S.session, token = S.token, worldN = S.world?.n, socket = S.ws;
    if (!charId || !session || !token || !(worldN > 0) || !S.connected || socket?.readyState !== 1) {
      log('연결을 확인한 뒤 영혼석 교환을 다시 눌러 달라.', 'info'); return;
    }
    if (forgeConfirm?.charId === charId && forgeConfirm.session === session && forgeConfirm.socket === socket) return;
    const life = soul.lifeCost, silver = soul.silverCost;
    const pending = { charId, session, socket };
    forgeConfirm = pending;
    askConfirm(`생명의 돌 ${life.toLocaleString()}개와 ${silver.toLocaleString()} 은화로 영혼석을 만든다.\n은화는 소지금부터, 부족분은 창고에서 쓴다.\n\n진행할까?`, () => {
      const current = S.you?.soul;
      if (S.charId !== charId || S.session !== session || S.token !== token || S.world?.n !== worldN
        || S.ws !== socket || !S.connected || socket.readyState !== 1
        || !current || current.made || !inv.soulCostKnown(current)
        || current.lifeCost !== life || current.silverCost !== silver) {
        log('영혼석 교환 조건이 바뀌었다. 현재 값을 확인한 뒤 다시 눌러 달라.', 'info'); return;
      }
      send({ t: 'awakenForge' });
    }, { ok: '만든다' }).finally(() => { if (forgeConfirm === pending) forgeConfirm = null; });
  },
  awakenFeed: (level) => {
    const lv = Math.max(0, Math.floor(Number(level) || 0));
    if (lv <= 1) return;
    // 두 번 묻는다 — 첫 창을 확인해야 둘째 창이 뜨고, 둘째까지 확인해야 보낸다
    askConfirm(`영혼석에 Lv${lv.toLocaleString()} 일생어치의 경험치를 넣는다 (지금까지 모은 전부).\n이 캐릭터는 레벨 1로 돌아가고 찍어 둔 스탯·스킬 강화도 처음으로 돌아간다 — 장비와 집은 그대로다.\n각성은 세계마다 한 번이다.\n\n되돌릴 수 없다. 진행할까?`,
      () => askConfirm('정말 바칠까? 이 몸의 레벨은 사라진다.', () => send({ t: 'awakenFeed' }), { ok: '바친다', danger: true }), { ok: '다음', danger: true });
  },
  skillUp: (id) => send({ t: 'skillUp', id }),
  levelPassiveUp: (id) => send({ t: 'levelPassiveUp', id }),
  // EXCHANGE-R1 — 확인창: 되돌릴 수 없는 교환이라 한 번 묻는다
  skillToStat: () => askConfirm('스킬 포인트 1개를 보너스 스탯 12로 바꾼다. 되돌릴 수 없다.', () => send({ t: 'skillToStat' }), { ok: '바꾼다', danger: true }),
  autoSkill: (id, on) => send({ t: 'autoSkill', id, on: !!on }),
  // 관리자 전용. 서버가 다시 판정하므로 이 호출을 흉내 내도 소용없다
  // DESIGN 14.601 ⑮ — through the console's `set` (the game server holds the body in 2.0; the old socket `grant` had no route there —
  //   「마을에서 아직 쓸 수 없는 행동이다」). The server re-checks the admin either way.
  grant: (n) => admPost({ cmd: 'set', name: S.you?.name, edits: { bonusStat: Math.max(0, Math.floor(Number(S.you?.inv?.bonusStat) || 0)) + Number(n) } }),
  read: (id) => send({ t: 'read', id }),
  imprintRead: (id) => send({ t: 'imprintRead', id }),
  imprintEquip: (id) => send({ t: 'imprintEquip', id }),
  bossTitle: (id) => send({ t: 'bossTitle', id }),
  breakdown: (id) => send({ t: 'breakdown', id }),
  /**
   * 대장간 모두 분해(14.493). 개수·예상 재료는 `forge.breakdownPlan` 한 자리에서 — 버튼의 N 과 같은 판정이다.
   * 되돌릴 수 없는 일이라 한 번 묻는다(「취소」에 먼저 손이 간다). 서버가 같은 판정으로 다시 골라 한 번에 분해하고
   * 한 번 저장한다 — 실제 개수·재료는 서버 문장이 말한다.
   */
  breakdownAll: () => {
    const plan = forge.breakdownPlan(S.you);
    if (!plan.ready.length) { toast('분해할 +0 장비가 없다.', 'bad'); return; }
    askConfirm(forge.breakdownAllQuestion(plan), () => {
      // 분해될 장비를 골라 둔 강화 선택은 비운다 — 사라진 장비가 선택칸에 남지 않게
      const gone = new Set(plan.ready.map((e) => e.id));
      S.forgeSel = S.forgeSel.filter((id) => !gone.has(id));
      send({ t: 'breakdownAll' });
    }, { ok: `${plan.ready.length.toLocaleString()}개 분해`, danger: true });
  },
  forge1: (id) => send({ t: 'forge', ids: [id] }),
  forgeAll: (id) => send({ t: 'forgeAll', id }),
  enhance: (id) => send({ t: 'enhance', id }),
  autoEnhance: (id, target) => send({ t: 'autoEnhance', id, target }),
  autoEnhanceAll: (id) => send({ t: 'autoEnhance', id, target: null }),
  autoEnhanceStop: () => send({ t: 'autoEnhanceStop' }),
  autoEnhanceDismiss: () => { S.autoEnhance = null; render(true); },
  bless: (id) => send({ t: 'bless', id }),
  /**
   * 연금술사 (UNI-ALCHEMY §7). 서버가 재료·비용·판정의 정본이고 화면은 요청만 보낸다 —
   * 여기서 수량이나 확률을 다시 계산하면 그 순간 두 곳이 갈라진다.
   */
  /** 연금술은 은화·강화석을 쓰는 계정 FIFO 행동이다. 영수증이 확정될 때까지 같은 ID를 보관한다. */
  alchemyAction: (kind, body) => {
    if (pendingWrite('alchemy')) { checkPendingWrite('alchemy', send, true); return; }
    if (S.alchemyBusy) return;
    if (!S.ws || S.ws.readyState !== 1) { toast('서버 연결이 끊겼다. 다시 연결된 뒤 시도해 달라.', 'bad'); return; }
    const worldN = S.world?.n;
    if (!Number.isSafeInteger(worldN) || worldN < 1) { log('세계 정보를 확인한 뒤 연금술을 이용해 달라.', 'bad'); return; }
    const requestId = crypto.randomUUID();
    const command = { ...body, requestId, worldN };
    const auto = kind === 'auto' ? { id: String(body.id), target: Number(body.target) } : null;
    const original = kind === 'reroll' ? S.you?.inv?.equips?.find((e) => e.id === body.id) : null;
    const rerollBefore = original ? { id: original.id, ids: S.you.inv.equips.map((e) => e.id), identity: gearIdentity(original) } : null;
    if (!savePendingWrite('alchemy', command, { action: body.t, kindName: kind, auto, autoStopped: false, rerollBefore })) {
      log('연금 요청 번호를 보관하지 못했다. 요청은 보내지 않았다.', 'bad'); return;
    }
    S.alchemyRequest = requestId;
    S.alchemyBusy = kind;
    S.alchemyAuto = auto;
    if (send(command) !== true) {
      if (clearPendingWrite('alchemy', requestId)) { S.alchemyRequest = null; S.alchemyBusy = null; S.alchemyAuto = null; }
      log('연금 요청을 보내지 못했다. 연결을 확인해 달라.', 'bad'); render(true); return;
    }
    armPendingWrite('alchemy', send); render(true);
  },
  alchemyCount: (value) => { S.alchemyCount = value; render(true); },
  alchemyConvert: (count) => {
    const raw = count ?? S.alchemyCount, n = Number(raw);
    if (n !== -1 && (!/^\d+$/.test(String(raw)) || !Number.isSafeInteger(n) || n < 1)) return;
    window.act.alchemyAction('convert', { t: 'alchemyConvert', count: n });
  },
  alchemyReroll: (id) => window.act.alchemyAction('reroll', { t: 'alchemyReroll', id }),
  alchemyAutoReroll: (id, target) => window.act.alchemyAction('auto', { t: 'alchemyAutoReroll', id, target }),
  alchemyTarget: (v) => { S.alchemyTarget = Number(v); render(true); },
  alchemyClear: () => {
    const row = pendingWrite('alchemy');
    if (row?.auto && !revisePendingWrite('alchemy', row.requestId, { autoStopped: true })) {
      log('자동 굴림 중지 선택을 보관하지 못했다. 연결을 확인해 달라.', 'bad'); return;
    }
    S.alchemyAuto = null; S.alchemySel = null;
    if (S.alchemyBusy === 'auto-next') S.alchemyBusy = null;
    render(true);
  },
  legendarySmith: (op, id) => send({ t: 'legendarySmith', op, id }),
  // DESIGN 14.601 ⑮ — the console's own HTTP path like every other console control (the socket `adm` has no route in the town region)
  admAlchemy: (feature, off) => admPost({ cmd: 'alchemy', feature, off }),
  /**
   * 격자 칸을 누르면 온다. **화면마다 고르는 대상이 다르다** — 가방은 한 칸,
   * 대장간은 최대 두 자루(머지)다. 그래서 키에 접두사를 붙여 갈랐다(`f:` = 대장간).
   * 안 가르면 대장간 격자가 `S.invSel` 을 건드려 **가방의 선택이 조용히 바뀐다.**
   */
  /**
   * 고른 칸은 **그 화면 안에서만** 산다(가방 `invSel`·대장간 `forgeSel`·연금술 `alchemySel`).
   * 전에는 여기서 `gearWorkId` 까지 같이 세워 가방에서 한 번 눌러 본 장비가 상점·창고 위에 붙었고,
   * 지우는 곳이 없어 창을 닫고 다시 들어와도 남았다(2026-10-25 사용자 신고 「안 사라지고 계속 떠 있어」).
   */
  pick: (k) => {
    if (k.startsWith('f:')) return window.act.pickForge(k.slice(2));
    if (k.startsWith('a:')) {
      const id = k.slice(2); S.alchemySel = S.alchemySel === id ? null : id;
      return render(true);
    }
    S.invSel = S.invSel === k ? null : k;
    render(true);
  },
  /**
   * 다른 화면으로 장비를 넘기는 버튼(강화·재추첨·창고·가방 비교). 넘겨받는 창이 자기 선택 칸을 갖고,
   * 창고만 `gearWorkId` 로 받는다. 그 값은 **넘겨받은 창이 열려 있는 동안만** 산다 — `render()` 가
   * 다른 창으로 바뀌면 지우고, 창을 닫으면 `closePanel()` 이 지운다.
   */
  gearWork: (id, destination) => {
    if (!['inv', 'forge', 'alchemy', 'vault'].includes(destination)) return;
    const bag = (S.you?.inv?.equips || []).find((e) => e.id === id);
    const stored = (S.vault?.equips || []).find((e) => e.id === id);
    if (!bag && !stored) { toast('이 장비가 있는 가방·창고를 다시 확인해 달라.', 'bad'); return; }
    if (!bag && destination !== 'vault') {
      toast('장비를 창고에서 가방으로 꺼낸 뒤 이어갈 수 있다.', 'info');
      S.gearWorkId = id; S.gearWorkPanel = 'vault'; togglePanel('vault', true); return;
    }
    S.gearWorkId = destination === 'vault' ? id : null;
    S.gearWorkPanel = S.gearWorkId ? 'vault' : null;
    if (destination === 'inv') { S.invView = 'gear'; S.invSel = id; }
    if (destination === 'forge') S.forgeSel = [id];
    if (destination === 'alchemy') S.alchemySel = id;
    togglePanel(destination, true);
  },
  goForge: (id) => window.act.gearWork(id, 'forge'),
  /** 상점 분류 — 물건을 바로 보여주려면 어느 칸인지 기억해야 한다 */
  shopTab: (t) => { S.shopTab = t; togglePanel('shop', true); },
  accKind: (k) => { S.accKind = String(k || 'all'); render(true); },
  /**
   * 홈 화면에 추가. **사용자가 누른 그 순간에만** prompt() 가 먹는다 —
   * 나중으로 미루거나 자동으로 부르면 브라우저가 조용히 무시한다.
   * 성공하면 버튼이 사라져야 하므로(기회는 1회성) 화면을 다시 그린다.
   */
  install: async () => {
    await promptInstall();
    render(true);
  },
  account: () => togglePanel('account', true),
  authLogout: () => logoutGoogleDevice(),
  logout: () => window.dispatchEvent(new CustomEvent('unige:logout')),
  npc: (id) => {
    const n = NPCS.find((q) => q.id === id);
    if (n) { S.npcLine = n; togglePanel(n.panel, true); }
  },
  pickForge: (id) => {
    const i = S.forgeSel.indexOf(id);
    if (i >= 0) S.forgeSel.splice(i, 1);
    else { S.forgeSel.push(id); if (S.forgeSel.length > 2) S.forgeSel.shift(); }
    render(true);
  },
  // 창고 아래 띠의 [닫기] — 살펴본 장비를 내려놓을 길이 없으면 띠가 계속 남는다
  gearWorkClear: () => { S.gearWorkId = null; S.gearWorkPanel = null; render(true); },
  merge: () => { send({ t: 'forge', ids: S.forgeSel.slice() }); render(true); },
  ascend: () => { send({ t: 'ascend', ids: S.forgeSel.slice() }); render(true); },
  // 실행 바의 [해제] — 고른 것을 무를 길이 없으면 잘못 고른 사람은 갇힌다
  clearForge: () => { S.forgeSel = []; render(true); },
  /**
   * 은화 입출고. `qty === -1` 이면 넣을 수 있는 **전부**.
   *
   * `prompt()` 를 쓰던 자리다. 모바일에서 화면을 덮는 것도 문제였지만,
   * 더 나쁜 건 **가진 것보다 큰 수를 넣으면 서버가 조용히 무시**한다는 것이었다
   * (`vaultMove` 가 `return`). 눌렀는데 아무 일도 안 일어나고 이유도 안 나온다.
   * 이제 칸 옆에 최대치가 보이고, 넘겨도 여기서 잘라 보낸다.
   */
  vaultSilver: (into, qty) => {
    const y = S.you; if (!y) return;
    const max = into ? y.silver : ((S.vault && S.vault.silver) || 0);
    const el = $('#vsilver');
    const want = qty === -1 ? max : parseInt((el && el.value) || '0', 10);
    const n = Math.max(0, Math.min(max, Number.isFinite(want) ? want : 0));
    if (n <= 0) return;
    if (el) el.value = '';
    send({ t: into ? 'vault' : 'unvault', what: 'silver', qty: n });
  },
  // ── 파티 (UNI-Q129) — 판정은 서버, 화면은 요청만 보낸다 ──
  partyInvite: (id) => send({ t: 'partyInvite', id }),
  partyInviteName: () => { const name = $('#partyname')?.value?.trim(); if (name) send({ t: 'partyInvite', name }); },
  partyAccept: (id) => send({ t: 'partyAccept', id }),
  partyDecline: () => send({ t: 'partyDecline' }),
  partyLeave: () => send({ t: 'partyLeave' }),
  partyKick: (id) => send({ t: 'partyKick', id }),
  /**
   * R227 ① — 이름표 카드의 [귓말]. 채팅칸을 `/w 이름 ` 으로 채워 연다(R230 귓말 — 보내지는 않는다, 할 말을 이어 쓰고 Enter).
   * 카드를 닫아 입력창이 가리지 않게 한다.
   */
  personWhisper: (id) => {
    const p = S.players.find((o) => o.id === id);
    if (!p || typeof chat.openChatWith !== 'function') return;
    closePanel();
    chat.openChatWith(`/w ${p.n} `);
  },
  /** 묶음 V — 이름표 카드의 [차단]. `/block 이름` 을 보낸다(서버가 저장하고 결과를 말한다 — 푸는 법도 거기 있다). */
  personBlock: (id) => {
    const p = S.players.find((o) => o.id === id);
    if (!p) return;
    closePanel();
    send({ t: 'chat', text: `/block ${p.n}` });
  },
  // ── 거래 (14.43) ──
  tradeAsk: (id) => send({ t: 'tradeAsk', id }),
  tradeAccept: (id) => { S.tradeAsk = null; send({ t: 'tradeAccept', id }); },
  tradeDeny: () => { S.tradeAsk = null; window.dispatchEvent(new CustomEvent('unige:trade')); },
  tradePut: (kind, key, n) => send({ t: 'tradePut', kind, key, n }),
  /** 드래그 중에는 숫자만 미리 보이고, 손을 놓은 change에서 서버에 한 번 보낸다. */
  tradePreview: (el) => {
    const card = el && el.closest('.trade-stack');
    const out = card && card.querySelector('output');
    const n = Math.max(0, Math.floor(Number(el?.value) || 0));
    const max = Math.max(0, Math.floor(Number(el?.max) || 0));
    if (out) out.textContent = `${n}/${max}`;
  },
  tradeRange: (el, kind, key) => {
    const max = Math.max(0, Math.floor(Number(el?.max) || 0));
    const n = Math.max(0, Math.min(max, Math.floor(Number(el?.value) || 0)));
    const mine = S.trade?.mine;
    const current = kind === 'junk' ? (mine?.junk?.[key] || 0) : (mine?.consum?.[key] || 0);
    if (n !== current) send({ t: 'tradePut', kind, key, n });
  },
  tradeOk: () => send({ t: 'tradeOk' }),
  tradeEnd: () => send({ t: 'tradeEnd' }),
  /** 은화는 칸에 적은 만큼. 0도 유효하며 서버가 실제 보유량으로 다시 자른다. */
  tradeSilver: () => {
    const el = $('#tsilver');
    const max = Math.max(0, Number(S.you?.silver) || 0);
    const n = Math.max(0, Math.min(max, parseInt((el && el.value) || '0', 10) || 0));
    if (el) el.value = String(n);
    if (n !== (S.trade?.mine?.silver || 0)) send({ t: 'tradePut', kind: 'silver', key: '', n });
  },
  vaultEquip: (id) => {
    const item = S.you?.inv?.equips?.find((e) => e.id === id);
    if (item?.guildBound != null) guildItemMove(item, 'in', render);
    else send({ t: 'vault', what: 'equip', id });
  },
  unvaultEquip: (id) => {
    const item = S.vault?.equips?.find((e) => e.id === id);
    if (item?.guildBound != null) guildItemMove(item, 'out', render);
    else send({ t: 'unvault', what: 'equip', id });
  },
  // 재화·잡템 입출고. 서버 `vaultMove` 가 원래부터 임의 키를 받고 있었는데
  // 이 자리가 없어서 강화석·축복받은 강화석을 창고에 못 넣었다.
  vaultJunk: (what, into, qty) =>
    send({ t: into ? 'vault' : 'unvault', what, qty: Math.max(1, Math.floor(qty)) }),
};
